/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 44);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(51);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(101);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(40)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-2-2!./App.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-2-2!./App.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export track */
/* unused harmony export trackLocal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackingWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gsntv__ = __webpack_require__(5);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var track=function track(analytics){var eventCategory=analytics.eventCategory,eventAction=analytics.eventAction,eventLabel=analytics.eventLabel,eventValue=analytics.eventValue;analytics&&window.gtag&&window.gtag("event",eventAction,{event_category:eventCategory,event_label:eventLabel,value:eventValue});};var trackLocal=function trackLocal(action,analytics){window.gtag&&window.gtag("event",action,analytics);};var trackingWrapper=function trackingWrapper(type,action,trackingObject){var event_category=trackingObject.event_category,event_label=trackingObject.event_label,label=trackingObject.label;var data=_defineProperty({action:action,label:label,category:event_category},"label",event_label);// trackGAToGSNTV(data);
trackLocal('Affiliate-'+action,trackingObject);};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(61)();
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loginToGSNTV */
/* unused harmony export logoutFromGSNTV */
/* unused harmony export highScoresFromGSNTV */
/* harmony export (immutable) */ __webpack_exports__["b"] = highScoresThisMonthFromGSNTV;
/* harmony export (immutable) */ __webpack_exports__["f"] = userDataFromGSNTV;
/* harmony export (immutable) */ __webpack_exports__["e"] = saveUserDataToGSNTV;
/* harmony export (immutable) */ __webpack_exports__["d"] = saveHighScoreToGSNTV;
/* unused harmony export trackGAToGSNTV */
/* unused harmony export trackKruxToGSNTV */
/* harmony export (immutable) */ __webpack_exports__["c"] = isIframed;
/* unused harmony export getSweepObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = gsntvIframeCommunicationInit;
/* unused harmony export gsntvCheckLogin */
/* unused harmony export gigyaResponseSuccess */
/* unused harmony export gigyaResponseFormClosed */
var CustomEvent=__webpack_require__(87);var NAMESPACE="[js/helpers/gsntv]";var GAME_ID=4;//temporary to pass syntax errors
function loginToGSNTV(){var gsntvLoginFromIFrame=window.parent.gsntvLoginFromIFrame;if(gsntvLoginFromIFrame){console.log(NAMESPACE,"loginToGSNTV");gsntvLoginFromIFrame();}}function logoutFromGSNTV(){var gsntvLogoutFromIFrame=window.parent.gsntvLogoutFromIFrame;if(gsntvLogoutFromIFrame){console.log(NAMESPACE,"logoutFromGSNTV");gsntvLogoutFromIFrame();}}/**
 * Get High Score
 */function highScoresFromGSNTV(){var gsntvGetHighScores=window.parent.gsntvGetHighScores;if(gsntvGetHighScores){console.log(NAMESPACE,"highScoresFromGSNTV");return gsntvGetHighScores(GAME_ID);// GAME_ID IS A GLOBAL.
}return Promise.resolve({scores:[]});}/**
 * Get High Scores This Month
 */function highScoresThisMonthFromGSNTV(){var gsntvGetHighScoresThisMonth=window.parent.gsntvGetHighScoresThisMonth;if(gsntvGetHighScoresThisMonth){console.log(NAMESPACE,"highScoresThisMonthFromGSNTV");return gsntvGetHighScoresThisMonth(GAME_ID);// GAME_ID IS A GLOBAL.
}return Promise.resolve({scores:[]});}/**
 * Get Game Data
 */function userDataFromGSNTV(){var gsntvGetUserData=window.parent.gsntvGetUserData;if(gsntvGetUserData){console.log(NAMESPACE,"gsntvGetUserData");return gsntvGetUserData(GAME_ID);}return Promise.resolve();}/**
 * Save Game Data
 * @param {string} data 
 */function saveUserDataToGSNTV(data){var gsntvSaveUserData=window.parent.gsntvSaveUserData;if(gsntvSaveUserData){console.log("gsntvSaveUserData");return gsntvSaveUserData(GAME_ID,data);}return Promise.resolve();}/**
 * Save High Score
 * @param {Object} data 
 * @param {string} data.name - displayed name
 * @param {integer} data.highScore - displayed score
 */function saveHighScoreToGSNTV(data){var gsntvSaveScore=window.parent.gsntvSaveScore;if(gsntvSaveScore){console.log("gsntvSaveScore");var name=data.name,highScore=data.highScore;return gsntvSaveScore(GAME_ID,name,highScore);}}function trackGAToGSNTV(data){var gsntvTrackGA=window.parent.gsntvTrackGA;console.log("tracking:",data);if(gsntvTrackGA){console.log("gsntvTrackGA");var category=data.category,action=data.action,label=data.label,value=data.value;return gsntvTrackGA(category,action,label,value);}}function trackKruxToGSNTV(data){var gsntvTrackKrux=window.parent.gsntvTrackKrux;if(gsntvTrackKrux){var id=data.id,eventParam=data.eventParam,dataDMP=data.dataDMP;return gsntvTrackKrux(id,eventParam,dataDMP);}}function isIframed(){return false;}function getSweepObject(){var hash=window.location.hash;switch(hash){case"#comcast":return{source:"comcast-america-quiz",img:"images/nestle-banner-2.jpeg",alt:"Nestle"};case"#other":return{source:"other-america-quiz",img:"images/nestle-banner.png",alt:"Nestle"};default:return{};}}function gsntvIframeCommunicationInit(store,actions){var userLogin=actions.userLogin,userLogout=actions.userLogout,setAppIframed=actions.setAppIframed;store.dispatch(setAppIframed());// create event for user login from parent
window.addEventListener("userlogin",function(event){return store.dispatch(userLogin(event));});// create event for user logout from parent
window.addEventListener("userlogout",function(){return store.dispatch(userLogout());});window.parentResize=function(width,height){console.log("parentResize",width,height);if(window.parent.gsntvFrameResize){console.log("gsntvFrameResize");window.parent.gsntvFrameResize(width,height);}};window.gsntvLoginFromParent=function(data){console.log("gsntvLoginFromParent",data);window.dispatchEvent(new CustomEvent("userlogin",{detail:data,bubbles:false,cancelable:false}));};window.gsntvLogoutFromParent=function(){console.log("gsntvLogoutFromParent");window.dispatchEvent(new CustomEvent("userlogout"));};window.gsntvUpdateMinHeight=function(minHeight){console.log("gsntvUpdateMinHeight");// var wrapper = document.getElementsByClassName("wrapper")[0];
// wrapper.style.minHeight = "calc(" + minHeight + " - 6.4rem)";
};}function gsntvCheckLogin(userLogin){if(window.parent&&window.parent.gsntvCheckLoginFromIFrame){window.parent.gsntvCheckLoginFromIFrame().then(function(data){console.log('gsntvCheckLogin',data);data&&data.UID&&userLogin({detail:data,appInitiatedLogin:true});});}}/**
 * Gigya Login/Registratoin Form Submission Response
 * @param {json} data
 */function gigyaResponseSuccess(data){return data.eventName==="afterSubmit"&&data.response&&data.response.errorCode===0;}function gigyaResponseFormClosed(data){return data.eventName==="hide"&&data.response&&data.response.errorCode===0;}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numberWithCommas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return facebookShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return twitterShare; });
var numberWithCommas=function numberWithCommas(num){return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",");};var facebookShare=function facebookShare(appId,shareImage,shareURL,shareMsg,shareRedirectURI){var url="https://www.facebook.com/dialog/feed";url+="?app_id="+appId;url+="&description="+encodeURIComponent(shareMsg);url+="&picture="+encodeURIComponent(shareImage);url+="&link="+encodeURIComponent(shareURL);url+="&redirect_uri="+encodeURIComponent(shareRedirectURI);url+="&display=popup";window.open(url,"_blank");};var twitterShare=function twitterShare(shareMsg,shareURL){var url="https://twitter.com/intent/tweet";url+="?text="+encodeURIComponent(shareMsg);url+="&url="+encodeURIComponent(shareURL);window.open(url,"_blank");};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_LOGIN", function() { return USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_LOGOUT", function() { return USER_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_IFRAMED", function() { return APP_IFRAMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MAX_SCORE", function() { return SET_MAX_SCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_AFFILIATE", function() { return SET_AFFILIATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userLogin", function() { return userLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userLogout", function() { return userLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAppIframed", function() { return setAppIframed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMaxScore", function() { return setMaxScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAffiliate", function() { return setAffiliate; });
var USER_LOGIN="USER_LOGIN";var USER_LOGOUT="USER_LOGOUT";var APP_IFRAMED="APP_IFRAMED";var SET_MAX_SCORE="SET_MAX_SCORE";var SET_AFFILIATE="SET_AFFILIATE";var userLogin=function userLogin(data){return{type:USER_LOGIN,data:data};};var userLogout=function userLogout(data){return{type:USER_LOGOUT,data:data};};var setAppIframed=function setAppIframed(){return{type:APP_IFRAMED};};var setMaxScore=function setMaxScore(){return{type:SET_MAX_SCORE};};var setAffiliate=function setAffiliate(data){return{type:SET_AFFILIATE,data:data};};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FooterLogo_scss__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FooterLogo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FooterLogo_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FooterLogo=function(_Component){_inherits(FooterLogo,_Component);function FooterLogo(props){_classCallCheck(this,FooterLogo);var _this=_possibleConstructorReturn(this,(FooterLogo.__proto__||Object.getPrototypeOf(FooterLogo)).call(this,props));_this.state={show:true};return _this;}_createClass(FooterLogo,[{key:'render',value:function render(){var cnLogo="f-logo-container"+(this.state.show?" show":"");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cnLogo},'Powered by ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-analytics-label':'DTC-footer-GSN-link',href:'https://www.gsntv.com',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'images/gsntv-logo.png',alt:'Game Show Network'})));}}]);return FooterLogo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FooterLogo);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REWARD_VIDEO_AD_BLOCKED; });
/* unused harmony export REWARD_VIDEO_NO_CAMPAIGN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REWARD_VIDEO_READY; });
/* unused harmony export REWARD_VIDEO_RESIZE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REWARD_VIDEO_OPEN; });
/* unused harmony export REWARD_VIDEO_CLOSE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REWARD_VIDEO_COMPLETION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REWARD_VIDEO_IRONSOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REWARD_VIDEO_SUPPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REWARD_VIDEO_STALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return rewardVideoAdBlocked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return rewardVideoReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return rewardVideoOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return rewardVideoComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setIronRV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setRewardVideoSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateRewardVideoStale; });
var REWARD_VIDEO_AD_BLOCKED="REWARD_VIDEO_AD_BLOCKED";var REWARD_VIDEO_NO_CAMPAIGN="REWARD_VIDEO_NO_CAMPAIGN";var REWARD_VIDEO_READY="REWARD_VIDEO_READY";var REWARD_VIDEO_RESIZE="REWARD_VIDEO_RESIZE";var REWARD_VIDEO_OPEN="REWARD_VIDEO_OPEN";var REWARD_VIDEO_CLOSE="REWARD_VIDEO_CLOSE";var REWARD_VIDEO_COMPLETION="REWARD_VIDEO_COMPLETION";var REWARD_VIDEO_IRONSOURCE="REWARD_VIDEO_IRONSOURCE";var REWARD_VIDEO_SUPPORT="REWARD_VIDEO_SUPPORT";var REWARD_VIDEO_STALE="REWARD_VIDEO_STALE";var rewardVideoAdBlocked=function rewardVideoAdBlocked(data){return{type:REWARD_VIDEO_AD_BLOCKED,data:data};};var rewardVideoReady=function rewardVideoReady(data){return{type:REWARD_VIDEO_READY,data:data};};var rewardVideoOpen=function rewardVideoOpen(data){return{type:REWARD_VIDEO_OPEN,data:data};};var rewardVideoComplete=function rewardVideoComplete(data){return{type:REWARD_VIDEO_COMPLETION,data:data};};var setIronRV=function setIronRV(data){return{type:REWARD_VIDEO_IRONSOURCE,data:data};};var setRewardVideoSupport=function setRewardVideoSupport(data){return{type:REWARD_VIDEO_SUPPORT,data:data};};var updateRewardVideoStale=function updateRewardVideoStale(data){return{type:REWARD_VIDEO_STALE,data:data};};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/game_bg3.ccac070e.jpg";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tt.96e17c74.png";

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LANDING_SCREEN */
/* unused harmony export UPLOAD_SCREEN */
/* unused harmony export NO_SUCCESS_MESSAGE */
/* unused harmony export NOIFRAME_SUCCESS_MESSAGE */
/* unused harmony export DEFAULT_SUCCESS_MESSAGE */
/* unused harmony export NO_ERROR_MESSAGE */
/* unused harmony export NO_ANSWER_ERROR_MESSAGE */
/* unused harmony export ALREADY_SUBMITTED_ERROR_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AD_MORE_TIME_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AD_REPLAY_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AD_FINAL_RESULTS; });
/* unused harmony export STATE_BEFORE_FINAL_RESULTS_SCREEN */
var LANDING_SCREEN="landing screen";var UPLOAD_SCREEN="upload screen";var NO_SUCCESS_MESSAGE="";var NOIFRAME_SUCCESS_MESSAGE="Thank you for playing! Come back tomorrow for a new question.";var DEFAULT_SUCCESS_MESSAGE="Your entry has been successfully submitted. "+NOIFRAME_SUCCESS_MESSAGE;var NO_ERROR_MESSAGE="";var NO_ANSWER_ERROR_MESSAGE="An answer was not selected.";var ALREADY_SUBMITTED_ERROR_MESSAGE="Your submission has already been entered.  Try again tomorrow.";var AD_MORE_TIME_CLICKED=1;var AD_REPLAY_CLICKED=2;var AD_FINAL_RESULTS=3;var STATE_BEFORE_FINAL_RESULTS_SCREEN=1;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(47);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createStore; });
/* unused harmony export combineReducers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindActionCreators; });
/* unused harmony export applyMiddleware */
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(69);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(27);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(12);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(74);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IronRV; });
/* harmony export (immutable) */ __webpack_exports__["c"] = initIronSource;
/* unused harmony export showRewardVideo */
/* unused harmony export hideOffer */
/* unused harmony export showOffer */
/* unused harmony export disableOffer */
/* harmony export (immutable) */ __webpack_exports__["b"] = adBlockerPopup;
var IronRV=window.IronRV;var TEXT_IRONSOURCE='Ironsource: ';function initIronSource(eventsArr){// CONFIGURATION
var params={applicationKey:"8c233aa5",applicationUserId:guid(),closeButtonShowTime:30};console.log('params',params);// INITIALIZE IRONSOURCE
var ironRV=IronRV.getInstance(params);// EVENT LISTENERS
initEventListeners(eventsArr,ironRV);return ironRV;}function initEventListeners(eventsArr,ironRV){eventsArr.forEach(function(evt){if(evt.callback!==undefined&&evt.callback!==null){console.log(TEXT_IRONSOURCE,evt);ironRV.addListener(evt.name,function(){console.log(TEXT_IRONSOURCE,evt.name);evt.callback({ironRV:ironRV,name:evt.name});});}});}// USER INTERFACE
function showRewardVideo(ironRV){console.log(TEXT_IRONSOURCE,"Opt-In call to action button Clicked");ironRV.show();disableOffer();}function hideOffer(){console.log(TEXT_IRONSOURCE,"Hide call to action button UI");}function showOffer(){console.log(TEXT_IRONSOURCE,"Show call to action button UI");}function disableOffer(){console.log(TEXT_IRONSOURCE,"Disable call to action button but keep it Shown in UI");}function adBlockerPopup(ironRV){ironRV.showAdBlockMessage();console.log(TEXT_IRONSOURCE,"Ad Blocker Detected");// hideOffer();
}function guid(){var nav=window.navigator;var screen=window.screen;var ga=document.cookie&&document.cookie.split(';').filter(function(val){return val.indexOf('_ga=')===0;});var gauid=ga.length===1?ga[0].split('=')[1]:'';var guid=nav.mimeTypes.length;guid+=nav.userAgent.replace(/\D+/g,'');guid+=nav.plugins.length;guid+=screen.height||'';guid+=screen.width||'';guid+=screen.pixelDepth||'';return gauid+guid;};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserRouter; });
/* unused harmony export HashRouter */
/* unused harmony export Link */
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(32);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(15);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.handleClick = function handleClick(event, history) {
    try {
      if (this.props.onClick) this.props.onClick(event);
    } catch (ex) {
      event.preventDefault();
      throw ex;
    }

    if (!event.defaultPrevented && // onClick prevented default
    event.button === 0 && ( // ignore everything but left clicks
    !this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        var method = this.props.replace ? history.replace : history.push;
        method(this.props.to);
      }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        replace = _this$props.replace,
        to = _this$props.to,
        rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["innerRef", "replace", "to"]); // eslint-disable-line no-unused-vars


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* __RouterContext */].Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, context.location) : to;
      var href = location ? context.history.createHref(location) : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        onClick: function onClick(event) {
          return _this.handleClick(event, context.history);
        },
        href: href,
        ref: innerRef
      }));
    });
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);
  var innerRefType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.propTypes = {
    innerRef: innerRefType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


function NavLink(_ref) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to"]);

  var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var pathToMatch = locationProp ? locationProp.pathname : context.location.pathname;
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* matchPath */])(pathToMatch, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, context.location) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, activeStyle) : styleProp;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: to
    }, rest));
  });
}

if (false) {
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}




/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* unused harmony export Redirect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Switch; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return matchPath; });
/* unused harmony export withRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mini_create_react_context__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_0_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_5_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context$$1.staticContext) return null;
    var method = context$$1.history.block;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context$$1.history,
        staticContext = context$$1.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_5_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string") options = {
    path: options
  };
  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path) return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      if (typeof children === "function") {
        children = children(props);

        if (children === undefined) {
          if (false) {
            var path = _this.props.path;
            process.env.NODE_ENV !== "production" ? warning(false, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
          }

          children = null;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
        value: props
      }, children && !isEmptyChildren(children) ? children : props.match ? component ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : render ? render(props) : null : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_5_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
     false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false);
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context$$1.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context$$1, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}




/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(15);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(98);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/AvenirNextLTPro-HeavyIt.05fdd987.eot";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/game_bg.f708d30e.jpg";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/game_bg_tall.bbeac46e.jpg";

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(118);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_buttons_Btn__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_gsntv__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import LoginBtn from "../components/buttons/LoginBtn";
// import LogoutBtn from "../components/buttons/LogoutBtn";
var AccAccessBtnContainer=function(_Component){_inherits(AccAccessBtnContainer,_Component);function AccAccessBtnContainer(){_classCallCheck(this,AccAccessBtnContainer);return _possibleConstructorReturn(this,(AccAccessBtnContainer.__proto__||Object.getPrototypeOf(AccAccessBtnContainer)).apply(this,arguments));}_createClass(AccAccessBtnContainer,[{key:"onClickHandler",value:function onClickHandler(){if(this.props.userLoggedIn){this.onLogoutClick();}else{this.onLoginClick();}}},{key:"onLoginClick",value:function onLoginClick(){window.parent&&window.parent.gsntvRegisterFromIFrame();}},{key:"onLogoutClick",value:function onLogoutClick(){window.parent&&window.parent.gsntvLogoutFromIFrame();}},{key:"componentDidMount",value:function componentDidMount(){//check user login on reload
// gsntvCheckLogin(this.props.userLogin);
}},{key:"render",value:function render(){var self=this;var _self$props=self.props,userLoggedIn=_self$props.userLoggedIn,btnRef=_self$props.btnRef,btnClassName=_self$props.btnClassName,btnLabel=_self$props.btnLabel;var label=btnLabel.login;var className=btnClassName.login;if(userLoggedIn){label=btnLabel.logout;className=btnClassName.logout;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_buttons_Btn__["a" /* default */],{label:label,onClick:this.onClickHandler.bind(this),btnRef:btnRef,btnClassName:className});// return !userLoggedIn ? (
//   <LoginBtn onLoginClick={this.onLoginClick.bind(this)} btnRef={btnRef.login} btnClassName={btnClassName.login}/>
// ) : (
//   <LogoutBtn onLogoutClick={this.onLogoutClick.bind(this)} btnRef={btnRef.logout} btnClassName={btnClassName.logout}/>
// );
}}]);return AccAccessBtnContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{userLoggedIn:state.userLoggedIn,isAppIframed:state.isAppIframed};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{userLogin:function userLogin(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_index__["userLogin"])(data));}};};AccAccessBtnContainer.propTypes={btnRef:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,btnClassName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AccAccessBtnContainer));

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scss_App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GamePage=function(_Component){_inherits(GamePage,_Component);function GamePage(props){_classCallCheck(this,GamePage);var _this=_possibleConstructorReturn(this,(GamePage.__proto__||Object.getPrototypeOf(GamePage)).call(this,props));_this.state={answer:"",defaultValue:"",currentValue:"",readOnly:false,altWords:[],bonusSet:null};_this.handleOnChange=_this.handleOnChange.bind(_this);_this.handleOnFocus=_this.handleOnFocus.bind(_this);_this.handleOnBlur=_this.handleOnBlur.bind(_this);_this.moveCursorToEnd=_this.moveCursorToEnd.bind(_this);_this.checkAnswer=_this.checkAnswer.bind(_this);return _this;}_createClass(GamePage,[{key:'componentDidMount',value:function componentDidMount(){//console.log("Field mounted");
this.setDefaultValue();this.setAltWords();this.setState({answer:this.props.answer.toUpperCase(),bonusSet:this.props.bonusSet});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// if reach end of field by typing
if(this.state.currentValue.length===this.state.answer.length){// force blur (which will then validate answer)
this.refs.field.blur();}// play reveal sound
//console.log("Field :: componentDidUpdate - this.props.showAnswers ", this.props.showAnswers);
//console.log("Field :: componentDidUpdate - prevProps.showAnswers ", prevProps.showAnswers);
if(this.props.showAnswers===true&&prevProps.showAnswers!==true){window.sounds.reveal.play();}// if parents "check answer" is different, check if matches alt list words
if(this.props.checkAnswer!==prevProps.checkAnswer&&this.state.readOnly===false){// only check answers from same set
if(this.state.bonusSet===this.props.currentSet){//console.log("Field :: componentDidUpdate - parent telling us to check answer");
this.checkAnswer(this.props.checkAnswer);}}}},{key:'setDefaultValue',value:function setDefaultValue(){var answer=this.props.answer.trim();// determine if is multi worded answer
if(answer.indexOf(" ")>-1){var wordArray=answer.split(" ");var blankedOutWords="";for(var i=0;i<wordArray.length;i++){blankedOutWords=blankedOutWords+" "+this.blankOutWord(wordArray[i]);}this.setState({defaultValue:blankedOutWords.trim(),currentValue:blankedOutWords.trim()});}else{this.setState({defaultValue:this.blankOutWord(answer),currentValue:this.blankOutWord(answer)});}}},{key:'blankOutWord',value:function blankOutWord(word){var blankedOutWord=word.charAt(0).toUpperCase();for(var i=1;i<word.length;i++){blankedOutWord+="_";}return blankedOutWord;}},{key:'setAltWords',value:function setAltWords(){var answer=this.props.answer.toUpperCase();var altWordList=window.alternateWords[answer];if(altWordList){this.setState({altWords:[].concat(_toConsumableArray(altWordList))});}}},{key:'handleOnChange',value:function handleOnChange(e){//console.log("handleOnChange  e:", e.target.value);
//console.log("handleOnChange  e.length:", e.target.value.length);
var nextValue=e.target.value.toUpperCase();// if first letter is typed in 2nd position, ignore it
if(e.target.value.length===2){if(nextValue.charAt(0)===nextValue.charAt(1)){nextValue=nextValue.charAt(0);}}/*
		// check if match alt words
		const isAltWord = this.isAltWord(nextValue);

		if(isAltWord !== false){
			//console.log("===== handle success");
			nextValue = isAltWord;

			//this.showCorrectAnswerCue();
			//this.props.handleFieldIsFocused(false);

			this.setState({
				currentValue : this.state.answer,
				readOnly : true
			});
		}
		else {
			this.setState({
				currentValue : nextValue
			});
		}
		*/this.setState({currentValue:nextValue});// update parent so that it can check all fields
this.props.updateAnswerHandler(nextValue);}},{key:'checkAnswer',value:function checkAnswer(answer){//console.log("Field :: checkAnswer");
// check answers from other fields if not already answered
if(this.state.readOnly===false){//console.log("Field :: checkAnswer - not readOnly ======");
// check if match alt words
var isAltWord=this.isAltWord(answer);//console.log("Field :: checkAnswer - isAltWord : ", isAltWord);
if(isAltWord!==false){//console.log("===== handle success");
answer=isAltWord;//this.showCorrectAnswerCue();
//this.props.handleFieldIsFocused(false);
this.setState({currentValue:this.state.answer});this.showCorrectAnswerCue();}else if(answer===this.state.answer){//console.log("===== handle success 2");
this.setState({currentValue:this.state.answer});this.showCorrectAnswerCue();}}}},{key:'isAltWord',value:function isAltWord(word){//console.log("this.state.altWords", this.state.altWords);
for(var i=0;i<this.state.altWords.length;i++){if(this.state.altWords[i].toUpperCase()===word){//console.log("Field :: isAltWord - YES word: ", word);
return word;}else{//console.log("Field :: isAltWord - no word: ", word);
}}return false;}},{key:'handleOnFocus',value:function handleOnFocus(){//console.log("Field :: handleOnFocus");
this.setState({currentValue:this.props.answer.charAt(0).toUpperCase()});this.props.handleFieldIsFocused(true);this.moveCursorToEnd(this.refs.field);}},{key:'moveCursorToEnd',value:function moveCursorToEnd(el){//console.log("Field :: moveCursorToEnd");
setTimeout(function(){if(typeof el.selectionStart==="number"){//console.log("Field :: moveCursorToEnd a");
el.selectionStart=el.selectionEnd=el.value.length;}else if(typeof el.createTextRange!=="undefined"){//console.log("Field :: moveCursorToEnd b");
el.focus();var range=el.createTextRange();range.collapse(false);range.select();}},10);}},{key:'handleOnBlur',value:function handleOnBlur(){//console.log("Field :: handleOnBlur   currentValue: " + this.state.currentValue + "    answer: " + this.state.answer);
if(this.props.revealingAnswersMode===false){if(this.state.currentValue===this.state.answer.charAt(0)){console.log("Field :: handleOnBlur - is default value, restore default");this.setState({currentValue:this.state.defaultValue});}else if(this.state.currentValue===this.state.answer){console.log("Field :: handleOnBlur - state.currentValue === state.answer - correct answer should have been caught already");//this.showCorrectAnswerCue();	
}else if(this.state.currentValue.length===this.state.answer.length){console.log("Field :: handleOnBlur - has reached end length and is not correct");this.showWrongAnswerCue();}else{console.log("Field :: handleOnBlur - else restore default and error cue");this.setState({currentValue:this.state.defaultValue});this.showWrongAnswerCue();}}this.props.handleFieldIsFocused(false);}},{key:'showWrongAnswerCue',value:function showWrongAnswerCue(){//console.log("WRONG ANSWER!");
this.setState({currentValue:this.state.defaultValue});this.props.handleWrongAnswer();window.sounds.wrong.play();}},{key:'showCorrectAnswerCue',value:function showCorrectAnswerCue(){//console.log("CORRECT ANSWER!");
this.setState({readOnly:true});this.props.handleCorrectAnswer();window.sounds.correct.play();}},{key:'render',value:function render(){var _this2=this;//console.log("Field :: render currentValue", this.state.currentValue);
var readOnly=this.state.readOnly?" readOnly":"";var value=this.props.showAnswers?this.state.answer:this.state.currentValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'field_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:"field"+readOnly,type:'text',maxLength:this.props.answer.length,size:this.props.answer.length+5,value:value,ref:'field',onChange:this.handleOnChange,onFocus:this.handleOnFocus,onBlur:this.handleOnBlur,onMouseUp:function onMouseUp(){return _this2.moveCursorToEnd(_this2.refs.field);}}));}}]);return GamePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GamePage);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_analytics__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GiveUpBtn=function(_Component){_inherits(GiveUpBtn,_Component);function GiveUpBtn(props){_classCallCheck(this,GiveUpBtn);var _this=_possibleConstructorReturn(this,(GiveUpBtn.__proto__||Object.getPrototypeOf(GiveUpBtn)).call(this,props));_this.state={expanded:false,closeOut:false};_this.handleGiveUpClick=_this.handleGiveUpClick.bind(_this);_this.handleNoClick=_this.handleNoClick.bind(_this);_this.handleYesClick=_this.handleYesClick.bind(_this);return _this;}_createClass(GiveUpBtn,[{key:'componentDidMount',value:function componentDidMount(){//console.log("GiveUpBtn :: componentDidMount");
}},{key:'handleGiveUpClick',value:function handleGiveUpClick(){this.setState({expanded:true});}},{key:'handleNoClick',value:function handleNoClick(){this.setState({expanded:false});}},{key:'handleYesClick',value:function handleYesClick(){// tracking
Object(__WEBPACK_IMPORTED_MODULE_2__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-answer-reveal',{'event_category':'america-says-game'});this.setState({closeOut:true});this.props.handleGiveUp();}},{key:'render',value:function render(){var _this2=this;var expanded=this.state.expanded?" expand":"";var show=this.props.show&&!this.state.closeOut?" show":"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"giveUpBtn"+expanded+show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'yesBtn',onClick:this.handleYesClick,onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},'YES'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'noBtn',onClick:function onClick(){return _this2.handleNoClick();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},'NO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'confirmLabel'},'SURE?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'giveUpLabel',onClick:function onClick(){return _this2.handleGiveUpClick();}},'REVEAL?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning'},'(this will end the round & reveal all remaining answers)'));}}]);return GiveUpBtn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GiveUpBtn);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(45);
module.exports = __webpack_require__(50);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(46).enable();
  window.Promise = __webpack_require__(48);
}

// fetch() polyfill for making API calls.
__webpack_require__(49);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(11);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(19);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(19);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AppContainer__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_gsntv__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(30);
//==============================================
window.config=null;window.questions=null;// initial list, used to reset pool
window.bonusQuestions=null;// initial list, used to reset pool
window.alternateWords=null;window.questionsPool=null;// randomize questions from this list
window.bonusQuestionsPool=null;// randomize questions from this list
// ---- sounds ------
window.sounds={};window.sounds.introBg=new window.Howl({src:['media/GM-AP_America_Building_r1_FULL.mp3'],volume:1});window.sounds.roundBg=new window.Howl({src:['media/America_Building_Full_mixdown.mp3'],volume:1,loop:true});window.sounds.bonusBg=new window.Howl({src:['media/America_Building_R2_Full_mixdown.mp3'],volume:1,loop:true});window.sounds.gameOverBg=new window.Howl({src:['media/GM_America_Says_Theme_2_END_CREDITS_14SEC.mp3'],volume:1});window.sounds.correct=new window.Howl({src:['media/Correct_Answer_2.mp3'],volume:1});window.sounds.wrong=new window.Howl({src:['media/Wrong_Answer_1_ALT_2.mp3'],volume:1});window.sounds.reveal=new window.Howl({src:['media/91926__tim-kahn__ding.mp3'],volume:1});window.sounds.buttonHover=new window.Howl({src:['media/little_robot_sound_factory_multimedia_Click_Electronic_05.mp3'],volume:1});window.sounds.buttonClick=new window.Howl({src:['media/multimedia_rollover_078.mp3'],volume:1});window.sounds.startButtonClick=new window.Howl({src:['media/btn_click.mp3'],volume:1});window.sounds.timerRunningOut=new window.Howl({src:['media/multimedia_rollover_077.mp3'],volume:1});window.sounds.buzzer=new window.Howl({src:['media/times_up_5.mp3'],volume:1,sprite:{buzzer:[0,2000]}});// ---- toggle sounds when leaving / re-entering site
window.$(window).bind("blur",function(){window.Howler.volume(0);});window.$(window).bind("focus",function(){window.Howler.volume(1);});//window.Howler.volume(.1);
//==============================================
var store=Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* createStore */])(__WEBPACK_IMPORTED_MODULE_4__reducers__["a" /* default */],window.__REDUX_DEVTOOLS_EXTENSION__&&window.__REDUX_DEVTOOLS_EXTENSION__());Object(__WEBPACK_IMPORTED_MODULE_8__utils_gsntv__["a" /* gsntvIframeCommunicationInit */])(store,__WEBPACK_IMPORTED_MODULE_5__actions__);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Route */],{path:'/:affiliate',render:function render(_ref){var match=_ref.match,props=_ref.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AppContainer__["a" /* default */],Object.assign({},props,{match:match}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Route */],{path:'/',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AppContainer__["a" /* default */],props);}})))),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_7__registerServiceWorker__["a" /* unregister */])();

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(11),n=__webpack_require__(20),p=__webpack_require__(21),q=__webpack_require__(22),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(53);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(20),ba=__webpack_require__(0),m=__webpack_require__(54),p=__webpack_require__(11),v=__webpack_require__(22),da=__webpack_require__(55),ea=__webpack_require__(56),fa=__webpack_require__(57),ha=__webpack_require__(21);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},zc={};function Ac(a){if(zc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return zc[a]=!0;xc[a]=!0;return!1}
function Bc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Cc(a,b,c,d){if(null===b||"undefined"===typeof b||Bc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Dc=/[\-:]([a-z])/g;function Ec(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Dc,
Ec);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Fc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Cc(b,c,e,d)&&(c=null),d||null===e?Ac(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Gc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Hc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ic(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Jc(a,b){b=b.checked;null!=b&&Fc(a,"checked",b,!1)}
function Kc(a,b){Jc(a,b);var c=Ic(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Lc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Lc(a,b.type,Ic(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Mc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Lc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Ic(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Nc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Oc(a,b,c){a=H.getPooled(Nc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Pc=null,Qc=null;function Rc(a){Ia(a,!1)}function Sc(a){var b=Oa(a);if(dc(b))return a}
function Tc(a,b){if("change"===a)return b}var Uc=!1;m.canUseDOM&&(Uc=$b("input")&&(!document.documentMode||9<document.documentMode));function Vc(){Pc&&(Pc.detachEvent("onpropertychange",Wc),Qc=Pc=null)}function Wc(a){"value"===a.propertyName&&Sc(Qc)&&(a=Oc(Qc,a,Zb(a)),Wb(Rc,a))}function Xc(a,b,c){"focus"===a?(Vc(),Pc=b,Qc=c,Pc.attachEvent("onpropertychange",Wc)):"blur"===a&&Vc()}function Yc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Sc(Qc)}
function Zc(a,b){if("click"===a)return Sc(b)}function $c(a,b){if("input"===a||"change"===a)return Sc(b)}
var ad={eventTypes:Nc,_isInputEventSupported:Uc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Tc:Yb(e)?Uc?f=$c:(f=Yc,g=Xc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Zc);if(f&&(f=f(a,b)))return Oc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Lc(e,"number",e.value)}},bd=H.extend({view:null,detail:null}),cd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}
var fd=bd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),gd=fd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),hd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},id={eventTypes:hd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=fd,h=hd.mouseLeave,k=hd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=gd,h=hd.pointerLeave,k=hd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function kd(a){2!==jd(a)?A("188"):void 0}
function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function nd(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var od=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=bd.extend({relatedTarget:null});
function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=bd.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=fd.extend({dataTransfer:null}),wd=bd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),xd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=fd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=fd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case fb:case gb:case hb:a=od;break;case ib:a=xd;break;case "scroll":a=bd;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=gd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Hd=!0;function Id(a){Hd=!!a}function K(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!1)}
function Md(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!0)}function Kd(a,b){Tb(Ld,a,b)}function Ld(a,b){if(Hd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}
var Nd={get _enabled(){return Hd},setEnabled:Id,isEnabled:function(){return Hd},trapBubbledEvent:K,trapCapturedEvent:Md,dispatchEvent:Ld},Od={},Pd=0,Qd="_reactListenersID"+(""+Math.random()).slice(2);function Rd(a){Object.prototype.hasOwnProperty.call(a,Qd)||(a[Qd]=Pd++,Od[a[Qd]]={});return Od[a[Qd]]}function Sd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Td(a,b){var c=Sd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Sd(c)}}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){if($d||null==Xd||Xd!==da())return null;var c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Zd&&ea(Zd,c)?null:(Zd=c,a=H.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ya(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Rd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:id,ChangeEventPlugin:ad,SelectEventPlugin:be,BeforeInputEventPlugin:Ib});
var ce="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,de=Date,ee=setTimeout,fe=clearTimeout,ge=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var he=performance;ge=function(){return he.now()}}else ge=function(){return de.now()};var ie=void 0,je=void 0;
if(m.canUseDOM){var ke="function"===typeof ce?ce:function(){A("276")},L=null,le=null,me=-1,ne=!1,oe=!1,pe=0,qe=33,re=33,se={didTimeout:!1,timeRemaining:function(){var a=pe-ge();return 0<a?a:0}},ue=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{je(a),d||(ne=!0,window.postMessage(te,"*"))}},te="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===te&&(ne=!1,null!==L)){if(null!==L){var b=ge();if(!(-1===
me||me>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(se.didTimeout=!0,b=0,d=c.length;b<d;b++)ue(c[b],se);me=a}}for(a=ge();0<pe-a&&null!==L;)a=L,se.didTimeout=!1,ue(a,se),a=ge();null===L||oe||(oe=!0,ke(ve))}},!1);var ve=function(a){oe=!1;var b=a-pe+re;b<re&&qe<re?(8>b&&(b=8),re=b<qe?qe:b):qe=b;pe=a+re;ne||(ne=!0,window.postMessage(te,"*"))};ie=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=ge()+
b.timeout);if(-1===me||-1!==c&&c<me)me=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=le,null!==b&&(b.next=a));le=a;oe||(oe=!0,ke(ve));return a};je=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,le=c):le=L=null}}}else{var we=new Map;ie=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=ee(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});we.set(a,c);return b};je=function(a){var b=we.get(a.scheduledCallback);we.delete(a);fe(b)}}function xe(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ye(a,b){a=p({children:void 0},b);if(b=xe(b.children))a.children=b;return a}
function ze(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ae(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Be(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function De(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function He(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ie=void 0,Je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Fe.svg||"innerHTML"in a)a.innerHTML=b;else{Ie=Ie||document.createElement("div");Ie.innerHTML="<svg>"+b+"</svg>";for(b=Ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Me=["Webkit","ms","Moz","O"];Object.keys(Le).forEach(function(a){Me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Le[b]=Le[a]})});
function Ne(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Le.hasOwnProperty(e)&&Le[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Oe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Pe(a,b,c){b&&(Oe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Qe(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Re=v.thatReturns("");
function Se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Rd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Md("scroll",a);break;case "focus":case "blur":Md("focus",a);Md("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Md(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Te(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Fe.html&&(d=Ge(a));d===Fe.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ue(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Ve(a,b,c,d){var e=Qe(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Hc(a,c);f=Gc(a,c);K("invalid",a);Se(d,"onChange");break;case "option":f=ye(a,c);break;case "select":Ae(a,c);f=p({},c,{value:void 0});
K("invalid",a);Se(d,"onChange");break;case "textarea":Ce(a,c);f=Be(a,c);K("invalid",a);Se(d,"onChange");break;default:f=c}Pe(b,f,Re);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Ne(a,k,Re):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Je(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ke(a,k):"number"===typeof k&&Ke(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Se(d,
h):null!=k&&Fc(a,h,k,e))}switch(b){case "input":cc(a);Mc(a,c,!1);break;case "textarea":cc(a);Ee(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ze(a,!!c.multiple,b,!1):null!=c.defaultValue&&ze(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function We(a,b,c,d,e){var f=null;switch(b){case "input":c=Gc(a,c);d=Gc(a,d);f=[];break;case "option":c=ye(a,c);d=ye(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Be(a,c);d=Be(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Pe(b,d,Re);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Se(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Xe(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Jc(a,e);Qe(c,d);d=Qe(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Ne(a,h,Re):"dangerouslySetInnerHTML"===g?Je(a,h):"children"===g?Ke(a,h):Fc(a,g,h,d)}switch(c){case "input":Kc(a,e);break;case "textarea":De(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ze(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ze(a,!!e.multiple,e.defaultValue,!0):ze(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ye(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Hc(a,c);K("invalid",a);Se(e,"onChange");break;case "select":Ae(a,c);K("invalid",a);Se(e,"onChange");break;case "textarea":Ce(a,c),K("invalid",a),Se(e,"onChange")}Pe(b,
c,Re);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Se(e,f)}switch(b){case "input":cc(a);Mc(a,c,!0);break;case "textarea":cc(a);Ee(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ze(a,b){return a.nodeValue!==b}
var $e={createElement:Te,createTextNode:Ue,setInitialProperties:Ve,diffProperties:We,updateProperties:Xe,diffHydratedProperties:Ye,diffHydratedText:Ze,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Kc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Kc(d,e)}}}break;case "textarea":De(a,c);break;case "select":b=c.value,null!=b&&ze(a,!!c.multiple,b,!1)}}},af=null,bf=null;function cf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function df(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ef=ge,ff=ie,gf=je;function hf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function jf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var kf=[],lf=-1;function mf(a){return{current:a}}
function M(a){0>lf||(a.current=kf[lf],kf[lf]=null,lf--)}function N(a,b){lf++;kf[lf]=a.current;a.current=b}var nf=mf(ha),O=mf(!1),of=ha;function pf(a){return qf(a)?of:nf.current}
function rf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function qf(a){return 2===a.tag&&null!=a.type.childContextTypes}function sf(a){qf(a)&&(M(O,a),M(nf,a))}function tf(a){M(O,a);M(nf,a)}
function uf(a,b,c){nf.current!==ha?A("168"):void 0;N(nf,b,a);N(O,c,a)}function vf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function wf(a){if(!qf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;of=nf.current;N(nf,b,a);N(O,O.current,a);return!0}
function xf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=vf(a,of);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(nf,a);N(nf,d,a)}else M(O,a);N(O,b,a)}
function yf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function zf(a,b,c){var d=a.alternate;null===d?(d=new yf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Af(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Bf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new yf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new yf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Bf(a,b,c,d){a=new yf(10,a,d,b);a.expirationTime=c;return a}function Cf(a,b,c){a=new yf(6,a,null,b);a.expirationTime=c;return a}function Df(a,b,c){b=new yf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ef(a,b,c){b=new yf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Ff=null,Gf=null;function Hf(a){return function(b){try{return a(b)}catch(c){}}}
function If(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ff=Hf(function(a){return b.onCommitFiberRoot(c,a)});Gf=Hf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Jf(a){"function"===typeof Ff&&Ff(a)}function Kf(a){"function"===typeof Gf&&Gf(a)}var Lf=!1;
function Mf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Nf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Of(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Qf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Mf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Mf(a.memoizedState),f=d.updateQueue=Mf(d.memoizedState)):e=a.updateQueue=Nf(f):null===f&&(f=d.updateQueue=Nf(e));null===f||e===f?Pf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Pf(e,b,c),Pf(f,b,c)):(Pf(e,b,c),f.lastUpdate=b)}
function Rf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Mf(a.memoizedState):Sf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Sf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Nf(b));return b}
function Tf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Lf=!0}return d}
function Uf(a,b,c,d,e){Lf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Sf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Vf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Wf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Vf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Vf(b,c)),a=a.nextEffect}
function Xf(a,b){return{value:a,source:b,stack:vc(b)}}var Yf=mf(null),Zf=mf(null),$f=mf(0);function ag(a){var b=a.type._context;N($f,b._changedBits,a);N(Zf,b._currentValue,a);N(Yf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function bg(a){var b=$f.current,c=Zf.current;M(Yf,a);M(Zf,a);M($f,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var cg={},dg=mf(cg),eg=mf(cg),fg=mf(cg);function gg(a){a===cg?A("174"):void 0;return a}
function ig(a,b){N(fg,b,a);N(eg,a,a);N(dg,cg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:He(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=He(b,c)}M(dg,a);N(dg,b,a)}function jg(a){M(dg,a);M(eg,a);M(fg,a)}function kg(a){eg.current===a&&(M(dg,a),M(eg,a))}function lg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var pg={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=mg();c=ng(c,a);var d=Of(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Qf(a,d,c);og(a,c)}};function qg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function rg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&pg.enqueueReplaceState(b,b.state,null)}
function sg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=pf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=rf(a,f);f=a.updateQueue;null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(lg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&pg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var tg=Array.isArray;
function ug(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function vg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function wg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=zf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=ug(a,b,c),d.return=a,d;d=Af(c,a.mode,d);d.ref=ug(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Bf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Af(b,a.mode,c),c.ref=ug(a,null,b),c.return=a,c;case hc:return b=Df(b,a.mode,c),b.return=a,b}if(tg(b)||tc(b))return b=Bf(b,a.mode,c,null),b.return=
a,b;vg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(tg(c)||tc(c))return null!==e?null:r(a,b,c,d,null);vg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(tg(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);vg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=ug(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Bf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Af(f,a.mode,h),h.ref=ug(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Cf(f,a.mode,h),d.return=a,a=d),g(a);if(tg(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&vg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var xg=wg(!0),yg=wg(!1),zg=null,Ag=null,Bg=!1;function Cg(a,b){var c=new yf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Dg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Eg(a){if(Bg){var b=Ag;if(b){var c=b;if(!Dg(a,b)){b=hf(c);if(!b||!Dg(a,b)){a.effectTag|=2;Bg=!1;zg=a;return}Cg(zg,c)}zg=a;Ag=jf(b)}else a.effectTag|=2,Bg=!1,zg=a}}
function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;zg=a}function Gg(a){if(a!==zg)return!1;if(!Bg)return Fg(a),Bg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!df(b,a.memoizedProps))for(b=Ag;b;)Cg(a,b),b=hf(b);Fg(a);Ag=zg?hf(a.stateNode):null;return!0}function Hg(){Ag=zg=null;Bg=!1}function Q(a,b,c){Ig(a,b,c,b.expirationTime)}function Ig(a,b,c,d){b.child=null===a?yg(b,null,c,d):xg(b,a.child,c,d)}
function Jg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Kg(a,b,c,d,e){Jg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&xf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Ig(a,b,null,e),b.child=null);Ig(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&xf(b,!0);return b.child}
function Lg(a){var b=a.stateNode;b.pendingContext?uf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&uf(a,b.context,!1);ig(a,b.containerInfo)}
function Mg(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Qg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,ag(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b)}else Mg(b,d,h,c)}b.stateNode=h;ag(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=zf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Rg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Lg(b);break;case 2:wf(b);break;case 4:ig(b,b.stateNode.containerInfo);break;case 13:ag(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=pf(b);f=rf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&lg(b,f,e),e=wf(b),d.updater=pg,b.stateNode=d,d._reactInternalFiber=b,sg(b,c),a=Kg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=pf(b),d=rf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=wf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=pf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?rf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=pg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);sg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=pf(b);g=rf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&rg(b,d,f,g);Lf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Uf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Lf?("function"===typeof r&&(lg(b,r,f),n=b.memoizedState),(k=Lf||qg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=pf(b),g=rf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&rg(b,d,k,g),Lf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Uf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Lf?("function"===typeof r&&(lg(b,r,k),w=b.memoizedState),(r=Lf||qg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Kg(a,b,d,e,c);case 3:Lg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Uf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Hg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Ag=jf(b.stateNode.containerInfo),zg=b,d=Bg=!0;d?(b.effectTag|=2,b.child=yg(b,null,e,c)):(Hg(),Q(a,b,e));a=b.child}else Hg(),a=R(a,b);return a;case 5:a:{gg(fg.current);e=gg(dg.current);d=He(e,
b.type);e!==d&&(N(eg,b,b),N(dg,d,b));null===a&&Eg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;df(e,d)?k=null:f&&df(e,f)&&(b.effectTag|=16);Jg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Eg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return ig(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=xg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Qg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Mg(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Sg(a){a.effectTag|=4}var Tg=void 0,Ug=void 0,Vg=void 0;Tg=function(){};Ug=function(a,b,c){(b.updateQueue=c)&&Sg(b)};Vg=function(a,b,c,d){c!==d&&Sg(b)};
function Wg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return sf(b),null;case 3:jg(b);tf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b),b.effectTag&=-3;Tg(b);return null;case 5:kg(b);d=gg(fg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=gg(dg.current);g=We(g,e,f,c,d);Ug(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=gg(dg.current);if(Gg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ye(c,e,f,a,d),b.updateQueue=d,null!==d&&Sg(b);else{a=Te(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Ve(a,e,c,d);cf(e,c)&&Sg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Vg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=gg(fg.current);gg(dg.current);Gg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ze(d,c)&&Sg(b)):(d=Ue(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return jg(b),Tg(b),null;case 13:return bg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Xg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Yg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Zg(a,c)}else b.current=null}
function $g(a){"function"===typeof Kf&&Kf(a);switch(a.tag){case 2:Yg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Zg(a,c)}break;case 5:Yg(a);break;case 4:ah(a)}}function bh(a){return 5===a.tag||3===a.tag||4===a.tag}
function ch(a){a:{for(var b=a.return;null!==b;){if(bh(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||bh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ah(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if($g(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:$g(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function dh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Xe(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function eh(a,b,c){c=Of(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){fh(d);Xg(a,b)};return c}
function gh(a,b,c){c=Of(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===hh?hh=new Set([this]):hh.add(this);var c=b.value,d=b.stack;Xg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function ih(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Xf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=eh(a,d,f);Rf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===hh||!hh.has(c))){a.effectTag|=1024;d=gh(a,b,f);Rf(a,d,f);return}}a=a.return}while(null!==a)}
function jh(a){switch(a.tag){case 2:sf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return jg(a),tf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return kg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return jg(a),null;case 13:return bg(a),null;default:return null}}var kh=ef(),lh=2,mh=kh,nh=0,oh=0,ph=!1,S=null,qh=null,T=0,rh=-1,sh=!1,U=null,th=!1,uh=!1,hh=null;
function vh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:sf(b);break;case 3:jg(b);tf(b);break;case 5:kg(b);break;case 4:jg(b);break;case 13:bg(b)}a=a.return}qh=null;T=0;rh=-1;sh=!1;S=null;uh=!1}
function wh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Wg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{uh=!0;break}}else{a=jh(a,sh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function xh(a){var b=Rg(a.alternate,a,T);null===b&&(b=wh(a));ec.current=null;return b}
function yh(a,b,c){ph?A("243"):void 0;ph=!0;if(b!==T||a!==qh||null===S)vh(),qh=a,T=b,rh=-1,S=zf(qh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;sh=!c||T<=lh;do{try{if(c)for(;null!==S&&!zh();)S=xh(S);else for(;null!==S;)S=xh(S)}catch(f){if(null===S)d=!0,fh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;fh(f);break}ih(a,e,c,f,sh,T,mh);S=wh(c)}}break}while(1);ph=!1;if(d)return null;if(null===S){if(uh)return a.pendingCommitExpirationTime=b,a.current.alternate;sh?A("262"):
void 0;0<=rh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Ah(a,b)},rh);Bh(a.current.expirationTime)}return null}
function Zg(a,b){var c;a:{ph&&!th?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===hh||!hh.has(d))){a=Xf(b,a);a=gh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}break;case 3:a=Xf(b,a);a=eh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Xf(b,a),c=eh(a,c,1),Qf(a,c,1),og(a,1));c=void 0}return c}
function Ch(){var a=2+25*(((mg()-2+500)/25|0)+1);a<=nh&&(a=nh+1);return nh=a}function ng(a,b){a=0!==oh?oh:ph?th?1:T:b.mode&1?Dh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Dh&&(0===Eh||a>Eh)&&(Eh=a);return a}
function og(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!ph&&0!==T&&b<T&&vh();var d=c.current.expirationTime;ph&&!th&&qh===c||Ah(c,d);Fh>Gh&&A("185")}else break;a=a.return}}function mg(){mh=ef()-kh;return lh=(mh/10|0)+2}
function Hh(a){var b=oh;oh=2+25*(((mg()-2+500)/25|0)+1);try{return a()}finally{oh=b}}function Ih(a,b,c,d,e){var f=oh;oh=1;try{return a(b,c,d,e)}finally{oh=f}}var Jh=null,V=null,Kh=0,Lh=void 0,W=!1,X=null,Y=0,Eh=0,Mh=!1,Nh=!1,Oh=null,Ph=null,Z=!1,Qh=!1,Dh=!1,Rh=null,Gh=1E3,Fh=0,Sh=1;function Th(a){if(0!==Kh){if(a>Kh)return;null!==Lh&&gf(Lh)}var b=ef()-kh;Kh=a;Lh=ff(Uh,{timeout:10*(a-2)-b})}
function Ah(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Jh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Jh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Qh&&(X=a,Y=1,Vh(a,1,!1)):1===b?Wh():Th(b))}
function Xh(){var a=0,b=null;if(null!==V)for(var c=V,d=Jh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Jh=V=d.nextScheduledRoot=null;break}else if(d===Jh)Jh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Jh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Fh++:Fh=0;X=b;Y=a}function Uh(a){Yh(0,!0,a)}function Wh(){Yh(1,!1,null)}function Yh(a,b,c){Ph=c;Xh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Mh||mg()>=Y);)mg(),Vh(X,Y,!Mh),Xh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Vh(X,Y,!1),Xh();null!==Ph&&(Kh=0,Lh=null);0!==Y&&Th(Y);Ph=null;Mh=!1;Zh()}function $h(a,b){W?A("253"):void 0;X=a;Y=b;Vh(a,b,!1);Wh();Zh()}
function Zh(){Fh=0;if(null!==Rh){var a=Rh;Rh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Nh||(Nh=!0,Oh=d)}}}if(Nh)throw a=Oh,Oh=null,Nh=!1,a;}function Vh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!0),null!==c&&(zh()?a.finishedWork=c:ai(a,c,b)))):(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!1),null!==c&&ai(a,c,b)));W=!1}
function ai(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Rh?Rh=[d]:Rh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;th=ph=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;mg();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;af=Hd;var f=da();if(Ud(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;bf={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var mi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=mi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Zg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ke(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:ch(U);U.effectTag&=-3;break;case 6:ch(U);U.effectTag&=-3;dh(U.alternate,
U);break;case 4:dh(U.alternate,U);break;case 8:D=U,ah(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Zg(U,y),null!==U&&(U=U.nextEffect))}l=bf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Ud(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Td(q,l),D=Td(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}bf=null;Id(af);af=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var hg=U.effectTag;if(hg&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var wi=oc.memoizedProps,xi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(wi,xi,ca.__reactInternalSnapshotBeforeUpdate)}var Ng=l.updateQueue;null!==Ng&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Wf(l,Ng,ca,u));break;case 3:var Og=l.updateQueue;if(null!==Og){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Wf(l,Og,y,u)}break;case 5:var yi=l.stateNode;null===oc&&l.effectTag&4&&cf(l.type,l.memoizedProps)&&yi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(hg&128){l=void 0;var yc=U.ref;if(null!==yc){var Pg=U.stateNode;switch(U.tag){case 5:l=Pg;break;default:l=Pg}"function"===typeof yc?yc(l):yc.current=l}}var zi=U.nextEffect;U.nextEffect=null;U=zi}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Zg(U,q),null!==U&&(U=U.nextEffect))}ph=th=!1;"function"===typeof Jf&&Jf(b.stateNode);b=c.current.expirationTime;0===b&&(hh=null);a.remainingExpirationTime=b}function zh(){return null===Ph||Ph.timeRemaining()>Sh?!1:Mh=!0}
function fh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Nh||(Nh=!0,Oh=a)}function Bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function bi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Wh()}}function ci(a,b){if(Z&&!Qh){Qh=!0;try{return a(b)}finally{Qh=!1}}return a(b)}function di(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Ih(a,b)}finally{Z=c,Wh()}}
function ei(a,b,c){if(Dh)return a(b,c);Z||W||0===Eh||(Yh(Eh,!1,null),Eh=0);var d=Dh,e=Z;Z=Dh=!0;try{return a(b,c)}finally{Dh=d,(Z=e)||W||Wh()}}function fi(a){var b=Z;Z=!0;try{Ih(a)}finally{(Z=b)||W||Yh(1,!1,null)}}
function gi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===jd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(qf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=qf(c)?vf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Of(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Qf(f,e,d);og(f,d);return d}
function hi(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=md(b);return null===a?null:a.stateNode}function ii(a,b,c,d){var e=b.current,f=mg();e=ng(f,e);return gi(a,b,c,e,d)}function ji(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function ki(a){var b=a.findFiberByHostInstance;return If(p({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var li={updateContainerAtExpirationTime:gi,createContainer:function(a,b,c){return Ef(a,b,c)},updateContainer:ii,flushRoot:$h,requestWork:Ah,computeUniqueAsyncExpiration:Ch,batchedUpdates:bi,unbatchedUpdates:ci,deferredUpdates:Hh,syncUpdates:Ih,interactiveUpdates:ei,flushInteractiveUpdates:function(){W||0===Eh||(Yh(Eh,!1,null),Eh=0)},flushControlled:fi,flushSync:di,getPublicRootInstance:ji,findHostInstance:hi,findHostInstanceWithNoPortals:function(a){a=nd(a);return null===a?null:a.stateNode},injectIntoDevTools:ki};
function ni(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent($e);function oi(a){this._expirationTime=Ch();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
oi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new pi;gi(a,b,null,c,d._onCommit);return d};oi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
oi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;$h(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};oi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function pi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}pi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function qi(a,b,c){this._internalRoot=Ef(a,b,c)}qi.prototype.render=function(a,b){var c=this._internalRoot,d=new pi;b=void 0===b?null:b;null!==b&&d.then(b);ii(a,c,null,d._onCommit);return d};
qi.prototype.unmount=function(a){var b=this._internalRoot,c=new pi;a=void 0===a?null:a;null!==a&&c.then(a);ii(null,b,null,c._onCommit);return c};qi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new pi;c=void 0===c?null:c;null!==c&&e.then(c);ii(b,d,a,e._onCommit);return e};
qi.prototype.createBatch=function(){var a=new oi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ri(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=li.batchedUpdates;Tb=li.interactiveUpdates;Ub=li.flushInteractiveUpdates;
function si(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qi(a,!1,b)}
function ti(a,b,c,d,e){ri(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ji(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=si(c,d);if("function"===typeof e){var h=e;e=function(){var a=ji(f._internalRoot);h.call(a)}}ci(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ji(f._internalRoot)}
function ui(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ri(b)?void 0:A("200");return ni(a,b,null,c)}
var vi={createPortal:ui,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:hi(a)},hydrate:function(a,b,c){return ti(null,a,b,!0,c)},render:function(a,b,c){return ti(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ti(a,b,c,!1,d)},unmountComponentAtNode:function(a){ri(a)?void 0:A("40");return a._reactRootContainer?(ci(function(){ti(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ui.apply(void 0,
arguments)},unstable_batchedUpdates:bi,unstable_deferredUpdates:Hh,unstable_interactiveUpdates:ei,flushSync:di,unstable_flushControlled:fi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Nd},unstable_createRoot:function(a,b){return new qi(a,!0,null!=b&&!0===b.hydrate)}};ki({findFiberByHostInstance:Na,bundleType:0,version:"16.4.1",rendererPackageName:"react-dom"});
var Ai={default:vi},Bi=Ai&&vi||Ai;module.exports=Bi.default?Bi.default:Bi;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(58);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(59);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(12);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(62);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(26);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(71);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8), __webpack_require__(70)(module)))

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(80);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(77);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(75);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(28);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(79);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(26);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(84);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(12);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_gsntv__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_rewardVideo__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rewardVideo__ = __webpack_require__(88);
var initialState={// userLoggedIn: true,
userLoggedIn:false,user:null,isAppIframed:false,appInitiatedLogin:false,maxScore:null,affiliate:null,rewardVideo:{adBlocked:false,// noCampaign: false,
ready:null,open:false,// close: false,
complete:false,ironRV:null,support:false,stale:true}};function setAppIframed(state,action){var isAppIframed=Object(__WEBPACK_IMPORTED_MODULE_2__utils_gsntv__["c" /* isIframed */])();return Object.assign({},state,{isAppIframed:isAppIframed});}function setMaxScore(state,action){console.log("Reducers :: setMaxScore - action = ",action);var maxScore=action.maxScore;return Object.assign({},state,{maxScore:maxScore});}function setAffiliate(state,action){var affiliate={};switch(action.data){case'fox4more':affiliate.imgName='fox4more-logo.png';affiliate.url='http://www.fox4news.com/kdfi-my27';break;case'fox9plus':affiliate.imgName='fox9plus-logo.png';affiliate.url='http://www.fox9.com/plus';break;case'fox10xtra':affiliate.imgName='fox10xtra-logo.png';affiliate.url='http://www.fox10phoenix.com/fox10xtra';break;case'foxmy13':affiliate.imgName='foxmy13-logo.png';affiliate.url='http://www.foxla.com/my13';break;case'foxmy56':affiliate.imgName='foxmy56-logo.png';affiliate.url='http://www.fox35orlando.com/my65';break;case'ktvuplus':affiliate.imgName='ktvuplus-logo.png';affiliate.url='http://www.ktvu.com/news/ktvuplus';break;default:affiliate=null;}return Object.assign({},state,{affiliate:affiliate});}function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions__["USER_LOGIN"]:return Object(__WEBPACK_IMPORTED_MODULE_1__user__["a" /* loginUser */])(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions__["USER_LOGOUT"]:return Object(__WEBPACK_IMPORTED_MODULE_1__user__["b" /* logoutUser */])(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions__["APP_IFRAMED"]:return setAppIframed(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions__["SET_MAX_SCORE"]:return setMaxScore(state,action);case __WEBPACK_IMPORTED_MODULE_3__actions_rewardVideo__["e" /* REWARD_VIDEO_READY */]:return Object(__WEBPACK_IMPORTED_MODULE_4__rewardVideo__["d" /* rewardVideoReady */])(state,action);case __WEBPACK_IMPORTED_MODULE_3__actions_rewardVideo__["c" /* REWARD_VIDEO_IRONSOURCE */]:return Object(__WEBPACK_IMPORTED_MODULE_4__rewardVideo__["e" /* setIronRV */])(state,action);case __WEBPACK_IMPORTED_MODULE_3__actions_rewardVideo__["d" /* REWARD_VIDEO_OPEN */]:return Object(__WEBPACK_IMPORTED_MODULE_4__rewardVideo__["c" /* rewardVideoOpen */])(state,action);case __WEBPACK_IMPORTED_MODULE_3__actions_rewardVideo__["b" /* REWARD_VIDEO_COMPLETION */]:return Object(__WEBPACK_IMPORTED_MODULE_4__rewardVideo__["b" /* rewardVideoComplete */])(state,action);case __WEBPACK_IMPORTED_MODULE_3__actions_rewardVideo__["a" /* REWARD_VIDEO_AD_BLOCKED */]:return Object(__WEBPACK_IMPORTED_MODULE_4__rewardVideo__["a" /* rewardVideoAdBlocked */])(state,action);case __WEBPACK_IMPORTED_MODULE_3__actions_rewardVideo__["g" /* REWARD_VIDEO_SUPPORT */]:return Object(__WEBPACK_IMPORTED_MODULE_4__rewardVideo__["f" /* setRewardVideoSupport */])(state,action);case __WEBPACK_IMPORTED_MODULE_3__actions_rewardVideo__["f" /* REWARD_VIDEO_STALE */]:return Object(__WEBPACK_IMPORTED_MODULE_4__rewardVideo__["g" /* updateRewardVideoStale */])(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions__["SET_AFFILIATE"]:return setAffiliate(state,action);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loginUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = logoutUser;
function loginUser(state,action){var userLoggedIn=true;var firstName=action.data&&action.data.detail&&action.data.detail.profile&&action.data.detail.profile.firstName||null;var lastName=action.data&&action.data.detail&&action.data.detail.profile&&action.data.detail.profile.lastName||null;var gameData=action.data&&action.data.detail&&action.data.detail.data&&action.data.detail.data.gameData4||null;var appInitiatedLogin=action.data&&action.data.appInitiatedLogin||false;console.log("user action.data",action.data);return Object.assign({},state,{userLoggedIn:userLoggedIn,appInitiatedLogin:appInitiatedLogin,user:{firstName:firstName,lastName:lastName,gameData:gameData}});}function logoutUser(state,action){var userLoggedIn=false;var user=null;return Object.assign({},state,{userLoggedIn:userLoggedIn,user:user});}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var NativeCustomEvent = global.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

module.exports = useNative() ? NativeCustomEvent :

// IE >= 9
'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
  var e = document.createEvent('CustomEvent');
  if (params) {
    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
  } else {
    e.initCustomEvent(type, false, false, void 0);
  }
  return e;
} :

// IE <= 8
function CustomEvent (type, params) {
  var e = document.createEventObject();
  e.type = type;
  if (params) {
    e.bubbles = Boolean(params.bubbles);
    e.cancelable = Boolean(params.cancelable);
    e.detail = params.detail;
  } else {
    e.bubbles = false;
    e.cancelable = false;
    e.detail = void 0;
  }
  return e;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rewardVideoAdBlocked;
/* harmony export (immutable) */ __webpack_exports__["d"] = rewardVideoReady;
/* harmony export (immutable) */ __webpack_exports__["e"] = setIronRV;
/* harmony export (immutable) */ __webpack_exports__["c"] = rewardVideoOpen;
/* harmony export (immutable) */ __webpack_exports__["b"] = rewardVideoComplete;
/* harmony export (immutable) */ __webpack_exports__["f"] = setRewardVideoSupport;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateRewardVideoStale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ironsource__ = __webpack_require__(29);
function rewardVideoAdBlocked(state,action){console.log("Reward Video Ad Blocked",action);var nextState=Object.assign({},state);nextState.rewardVideo=Object.assign({},state.rewardVideo);nextState.rewardVideo.adBlocked=action&&action.data||false;return nextState;}function rewardVideoReady(state,action){var nextState=Object.assign({},state);nextState.rewardVideo=Object.assign({},state.rewardVideo);if(action.data===null){nextState.rewardVideo.ready=null;}else if(action.data.name===__WEBPACK_IMPORTED_MODULE_0__utils_ironsource__["a" /* IronRV */].EVENTS.READY){nextState.rewardVideo.ready=true;}else{nextState.rewardVideo.ready=false;}console.log("Reward Video Ready",action,nextState);return nextState;}function setIronRV(state,action){var nextState=Object.assign({},state);nextState.rewardVideo=Object.assign({},state.rewardVideo);if(action){nextState.rewardVideo.ironRV=action.data;}console.log("Reward Video setIronRV",action,nextState);return nextState;}function rewardVideoOpen(state,action){var nextState=Object.assign({},state);nextState.rewardVideo=Object.assign({},state.rewardVideo);if(action.data.name===__WEBPACK_IMPORTED_MODULE_0__utils_ironsource__["a" /* IronRV */].EVENTS.OPEN){nextState.rewardVideo.open=true;nextState.rewardVideo.complete=false;}else{nextState.rewardVideo.open=false;}console.log("Reward Video Open",action,nextState);return nextState;}function rewardVideoComplete(state,action){var nextState=Object.assign({},state);nextState.rewardVideo=Object.assign({},state.rewardVideo);nextState.rewardVideo.complete=true;console.log("Reward Video Complete",action,nextState);return nextState;}function setRewardVideoSupport(state,action){var nextState=Object.assign({},state);nextState.rewardVideo=Object.assign({},state.rewardVideo);nextState.rewardVideo.support=window.screen&&window.screen.availWidth>706;console.log("Reward Video Supported",action,nextState);return nextState;}function updateRewardVideoStale(state,action){var nextState=Object.assign({},state);nextState.rewardVideo=Object.assign({},state.rewardVideo);nextState.rewardVideo.stale=action.data;console.log("Reward Video Supported",action,nextState);return nextState;}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(7);
var mapStateToProps=function mapStateToProps(state){return{userLoggedIn:state.userLoggedIn,user:state.user,affiliate:state.affiliate};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setAppIframed:function setAppIframed(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["setAppIframed"])());},setAffiliate:function setAffiliate(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["setAffiliate"])(data));}};};var AppContainer=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AppContainer);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_landingpage_header_Header__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_landingpage_leftCol_TuneIn__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_landingpage_leaderboard_Leaderboard__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_gamepage_GamePage__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_gsntv__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_analytics__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_IronSourceInitializerContainer__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_landingpage_leftCol_LandingVideo__ = __webpack_require__(140);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Ranking from './components/landingpage/leftCol/Ranking';
var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this2=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this2.state={page:"",landingTransitionOut:false,dataReady:false};_this2.showPage=_this2.showPage.bind(_this2);_this2.handleTransitionOut=_this2.handleTransitionOut.bind(_this2);return _this2;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){//console.log("componentDidMount");
this.initData();this.showPage("landing");// disable "tab" keyboard input
window.$(document).keydown(function(e){if(e.keyCode===9||e.keyCode===37||e.keyCode===38||e.keyCode===39||e.keyCode===40){e.preventDefault();}});// pressing "enter" forces blur on fields
window.$(document).keydown(function(e){if(e.keyCode===13){window.$("input[type=text]").blur();}});// tracking
Object(__WEBPACK_IMPORTED_MODULE_8__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-page-loaded',{'event_category':'america-says-game'});this.props.setAffiliate('fox9');if(this.props.match){this.props.setAffiliate(this.props.match.params.affiliate);}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){if(nextState.page==="landing"&&this.state.page==="game"&&!Object(__WEBPACK_IMPORTED_MODULE_6__utils_gsntv__["c" /* isIframed */])()){//console.log("App :: componentWillUpdate - not iframed - will set dataReady true");
this.setState({dataReady:true});}else if(nextState.page==="landing"&&this.state.page!=="landing"){//console.log("App :: componentWillUpdate - going to landing");
this.setState({dataReady:false});// 
//console.log("App :: componentWillUpdate - about to check if iframed");
var _this=this;if(Object(__WEBPACK_IMPORTED_MODULE_6__utils_gsntv__["c" /* isIframed */])()){//console.log("App :: componentWillUpdate - is iframed");
Object(__WEBPACK_IMPORTED_MODULE_6__utils_gsntv__["b" /* highScoresThisMonthFromGSNTV */])().then(function(data){//console.log("App :: highScoresThisMonthFromGSNTV - data ", data);
window.highScores=Object.assign({},data);_this.setState({dataReady:true});});}}}},{key:'initData',value:function initData(){console.log("App :: initData - v41");var _this=this;window.$.when(window.$.getJSON("data/config.json",function(data){window.config=Object.assign({},data);window.videoAdsPool=[].concat(_toConsumableArray(data.videoAd.videos));}),window.$.getJSON("data/questions.json",function(data){window.questions={};window.questionsPool={};window.questions.easy=[].concat(_toConsumableArray(data.easy));window.questionsPool.easy=[].concat(_toConsumableArray(data.easy));window.questions.medium=[].concat(_toConsumableArray(data.medium));window.questionsPool.medium=[].concat(_toConsumableArray(data.medium));window.questions.hard=[].concat(_toConsumableArray(data.hard));window.questionsPool.hard=[].concat(_toConsumableArray(data.hard));}),window.$.getJSON("data/bonusQuestions.json",function(data){window.bonusQuestions={};window.bonusQuestionsPool={};window.bonusQuestions["1"]=[].concat(_toConsumableArray(data["1"]));window.bonusQuestionsPool["1"]=[].concat(_toConsumableArray(data["1"]));window.bonusQuestions["2"]=[].concat(_toConsumableArray(data["2"]));window.bonusQuestionsPool["2"]=[].concat(_toConsumableArray(data["2"]));window.bonusQuestions["3"]=[].concat(_toConsumableArray(data["3"]));window.bonusQuestionsPool["3"]=[].concat(_toConsumableArray(data["3"]));window.bonusQuestions["4"]=[].concat(_toConsumableArray(data["4"]));window.bonusQuestionsPool["4"]=[].concat(_toConsumableArray(data["4"]));}),window.$.getJSON("data/alternateWords.json",function(data){window.alternateWords=Object.assign({},data);}),window.$.getJSON("data/leaderboard.json",function(data){window.leaderboard=Object.assign({},data);})).then(function(){if(window.config&&window.questions&&window.bonusQuestions&&window.alternateWords){console.log("App :: json loaded");if(!Object(__WEBPACK_IMPORTED_MODULE_6__utils_gsntv__["c" /* isIframed */])()){_this.setState({dataReady:true});}}else{console.log("App :: json load failed");}});}},{key:'showPage',value:function showPage(pageName){this.setState({page:pageName,landingTransitionOut:false});// play bg
if(pageName==="landing"){window.sounds.roundBg.stop();window.sounds.bonusBg.stop();window.sounds.introBg.play();}}},{key:'handleTransitionOut',value:function handleTransitionOut(){this.setState({landingTransitionOut:true});}},{key:'route_page',value:function route_page(){//console.log("App :: route_page");
if(this.state.dataReady){//console.log("App :: route_page - dataReady");
if(this.state.page==="landing"){//console.log("App :: route_page - render landing");
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_landingpage_header_Header__["a" /* default */],{showPage:this.showPage,handleTransitionOut:this.handleTransitionOut}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leftCol_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_landingpage_leftCol_TuneIn__["a" /* default */],{landingTransitionOut:this.state.landingTransitionOut})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaderboard_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_landingpage_leftCol_LandingVideo__["a" /* default */],{landingTransitionOut:this.state.landingTransitionOut}))));}else if(this.state.page==="game"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_gamepage_GamePage__["a" /* default */],{showPage:this.showPage,store:this.props.store});}}}},{key:'render',value:function render(){//console.log("App :: render - bonusQuestions", this.bonusQuestions);
//console.log("App.js :: render - redux props", this.props.user);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main_wrapper'},this.route_page(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__containers_IronSourceInitializerContainer__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(9);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 92 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(97)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(34);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_AccAccessBtnContainer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_analytics__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FooterLogo__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this2=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this2.transitionIn=new window.TimelineMax({onComplete:_this2.handleTransitionComplete,onCompleteParams:[_this2],onReverseComplete:_this2.handleTransitionOutComplete,onReverseCompleteParams:[_this2]});_this2.state={inTransition:false};_this2.playBtnHandleOnClick=_this2.playBtnHandleOnClick.bind(_this2);_this2.facebookHandleClick=_this2.facebookHandleClick.bind(_this2);_this2.twitterHandleClick=_this2.twitterHandleClick.bind(_this2);_this2.accAccessBtn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this2;}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.wipe,{"height":"100%"});window.TweenMax.set(this.refs.host,{"height":"0%"});window.TweenMax.set(this.refs.logo,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.playBtn,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.accAccessBtn.current,{"opacity":0,"transform":"translateY(1vw)"});this.transitionIn.to(this.refs.wipe,.7,{"height":"0%"}).to(this.refs.host,.6,{"height":"100%"}).to(this.refs.logo,.6,{"opacity":1,"transform":"translateY(0vw)"},"-=.4").to(this.refs.playBtn,.6,{"opacity":1,"transform":"translateY(0vw)"},"-=.2").to(this.accAccessBtn.current,.6,{"opacity":1,"transform":"translateY(0vw)"},"-=.2");this.setState({inTransition:true});}},{key:'playBtnHandleOnClick',value:function playBtnHandleOnClick(){if(!this.props.rewardVideo.adBlocked){window.sounds.buttonClick.play();// tell parent to transition out the ranking and leaderboard modules
this.props.handleTransitionOut();// start transition out for this module
this.transitionIn.reverse(1);// tracking
Object(__WEBPACK_IMPORTED_MODULE_5__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-game-start',{'event_category':'america-says-game'});}}},{key:'handleTransitionComplete',value:function handleTransitionComplete(_this){_this.setState({inTransition:false});}},{key:'handleTransitionOutComplete',value:function handleTransitionOutComplete(_this){_this.props.showPage("game");}},{key:'facebookHandleClick',value:function facebookHandleClick(){Object(__WEBPACK_IMPORTED_MODULE_5__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-share-fb',{'event_category':'america-says-game','event_label':'landing'});//
var appId="";var shareImage="http://lifeislikeadot.com/contents_index/comingsoon1.jpg";var shareURL="http://lifeislikeadot.com";var shareMsg="test share messsage";var shareRedirectURI="";Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* facebookShare */])(appId,shareImage,shareURL,shareMsg,shareRedirectURI);}},{key:'twitterHandleClick',value:function twitterHandleClick(){Object(__WEBPACK_IMPORTED_MODULE_5__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-share-tw',{'event_category':'america-says-game','event_label':'landing'});//
var shareMsg="test share message";var shareURL="http://lifeislikeadot";Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["c" /* twitterShare */])(shareMsg,shareURL);}},{key:'render',value:function render(){var _this3=this;var hoverActive=this.state.inTransition?"":"hoverActive";var btnRef=this.accAccessBtn;var playNowBtnTxt='Play Now';var isAppIframed=this.props.isAppIframed;console.log('Header this.props',this.props);var btnClassName={login:'loginBtn hide',logout:'loginBtn hide'};var btnLabel={login:'Login / Register',logout:'Logout'};if(this.props.rewardVideo.adBlocked){playNowBtnTxt='Ad-Blocker Detected';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'header',ref:'header',className:hoverActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo',ref:'logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'playBtn',ref:'playBtn',onClick:function onClick(){return _this3.playBtnHandleOnClick();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},playNowBtnTxt,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fas fa-caret-right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_AccAccessBtnContainer__["a" /* default */],{btnLabel:btnLabel,btnRef:btnRef,btnClassName:btnClassName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'host',ref:'host'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FooterLogo__["a" /* default */],null),window.config.share&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fab fa-facebook-square',onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();},onClick:function onClick(){return _this3.facebookHandleClick();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fab fa-twitter-square',onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();},onClick:function onClick(){return _this3.twitterHandleClick();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wipe',ref:'wipe'}));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isAppIframed:state.isAppIframed,rewardVideo:state.rewardVideo};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Header));

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(36)(undefined);
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: 'AvenirNextLTPro-HeavyIt';\n  src: url(" + __webpack_require__(37) + ");\n  src: url(" + __webpack_require__(37) + "?#iefix) format(\"embedded-opentype\"), url(" + __webpack_require__(102) + ") format(\"woff\"), url(" + __webpack_require__(103) + ") format(\"truetype\"); }\n\nhtml, body {\n  width: 100%;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  background-color: #ffffff; }\n\n.main_wrapper {\n  width: 100%;\n  height: auto;\n  min-height: 100vh;\n  position: relative;\n  top: 0;\n  left: 0;\n  overflow: hidden; }\n  .main_wrapper .page {\n    width: calc(100% - 1.6rem * 2);\n    height: auto;\n    margin: 1.6rem;\n    position: relative;\n    display: block;\n    /* -- general -- */\n    /* ===== landing page ===== */\n    /* ===== game page ===== */ }\n    @media (max-width: 768px) {\n      .main_wrapper .page {\n        width: calc(100% - 1.6rem);\n        margin: calc(0.8rem); } }\n    .main_wrapper .page .content {\n      width: 100%;\n      height: 100%;\n      position: relative;\n      background-color: transparent;\n      overflow: hidden; }\n    .main_wrapper .page.landing {\n      /* -- blocks -- */ }\n      .main_wrapper .page.landing .header_wrapper {\n        width: 100%;\n        height: 40vw;\n        position: relative;\n        display: inline-block;\n        vertical-align: top; }\n        @media (max-width: 768px) {\n          .main_wrapper .page.landing .header_wrapper {\n            height: auto; } }\n      .main_wrapper .page.landing .leftCol_wrapper {\n        width: calc(50% - 0.8rem);\n        height: auto;\n        padding: 1.6rem 0.8rem 0 0;\n        position: relative;\n        display: inline-block;\n        vertical-align: top; }\n        @media (max-width: 768px) {\n          .main_wrapper .page.landing .leftCol_wrapper {\n            width: 100%;\n            padding: 0.8rem 0.8rem 0 0; } }\n      .main_wrapper .page.landing .leaderboard_wrapper {\n        width: calc(50% - 0.8rem);\n        height: auto;\n        padding: 1.6rem 0 0 0.8rem;\n        position: relative;\n        display: inline-block;\n        vertical-align: top; }\n        @media (max-width: 768px) {\n          .main_wrapper .page.landing .leaderboard_wrapper {\n            width: 100%;\n            padding: 0.8rem 0.8rem 0 0; } }\n    .main_wrapper .page.game {\n      /* -- blocks -- */ }\n      .main_wrapper .page.game .wipe {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 1000;\n        background-color: #ffffff; }\n      .main_wrapper .page.game .f-logo-container {\n        display: block;\n        left: 2vw;\n        right: auto;\n        padding-right: 0;\n        text-align: center; }\n        @media (max-width: 768px) {\n          .main_wrapper .page.game .f-logo-container {\n            font-size: 1.5vw; } }\n        .main_wrapper .page.game .f-logo-container img {\n          display: block;\n          margin: .5vw auto 0;\n          width: 5vw;\n          min-width: 30px; }\n      .main_wrapper .page.game .game_wrapper {\n        width: calc(84% - 0.8rem);\n        height: 45vw;\n        padding: 0 0.8rem 0 0;\n        position: relative;\n        display: inline-block;\n        vertical-align: top; }\n        .main_wrapper .page.game .game_wrapper .content {\n          background-image: url(" + __webpack_require__(38) + ");\n          background-size: cover;\n          background-repeat: no-repeat;\n          background-position: center; }\n          .main_wrapper .page.game .game_wrapper .content .giveUpBtn {\n            width: auto;\n            height: auto;\n            position: absolute;\n            bottom: 2vw;\n            right: 7vw;\n            color: #ffffff;\n            font-family: \"AvenirNextLTPro-HeavyIt\";\n            font-weight: bold;\n            font-size: 1.5vw;\n            text-align: center;\n            transition: 300ms;\n            -webkit-transition: 300ms;\n            transform: scale(0.9);\n            -webkit-transform: scale(0.9);\n            opacity: 0;\n            pointer-events: none; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn .giveUpLabel {\n              padding: 1vw 1.2vw;\n              position: relative;\n              top: 0;\n              left: 0;\n              background-color: #f6a936;\n              border-radius: 2vw;\n              cursor: pointer;\n              transition: 300ms;\n              -webkit-transition: 300ms; }\n              .main_wrapper .page.game .game_wrapper .content .giveUpBtn .giveUpLabel:hover {\n                background-color: #ba750e; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn .confirmLabel {\n              width: 100%;\n              padding: 1vw 0vw;\n              position: absolute;\n              top: 0;\n              left: 0;\n              border-radius: 2vw;\n              background-color: #ffffff;\n              color: #000000; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn .yesBtn {\n              width: 100%;\n              padding: 1vw 1.5vw;\n              position: absolute;\n              top: 0;\n              left: 0vw;\n              text-align: right;\n              background-color: #139f09;\n              border-radius: 2vw;\n              cursor: pointer;\n              transition: 300ms;\n              -webkit-transition: 300ms;\n              box-sizing: border-box;\n              -moz-box-sizing: border-box;\n              -webkit-box-sizing: border-box; }\n              .main_wrapper .page.game .game_wrapper .content .giveUpBtn .yesBtn:hover {\n                background-color: #29e61a; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn .noBtn {\n              width: 100%;\n              padding: 1vw 1.5vw;\n              position: absolute;\n              top: 0;\n              left: 0vw;\n              text-align: left;\n              background-color: #c71313;\n              border-radius: 2vw;\n              cursor: pointer;\n              transition: 300ms;\n              -webkit-transition: 300ms;\n              box-sizing: border-box;\n              -moz-box-sizing: border-box;\n              -webkit-box-sizing: border-box; }\n              .main_wrapper .page.game .game_wrapper .content .giveUpBtn .noBtn:hover {\n                background-color: #ff0000; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn .warning {\n              width: 27vw;\n              position: absolute;\n              bottom: -1.6vw;\n              font-family: arial;\n              font-weight: normal;\n              color: #e2e2e2;\n              font-size: 1vw;\n              transform: translateX(-38%);\n              -webkit-transform: translateX(-38%);\n              pointer-events: none;\n              opacity: 0;\n              transition: 300ms;\n              -webkit-transition: 300ms; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn.show {\n              pointer-events: auto;\n              opacity: 1;\n              transform: scale(1);\n              -webkit-transform: scale(1); }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn.expand .giveUpLabel {\n              opacity: 0;\n              pointer-events: none; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn.expand .yesBtn {\n              left: 5vw; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn.expand .noBtn {\n              left: -5vw; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn.expand .warning {\n              opacity: 1; }\n      .main_wrapper .page.game .sidebar_wrapper {\n        width: calc(16% - 0.8rem);\n        height: 45vw;\n        margin: 0 0 0 0.8rem;\n        position: relative;\n        display: inline-block;\n        vertical-align: top; }\n      .main_wrapper .page.game .instructions_overlay {\n        width: calc(100% - 1.6rem * 2);\n        height: calc(45vw - 1.6rem * 2);\n        padding: 1.6rem;\n        background-color: rgba(0, 0, 0, 0.85);\n        position: absolute;\n        top: 0;\n        left: 0; }\n        .main_wrapper .page.game .instructions_overlay .content {\n          width: 60vw;\n          background-color: #0341ef;\n          position: relative;\n          margin: 0 auto;\n          background-image: url(" + __webpack_require__(16) + ");\n          background-size: cover;\n          background-repeat: no-repeat;\n          background-position: center; }\n          .main_wrapper .page.game .instructions_overlay .content .text {\n            width: 50vw;\n            height: auto;\n            background-color: transparent;\n            font-family: \"AvenirNextLTPro-HeavyIt\";\n            font-weight: bold;\n            color: #ffffff;\n            position: relative;\n            padding: 2vw;\n            font-size: 1.6vw;\n            line-height: 2.4vw;\n            margin: 2vw auto 0 auto; }\n            .main_wrapper .page.game .instructions_overlay .content .text .firstLine {\n              font-size: 3vw; }\n            .main_wrapper .page.game .instructions_overlay .content .text ol {\n              padding: 0vw 0vw 0vw 4vw; }\n            .main_wrapper .page.game .instructions_overlay .content .text .thumbnail {\n              width: 51vw;\n              height: 14vw;\n              margin: 0 auto;\n              background-image: url(" + __webpack_require__(104) + ");\n              background-size: contain;\n              background-repeat: no-repeat;\n              background-position: center;\n              box-sizing: border-box;\n              -moz-box-sizing: border-box;\n              -webkit-box-sizing: border-box; }\n          .main_wrapper .page.game .instructions_overlay .content .playBtn {\n            width: 28vw;\n            height: 4vw;\n            background-color: #ffffff;\n            font-family: \"AvenirNextLTPro-HeavyIt\";\n            font-weight: bold;\n            font-size: 2.3vw;\n            text-align: center;\n            line-height: 4vw;\n            color: #dd1834;\n            border-radius: .5vw;\n            position: relative;\n            margin: 1vw auto;\n            cursor: pointer;\n            transition: 300ms;\n            -webkit-transition: 300ms; }\n            .main_wrapper .page.game .instructions_overlay .content .playBtn:hover {\n              font-size: 2.4vw;\n              background-color: #dd1834;\n              color: #ffffff; }\n      .main_wrapper .page.game .bonusInstructions_overlay {\n        width: calc(100% - 1.6rem * 2);\n        height: calc(45vw - 1.6rem * 2);\n        padding: 1.6rem;\n        background-color: rgba(0, 0, 0, 0.85);\n        position: absolute;\n        top: 0;\n        left: 0; }\n        .main_wrapper .page.game .bonusInstructions_overlay .content {\n          width: 67vw;\n          background-color: #0341ef;\n          position: relative;\n          margin: 0 auto;\n          background-image: url(" + __webpack_require__(16) + ");\n          background-size: cover;\n          background-repeat: no-repeat;\n          background-position: center; }\n          .main_wrapper .page.game .bonusInstructions_overlay .content .text {\n            width: 49vw;\n            height: auto;\n            background-color: transparent;\n            font-family: \"AvenirNextLTPro-HeavyIt\";\n            font-weight: bold;\n            color: #ffffff;\n            position: relative;\n            padding: 2vw;\n            font-size: 1.6vw;\n            line-height: 2.4vw;\n            margin: 2vw auto 0 auto; }\n            .main_wrapper .page.game .bonusInstructions_overlay .content .text .firstLine {\n              font-size: 3vw;\n              text-align: center; }\n            .main_wrapper .page.game .bonusInstructions_overlay .content .text ul {\n              width: 41vw;\n              margin: 5vw 0 0 0;\n              padding: 0vw 2vw 0vw 0vw;\n              font-size: 1.5vw; }\n              .main_wrapper .page.game .bonusInstructions_overlay .content .text ul li {\n                margin: 1vw 0; }\n          .main_wrapper .page.game .bonusInstructions_overlay .content .playBtn {\n            width: 28vw;\n            height: 4vw;\n            background-color: #ffffff;\n            font-family: \"AvenirNextLTPro-HeavyIt\";\n            font-weight: bold;\n            font-size: 2.3vw;\n            text-align: center;\n            line-height: 4vw;\n            color: #dd1834;\n            border-radius: .5vw;\n            position: relative;\n            margin: 2vw auto;\n            left: -8vw;\n            cursor: pointer;\n            transition: 300ms;\n            -webkit-transition: 300ms; }\n            .main_wrapper .page.game .bonusInstructions_overlay .content .playBtn:hover {\n              font-size: 2.4vw;\n              background-color: #dd1834;\n              color: #ffffff; }\n          .main_wrapper .page.game .bonusInstructions_overlay .content .host {\n            height: 32vw;\n            width: 23vw;\n            position: absolute;\n            right: 0;\n            bottom: 0;\n            background-image: url(" + __webpack_require__(105) + ");\n            background-size: 19vw 30vw;\n            background-repeat: no-repeat;\n            background-position: center bottom;\n            pointer-events: none; }\n      .main_wrapper .page.game .results_overlay {\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.85);\n        position: absolute;\n        top: 0;\n        left: 0; }\n        .main_wrapper .page.game .results_overlay .content {\n          width: auto;\n          height: auto;\n          background-color: #0341ef;\n          background-image: url(" + __webpack_require__(16) + ");\n          background-size: cover;\n          background-repeat: no-repeat;\n          background-position: center;\n          padding: 4vw 8vw;\n          display: inline-block;\n          text-align: center;\n          font-size: 1.8vw;\n          font-family: \"AvenirNextLTPro-HeavyIt\";\n          position: absolute;\n          color: #ffffff;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          -webkit-transform: translate(-50%, -50%); }\n          .main_wrapper .page.game .results_overlay .content .roundMsg {\n            font-weight: bold;\n            font-size: 2.5vw;\n            margin: 1vw 0 2vw;\n            white-space: nowrap; }\n          .main_wrapper .page.game .results_overlay .content .scoreMsg {\n            font-size: 1.7vw;\n            margin: 2vw 0; }\n          .main_wrapper .page.game .results_overlay .content .bonusRoundMsg {\n            font-size: 1.6vw;\n            color: #ffff39;\n            font-weight: bold; }\n          .main_wrapper .page.game .results_overlay .content .thresholdMsg {\n            font-size: 1.2vw;\n            white-space: nowrap; }\n          .main_wrapper .page.game .results_overlay .content .nextBtn {\n            width: 28vw;\n            height: 4vw;\n            background-color: #ffffff;\n            font-family: \"AvenirNextLTPro-HeavyIt\";\n            font-weight: bold;\n            font-size: 2.3vw;\n            text-align: center;\n            line-height: 4vw;\n            color: #dd1834;\n            border-radius: .5vw;\n            position: relative;\n            margin: 2vw auto 0 auto;\n            cursor: pointer;\n            transition: 300ms;\n            -webkit-transition: 300ms; }\n            .main_wrapper .page.game .results_overlay .content .nextBtn:hover {\n              font-size: 2.4vw;\n              background-color: #dd1834;\n              color: #ffffff; }\n      .main_wrapper .page.game .bonusResults_overlay {\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.9);\n        position: absolute;\n        top: 0;\n        left: 0; }\n        .main_wrapper .page.game .bonusResults_overlay .content {\n          width: 55vw;\n          height: auto;\n          display: inline-block;\n          text-align: center;\n          font-size: 1.8vw;\n          font-family: \"AvenirNextLTPro-HeavyIt\";\n          position: absolute;\n          z-index: 100;\n          color: #ffffff;\n          background-color: #0341ef;\n          background-image: url(" + __webpack_require__(106) + ");\n          background-size: cover;\n          background-repeat: no-repeat;\n          background-position: center;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          -webkit-transform: translate(-50%, -50%); }\n          .main_wrapper .page.game .bonusResults_overlay .content .leftColumn {\n            width: 50%;\n            height: 35vw;\n            position: relative;\n            display: inline-block;\n            padding: 4vw;\n            vertical-align: middle;\n            text-align: center;\n            box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            -webkit-box-sizing: border-box; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .logo {\n              width: 18vw;\n              padding-top: 10vw;\n              position: absolute;\n              top: 3vw;\n              left: 0;\n              margin: 0 auto 2vw;\n              background-image: url(" + __webpack_require__(17) + ");\n              background-size: contain;\n              background-position: center -1.5vw;\n              background-repeat: no-repeat; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .affiliateLogo {\n              left: 2vw;\n              margin-top: 13vw;\n              position: absolute;\n              width: 14vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .tuneIn {\n              position: absolute;\n              top: 10.5vw;\n              left: 3vw;\n              font-size: 1.6vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .host {\n              width: 18vw;\n              height: 100%;\n              position: absolute;\n              bottom: 0;\n              right: -5vw;\n              background-image: url(" + __webpack_require__(107) + ");\n              background-size: auto 24vw;\n              background-position: bottom center;\n              background-repeat: no-repeat; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .socialWrapper {\n              width: auto;\n              height: auto;\n              position: absolute;\n              bottom: 1vw;\n              left: 4.4vw;\n              text-align: center; }\n              .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .socialWrapper .label {\n                font-size: 1vw; }\n              .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .socialWrapper .fab {\n                color: #edeff4;\n                font-size: 2.5vw;\n                margin: .5vw;\n                transition: 300ms;\n                -webkit-transition: 300ms;\n                cursor: pointer; }\n                .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .socialWrapper .fab:hover {\n                  color: #ffffff;\n                  transform: scale(1.08);\n                  -webkit-transform: scale(1.08); }\n          .main_wrapper .page.game .bonusResults_overlay .content .rightColumn {\n            width: 50%;\n            height: auto;\n            position: relative;\n            display: inline-block;\n            padding: 4vw;\n            vertical-align: top;\n            box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            -webkit-box-sizing: border-box; }\n            .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .line1 {\n              font-size: 1.8vw;\n              font-weight: bold;\n              line-height: 2vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .line2 {\n              font-size: 1.5vw;\n              font-weight: bold;\n              line-height: 1.7vw;\n              margin: 1vw auto; }\n            .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .line3 {\n              font-size: 1.5vw;\n              font-weight: bold;\n              margin: 0vw auto; }\n            .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .buttonsWrapper {\n              position: relative;\n              margin: 2vw 0 0 0; }\n              .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .buttonsWrapper .button {\n                width: auto;\n                height: auto;\n                position: relative;\n                background-color: #ffffff;\n                color: #dd1834;\n                padding: .5vw 1vw;\n                font-size: 1.3vw;\n                font-weight: bold;\n                border-radius: .5vw;\n                margin: .7vw auto;\n                cursor: pointer;\n                transition: 300ms;\n                -webkit-transition: 300ms; }\n                .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .buttonsWrapper .button:hover {\n                  background-color: #dd1834;\n                  color: #ffffff; }\n              .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .buttonsWrapper .hide {\n                display: none; }\n          .main_wrapper .page.game .bonusResults_overlay .content .f-logo-container {\n            bottom: 0;\n            color: #fff;\n            font: 10px \"AvenirNextLTPro-HeavyIt\", arial;\n            right: 0;\n            text-align: right;\n            padding: 1em 2em 2em 0;\n            position: absolute; }\n            .main_wrapper .page.game .bonusResults_overlay .content .f-logo-container img {\n              display: inline;\n              margin-left: .5em;\n              vertical-align: middle;\n              width: 50px; }\n      @media (max-width: 768px) {\n        .main_wrapper .page.game .game_wrapper {\n          width: 100%;\n          height: auto;\n          margin: calc(20vw + 0.8rem) auto 0.8rem; }\n          .main_wrapper .page.game .game_wrapper .content .giveUpBtn {\n            bottom: 9vw;\n            right: 10vw; }\n            .main_wrapper .page.game .game_wrapper .content .giveUpBtn .warning {\n              bottom: -4vw;\n              font-size: 1.8vw; }\n        .main_wrapper .page.game .sidebar_wrapper {\n          width: 100%;\n          height: 20vw;\n          position: absolute;\n          top: 0;\n          left: 0;\n          margin: 0; }\n        .main_wrapper .page.game .instructions_overlay {\n          height: 100%; }\n          .main_wrapper .page.game .instructions_overlay .content {\n            width: 70vw;\n            height: auto; }\n            .main_wrapper .page.game .instructions_overlay .content .text {\n              width: 60vw;\n              font-size: 2.2vw;\n              line-height: 4vw; }\n              .main_wrapper .page.game .instructions_overlay .content .text .firstLine {\n                font-size: 4vw; }\n              .main_wrapper .page.game .instructions_overlay .content .text .thumbnail {\n                width: 60vw;\n                height: 17vw; }\n            .main_wrapper .page.game .instructions_overlay .content .playBtn {\n              font-size: 3vw;\n              height: 6vw;\n              width: 32vw;\n              line-height: 6vw;\n              margin: 2vw auto 4vw; }\n        .main_wrapper .page.game .bonusInstructions_overlay {\n          height: 100%; }\n          .main_wrapper .page.game .bonusInstructions_overlay .content {\n            width: 83vw;\n            height: auto; }\n            .main_wrapper .page.game .bonusInstructions_overlay .content .text {\n              width: 70vw;\n              font-size: 2.2vw;\n              line-height: 4vw; }\n              .main_wrapper .page.game .bonusInstructions_overlay .content .text .firstLine {\n                font-size: 4vw;\n                text-align: center; }\n              .main_wrapper .page.game .bonusInstructions_overlay .content .text ul {\n                width: 55vw;\n                font-size: 2vw; }\n            .main_wrapper .page.game .bonusInstructions_overlay .content .playBtn {\n              font-size: 3vw;\n              height: 6vw;\n              width: 32vw;\n              line-height: 6vw;\n              margin: 2vw auto 4vw; }\n        .main_wrapper .page.game .results_overlay .content {\n          width: 55vw; }\n          .main_wrapper .page.game .results_overlay .content .roundMsg {\n            font-size: 4vw; }\n          .main_wrapper .page.game .results_overlay .content .scoreMsg {\n            font-size: 3vw;\n            line-height: 4vw; }\n          .main_wrapper .page.game .results_overlay .content .thresholdMsg {\n            font-size: 2vw; }\n          .main_wrapper .page.game .results_overlay .content .bonusRoundMsg {\n            font-size: 2.5vw; }\n          .main_wrapper .page.game .results_overlay .content .nextBtn {\n            width: 30vw;\n            height: 6vw;\n            font-size: 3vw;\n            line-height: 6vw;\n            margin: 3vw auto 0 auto; }\n        .main_wrapper .page.game .bonusResults_overlay .content {\n          width: 85vw; }\n          .main_wrapper .page.game .bonusResults_overlay .content .leftColumn {\n            height: 45vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .logo {\n              background-position-y: -1.7vw;\n              width: 21vw;\n              left: 3vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .affiliateLogo {\n              left: 6vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .tuneIn {\n              top: 18vw;\n              left: 3.8vw;\n              font-size: 2.5vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .host {\n              width: 24vw;\n              background-size: auto 34vw;\n              bottom: -4.2vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .socialWrapper {\n              bottom: 1vw;\n              left: 5.7vw; }\n              .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .socialWrapper .label {\n                font-size: 1.7vw; }\n              .main_wrapper .page.game .bonusResults_overlay .content .leftColumn .socialWrapper .fab {\n                font-size: 3.5vw;\n                margin: .7vw; }\n          .main_wrapper .page.game .bonusResults_overlay .content .rightColumn {\n            height: 49vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .line1 {\n              font-size: 3vw;\n              margin: 1vw 0 0 0;\n              line-height: 3.6vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .line2 {\n              font-size: 2.3vw;\n              line-height: 3vw;\n              margin: 1.5vw auto; }\n            .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .line3 {\n              font-size: 2.3vw; }\n            .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .buttonsWrapper {\n              margin: 3vw 0 0 0; }\n              .main_wrapper .page.game .bonusResults_overlay .content .rightColumn .buttonsWrapper .button {\n                font-size: 2.2vw;\n                padding: 1vw;\n                margin: 1.5vw auto; }\n          .main_wrapper .page.game .bonusResults_overlay .content .f-logo-container {\n            font-size: 2vw;\n            padding: 1em 1em 1em 0; }\n            .main_wrapper .page.game .bonusResults_overlay .content .f-logo-container img {\n              width: 5vw; } }\n\n#confetti {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0; }\n  #confetti canvas {\n    width: 100%;\n    height: 100%; }\n\n#header {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-image: url(" + __webpack_require__(38) + ");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center; }\n  #header .wipe {\n    width: 100%;\n    height: 0%;\n    background-color: #ffffff;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  #header .logo {\n    width: calc(45vw - 1.6rem);\n    height: 19vw;\n    position: absolute;\n    background-color: transparent;\n    top: 4vw;\n    left: 7vw;\n    background-image: url(" + __webpack_require__(17) + ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center -2.7vw; }\n  #header .playBtn {\n    width: calc(45vw - 1.6rem);\n    height: 5vw;\n    position: absolute;\n    background-color: #ffffff;\n    top: 25.5vw;\n    left: 7vw;\n    color: #dd1834;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    font-weight: bold;\n    text-align: center;\n    font-size: 3vw;\n    line-height: 5.2vw;\n    border-radius: .6vw;\n    cursor: pointer; }\n    #header .playBtn .fa-caret-right {\n      font-size: 4vw;\n      right: 2.5vw;\n      line-height: 5.2vw;\n      position: absolute;\n      pointer-events: none; }\n  #header .loginBtn {\n    width: calc(45vw - 1.6rem);\n    height: 4vw;\n    position: absolute;\n    background-color: #ffffff;\n    top: 33vw;\n    left: 7vw;\n    color: #dd1834;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    text-align: center;\n    font-size: 2vw;\n    line-height: 4vw;\n    border-radius: .6vw;\n    cursor: pointer; }\n  #header .legalText {\n    width: calc(92vw - 1.6rem);\n    height: 4vw;\n    position: absolute;\n    bottom: 0;\n    left: 2vw;\n    color: #fff;\n    font-family: arial;\n    font-size: .9vw;\n    border-radius: .6vw;\n    z-index: 1;\n    cursor: pointer; }\n    #header .legalText a {\n      color: #fff; }\n  #header .host {\n    width: calc(40vw - 1.6rem * 2);\n    height: 100%;\n    position: absolute;\n    background-color: transparent;\n    bottom: 0vw;\n    left: calc(57vw - 1.6rem);\n    background-image: url(" + __webpack_require__(108) + ");\n    background-size: 25vw;\n    background-repeat: no-repeat;\n    background-position: center bottom; }\n  #header .socialWrapper {\n    width: auto;\n    height: auto;\n    position: absolute;\n    top: .3vw;\n    right: .5vw; }\n    #header .socialWrapper .fab {\n      color: #edeff4;\n      font-size: 2.5vw;\n      margin: .5vw;\n      transition: 300ms;\n      -webkit-transition: 300ms;\n      cursor: pointer; }\n      #header .socialWrapper .fab:hover {\n        color: #ffffff;\n        transform: scale(1.08);\n        -webkit-transform: scale(1.08); }\n  #header .hide {\n    display: none; }\n  #header.hoverActive .playBtn {\n    transition: 300ms;\n    -webkit-transition: 300ms; }\n    #header.hoverActive .playBtn:hover {\n      font-size: 3.1vw;\n      background-color: #dd1834;\n      color: #ffffff; }\n  #header.hoverActive .loginBtn {\n    transition: 300ms;\n    -webkit-transition: 300ms; }\n    #header.hoverActive .loginBtn:hover {\n      font-size: 2.1vw;\n      background-color: #dd1834;\n      color: #ffffff; }\n  @media (max-width: 768px) {\n    #header {\n      overflow: hidden;\n      height: auto; }\n      #header .host {\n        display: none; }\n      #header .logo {\n        background-position-y: -5.2vw;\n        width: 63vw;\n        height: 48vw;\n        position: relative;\n        top: 0;\n        left: 0;\n        margin: 4vw auto 0; }\n      #header .playBtn {\n        height: 6vw;\n        position: relative;\n        top: 0;\n        left: 0;\n        margin: 0 auto;\n        width: 80vw;\n        line-height: 6.5vw; }\n        #header .playBtn .fa-caret-right {\n          line-height: 6vw; }\n      #header .loginBtn {\n        height: 6vw;\n        position: relative;\n        top: 0;\n        left: 0;\n        margin: 1vw auto 4vw auto;\n        width: 80vw;\n        line-height: 6vw; }\n      #header .legalText {\n        font-size: 2vw;\n        height: 17.5vw;\n        position: relative;\n        top: 0;\n        left: 0;\n        margin: 3vw auto 4vw auto;\n        width: 80vw; }\n      #header .play1QQBtn {\n        display: none; }\n      #header .socialWrapper .fab {\n        font-size: 5vw;\n        margin: 1vw; } }\n\n#game {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden; }\n  #game .correctAnswerCue {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: lime;\n    opacity: 0;\n    pointer-events: none;\n    z-index: 100; }\n  #game .wrongAnswerCue {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: red;\n    opacity: 0;\n    pointer-events: none;\n    z-index: 100; }\n  #game .hint {\n    width: 100%;\n    height: auto;\n    text-align: center;\n    position: absolute;\n    bottom: 3vw;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    font-size: 1.5vw;\n    font-style: italic;\n    color: #ffff39; }\n  #game .questionBox {\n    width: calc(80% - 2vw);\n    height: auto;\n    padding: 2vw;\n    margin: 2vw auto;\n    text-align: center;\n    background-color: #dd1834;\n    border: .3vw solid #ffff39;\n    color: #ffffff;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    font-weight: bold;\n    font-size: 2vw; }\n  #game .answers_wrapper {\n    width: 90%;\n    height: auto;\n    text-align: center;\n    position: absolute;\n    top: 13vw;\n    left: 50%;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    background-color: transparent;\n    overflow: hidden; }\n    #game .answers_wrapper.readOnly {\n      pointer-events: none; }\n      #game .answers_wrapper.readOnly .field_wrapper {\n        pointer-events: none; }\n        #game .answers_wrapper.readOnly .field_wrapper .field {\n          pointer-events: none; }\n    #game .answers_wrapper .field_wrapper {\n      width: calc(50% - 6vw);\n      height: auto;\n      margin: 1.5vw 3vw;\n      display: inline-block; }\n      #game .answers_wrapper .field_wrapper .field {\n        width: auto;\n        height: 3vw;\n        font-family: \"AvenirNextLTPro-HeavyIt\";\n        font-weight: bold;\n        color: #ffffff;\n        font-size: 2.2vw;\n        border: none;\n        background-color: transparent;\n        display: inline-block; }\n        #game .answers_wrapper .field_wrapper .field.readOnly {\n          pointer-events: none; }\n      #game .answers_wrapper .field_wrapper:first-child {\n        width: calc(100% - 6vw);\n        display: block; }\n        #game .answers_wrapper .field_wrapper:first-child .field {\n          width: auto;\n          font-size: 3vw;\n          display: block;\n          margin: 1.5vw auto; }\n  @media (max-width: 768px) {\n    #game {\n      height: 75vw; }\n      #game .questionBox {\n        font-size: 3.7vw;\n        margin: 4vw auto; }\n      #game .answers_wrapper {\n        top: 23vw; }\n        #game .answers_wrapper .field_wrapper .field {\n          font-size: 2.7vw;\n          margin: 2vw auto; }\n        #game .answers_wrapper .field_wrapper:first-child .field {\n          font-size: 4vw;\n          height: auto; }\n      #game .hint {\n        font-size: 2vw;\n        bottom: 2vw; } }\n\n#bonusGame {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden; }\n  #bonusGame .correctAnswerCue {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: lime;\n    opacity: 0;\n    pointer-events: none;\n    z-index: 100; }\n  #bonusGame .wrongAnswerCue {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: red;\n    opacity: 0;\n    pointer-events: none;\n    z-index: 100; }\n  #bonusGame .hint {\n    width: 100%;\n    height: auto;\n    text-align: center;\n    position: absolute;\n    bottom: 3vw;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    font-size: 1.5vw;\n    font-style: italic;\n    color: #ffff39; }\n  #bonusGame .skipBtn {\n    width: 10vw;\n    height: 10vw;\n    position: absolute;\n    top: 14vw;\n    right: 4vw;\n    background-color: #dd1834;\n    color: #ffffff;\n    padding: 0vw;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    font-size: 2.4vw;\n    font-weight: bold;\n    line-height: 10vw;\n    border-radius: 100vw;\n    border: .3vw solid #ffff39;\n    text-align: center;\n    cursor: pointer;\n    transition: 300ms;\n    -webkit-transition: 300ms; }\n    #bonusGame .skipBtn:hover {\n      background-color: #ffffff;\n      color: #dd1834;\n      font-size: 1.5vw; }\n  #bonusGame .bonusSet {\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 0; }\n    #bonusGame .bonusSet.show {\n      opacity: 1;\n      pointer-events: auto;\n      position: relative; }\n    #bonusGame .bonusSet .questionBox {\n      width: calc(80% - 2vw);\n      height: auto;\n      padding: 2vw;\n      margin: 2vw auto;\n      text-align: center;\n      background-color: #dd1834;\n      border: .3vw solid #ffff39;\n      color: #ffffff;\n      font-family: \"AvenirNextLTPro-HeavyIt\";\n      font-weight: bold;\n      font-size: 2vw; }\n    #bonusGame .bonusSet .answers_wrapper {\n      width: 90%;\n      height: auto;\n      text-align: left;\n      position: relative;\n      margin: 0vw auto 0;\n      background-color: transparent;\n      overflow: hidden; }\n      #bonusGame .bonusSet .answers_wrapper.readOnly {\n        pointer-events: none; }\n        #bonusGame .bonusSet .answers_wrapper.readOnly .field_wrapper {\n          pointer-events: none; }\n          #bonusGame .bonusSet .answers_wrapper.readOnly .field_wrapper .field {\n            pointer-events: none; }\n      #bonusGame .bonusSet .answers_wrapper .field_wrapper {\n        width: calc(50% - 6vw);\n        height: auto;\n        margin: 2vw 3vw;\n        display: block; }\n        #bonusGame .bonusSet .answers_wrapper .field_wrapper .field {\n          width: auto;\n          height: 3vw;\n          font-family: \"AvenirNextLTPro-HeavyIt\";\n          font-weight: bold;\n          color: #ffffff;\n          font-size: 2.5vw;\n          border: none;\n          background-color: transparent;\n          display: inline-block; }\n          #bonusGame .bonusSet .answers_wrapper .field_wrapper .field.readOnly {\n            pointer-events: none; }\n  @media (max-width: 768px) {\n    #bonusGame {\n      height: 80vw; }\n      #bonusGame .bonusSet .questionBox {\n        font-size: 3.7vw;\n        margin: 4vw auto 0; }\n      #bonusGame .bonusSet .answers_wrapper {\n        margin: 3vw auto 0; }\n        #bonusGame .bonusSet .answers_wrapper .field_wrapper .field {\n          height: 4vw;\n          font-size: 4vw;\n          margin: 2vw auto; }\n      #bonusGame .hint {\n        position: absolute;\n        bottom: 2vw;\n        font-size: 2vw; }\n      #bonusGame .skipBtn {\n        width: 13vw;\n        height: 13vw;\n        top: 27vw;\n        font-size: 2vw;\n        line-height: 13vw;\n        right: 6vw; }\n        #bonusGame .skipBtn:hover {\n          font-size: 2.1vw; } }\n\n#sidebar {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  font-family: \"AvenirNextLTPro-HeavyIt\";\n  background-color: #dd1834; }\n  #sidebar .logo {\n    display: none; }\n  #sidebar .label {\n    color: #ffffff;\n    font-size: 1.2vw;\n    margin: 1vw 0vw 0vw 0vw; }\n  #sidebar .value {\n    color: #ffff39;\n    font-size: 2.3vw;\n    font-weight: bold; }\n  #sidebar .round {\n    font-size: 2vw;\n    font-weight: bold;\n    color: #ffffff;\n    margin: 1.3vw 0vw;\n    line-height: 1.8vw; }\n  #sidebar .score {\n    font-size: 1.4vw;\n    margin: 1vw auto; }\n  #sidebar .timer {\n    font-size: 1.4vw;\n    margin: 1vw auto; }\n    #sidebar .timer .remaining {\n      width: 12vw;\n      height: auto;\n      border: 1px solid #333333;\n      margin: .3vw auto;\n      padding: .5vw;\n      font-size: 2vw; }\n  #sidebar .needMoreTimeBtn {\n    width: auto;\n    height: auto;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    font-size: 1.2vw;\n    padding: .5vw 1vw;\n    background-color: #f1dd01;\n    color: #2364ce;\n    position: absolute;\n    bottom: 25.8vw;\n    left: 50%;\n    border-radius: 1vw;\n    white-space: nowrap;\n    text-align: center;\n    cursor: pointer;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    transition: 300ms;\n    -webkit-transition: 300ms; }\n    #sidebar .needMoreTimeBtn:hover {\n      background-color: #2364ce;\n      color: #ffffff; }\n  #sidebar .ad {\n    cursor: pointer;\n    width: 100%;\n    height: 25vw;\n    background-color: #e2e2e2;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    padding: 1vw;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    background-image: url(" + __webpack_require__(109) + ");\n    background-size: cover;\n    background-position: top center;\n    background-repeat: no-repeat; }\n    #sidebar .ad .affiliateLogo {\n      margin-top: 3.5vw;\n      width: 10vw; }\n  @media (max-width: 768px) {\n    #sidebar {\n      text-align: left;\n      background-color: #0341ef; }\n      #sidebar .logo {\n        width: 25vw;\n        height: 18vw;\n        background-image: url(" + __webpack_require__(17) + ");\n        background-size: contain;\n        background-position: center -2.1vw;\n        background-repeat: no-repeat;\n        position: absolute;\n        left: 2vw;\n        top: 1.5vw;\n        display: block; }\n      #sidebar .label {\n        font-size: 2.2vw;\n        margin: 2.5vw 3vw 0 0;\n        text-align: right; }\n        #sidebar .label .value {\n          font-size: 3.3vw; }\n      #sidebar .round {\n        width: 100%;\n        text-align: center;\n        position: absolute;\n        top: 6vw;\n        left: 2vw;\n        font-size: 4vw; }\n      #sidebar .score {\n        position: absolute;\n        top: 6vw;\n        left: 27vw;\n        font-size: 4vw; }\n      #sidebar .timer {\n        position: absolute;\n        top: 11vw;\n        left: 27vw;\n        font-size: 4vw; }\n        #sidebar .timer .remaining {\n          width: 17vw;\n          display: inline-block;\n          font-size: 3.5vw;\n          text-align: center;\n          left: 2vw;\n          position: relative; }\n      #sidebar .needMoreTimeBtn {\n        bottom: 2vw;\n        font-size: 3vw;\n        padding: 1vw 3vw;\n        left: calc(50% + 2vw);\n        border-radius: 2vw; }\n      #sidebar .ad {\n        display: none; } }\n\n#ranking {\n  width: 100%;\n  height: auto;\n  position: relative;\n  background-image: url(" + __webpack_require__(39) + ");\n  background-size: 100% auto;\n  background-repeat: repeat-y;\n  background-position: center;\n  overflow: hidden; }\n  #ranking .wipe {\n    width: 0%;\n    height: 100%;\n    background-color: #ffffff;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  #ranking .header {\n    width: 100%;\n    height: 12vw;\n    margin: 3vw 0vw 2vw 0vw;\n    background-image: url(" + __webpack_require__(110) + ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center bottom;\n    position: relative; }\n  #ranking .text {\n    padding: 3vw;\n    font-size: 3vw;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    color: #ffffff;\n    margin: 0 0 3vw 0;\n    text-align: center;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box; }\n  @media (max-width: 768px) {\n    #ranking .header {\n      height: 22vw;\n      margin: 6vw 0 5vw 0; }\n    #ranking .text {\n      font-size: 6vw; } }\n\n#leaderboard {\n  width: 100%;\n  height: auto;\n  position: relative;\n  background-image: url(" + __webpack_require__(39) + ");\n  background-size: 100% auto;\n  background-repeat: repeat-y;\n  background-position: center; }\n  #leaderboard .wipe {\n    width: 0%;\n    height: 100%;\n    background-color: #ffffff;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  #leaderboard .header {\n    width: 100%;\n    height: 8vw;\n    margin: 0vw 0vw 3vw 0vw;\n    background-image: url(" + __webpack_require__(111) + ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center bottom; }\n  #leaderboard .month-header {\n    font-size: 4.5vw;\n    text-align: center;\n    text-transform: uppercase; }\n  #leaderboard .content {\n    padding: 3vw;\n    font-size: 2.4vw;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    color: #ffffff;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box; }\n    #leaderboard .content table tr {\n      height: 5.5vw; }\n      #leaderboard .content table tr td:nth-child(1) {\n        width: 29vw;\n        text-align: left; }\n      #leaderboard .content table tr td:nth-child(2) {\n        width: 12vw;\n        text-align: right; }\n  @media (max-width: 768px) {\n    #leaderboard .month-header {\n      font-size: 8vw; }\n    #leaderboard .header {\n      height: 14vw;\n      margin: 0 0 4vw 0; }\n    #leaderboard .content {\n      font-size: 5vw;\n      padding: 4vw; }\n      #leaderboard .content table tr {\n        height: 9vw; }\n        #leaderboard .content table tr td:nth-child(1) {\n          width: 70vw;\n          text-align: left; }\n        #leaderboard .content table tr td:nth-child(2) {\n          width: 12vw;\n          text-align: right; } }\n\n#videoOverlay {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 5000;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.9); }\n  #videoOverlay .text {\n    width: 100%;\n    height: auto;\n    padding: .5vw 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    text-align: center;\n    font-family: arial;\n    font-size: 1.2vw;\n    color: #f8ff30; }\n  #videoOverlay .video-player {\n    width: 90vw;\n    height: 38vw;\n    position: absolute;\n    background-color: #000000;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%); }\n  #videoOverlay .closeBtn {\n    padding: .3vw 1vw;\n    font-size: 2vw;\n    font-family: arial;\n    color: #ffffff;\n    text-align: center;\n    position: absolute;\n    top: 0;\n    right: 0;\n    cursor: pointer;\n    transition: 300ms;\n    -webkit-transition: 300ms; }\n    #videoOverlay .closeBtn:hover {\n      color: #dd1834; }\n  #videoOverlay .skipCountdown {\n    padding: 1vw 1vw;\n    font-size: 1.2vw;\n    font-family: arial;\n    color: #ffffff;\n    text-align: center;\n    position: absolute;\n    top: 0;\n    right: 0; }\n  @media (max-width: 768px) {\n    #videoOverlay .closeBtn {\n      font-size: 5vw;\n      padding: 1vw 2vw; }\n    #videoOverlay .text {\n      font-size: 2vw; }\n    #videoOverlay .skipCountdown {\n      font-size: 2vw; } }\n\n#tuneIn {\n  width: 100%;\n  height: 26vw;\n  position: relative;\n  background-image: url(" + __webpack_require__(112) + ");\n  background-size: cover;\n  background-repeat: repeat-y;\n  background-position: center;\n  overflow: hidden; }\n  #tuneIn .wipe {\n    width: 0%;\n    height: 100%;\n    background-color: #ffffff;\n    position: absolute;\n    top: 0;\n    left: 0; }\n  #tuneIn .tuneIn {\n    width: 16vw;\n    height: 16vw;\n    background-image: url(" + __webpack_require__(113) + ");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center -2vw;\n    position: absolute;\n    top: 7vw;\n    left: 3vw; }\n  #tuneIn .affiliateLogo {\n    margin: 15vw 0 0 3vw;\n    width: 10vw; }\n  #tuneIn .host {\n    width: 30vw;\n    height: 100%;\n    background-image: url(" + __webpack_require__(114) + ");\n    background-size: auto 24vw;\n    background-repeat: no-repeat;\n    background-position: bottom center;\n    position: absolute;\n    bottom: 0;\n    right: 0; }\n  #tuneIn .dvrBtn {\n    width: auto;\n    height: auto;\n    position: absolute;\n    background-color: #ffffff;\n    top: 20vw;\n    left: 3vw;\n    color: #dd1834;\n    font-family: \"AvenirNextLTPro-HeavyIt\";\n    font-weight: bold;\n    text-align: center;\n    font-size: 1.5vw;\n    padding: 1vw 4vw;\n    text-decoration: none;\n    border-radius: .6vw;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: 300ms;\n    -webkit-transition: 300ms; }\n    #tuneIn .dvrBtn .fa-caret-right {\n      font-size: 2vw;\n      right: 1.6vw;\n      line-height: 1.9vw;\n      position: absolute;\n      pointer-events: none; }\n    #tuneIn .dvrBtn:hover {\n      background-color: #dd1834;\n      color: #ffffff; }\n  @media (max-width: 768px) {\n    #tuneIn {\n      height: 30vw; }\n      #tuneIn .tuneIn {\n        width: 27vw;\n        height: 100%;\n        top: 4vw;\n        left: 13vw;\n        background-position-y: -3vw; }\n      #tuneIn .host {\n        width: 50vw;\n        height: 100%;\n        background-size: auto 28vw;\n        bottom: 0;\n        right: 4vw; }\n      #tuneIn .dvrBtn {\n        top: 23vw;\n        left: 15vw; }\n      #tuneIn .affiliateLogo {\n        margin: 20vw 0 0 14vw;\n        width: 15vw; } }\n\n#landingVideo {\n  width: 100%;\n  height: 26vw;\n  position: relative;\n  overflow: hidden; }\n  #landingVideo .wipe {\n    width: 0%;\n    height: 100%;\n    background-color: #ffffff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1000; }\n  #landingVideo .video-player {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    background-color: #000000;\n    top: 0;\n    left: 0;\n    z-index: 1; }\n  #landingVideo .poster {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-image: url(" + __webpack_require__(115) + ");\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    z-index: 100;\n    transition: 300ms;\n    -webkit-transition: 300ms;\n    -webkit-backface-visibility: hidden;\n    cursor: pointer; }\n    #landingVideo .poster .playBtn {\n      width: 8vw;\n      height: 8vw;\n      position: absolute;\n      top: 16vw;\n      left: 5vw;\n      background-image: url(" + __webpack_require__(116) + ");\n      background-position: center;\n      background-size: contain;\n      background-repeat: no-repeat;\n      overflow: hidden; }\n      #landingVideo .poster .playBtn .playArrow {\n        width: 4vw;\n        height: 4vw;\n        position: absolute;\n        top: 2vw;\n        left: 2.3vw;\n        color: red;\n        background-image: url(" + __webpack_require__(117) + "#svgBtnCtaRightArrow);\n        background-position: center;\n        background-size: contain;\n        background-repeat: no-repeat; }\n    #landingVideo .poster:hover {\n      transform: scale(1.02);\n      -webkit-transform: scale(1.02); }\n      #landingVideo .poster:hover .playBtn {\n        opacity: 1; }\n  @media (max-width: 768px) {\n    #landingVideo {\n      margin-top: 0.8rem;\n      height: 46vw; }\n      #landingVideo .poster .playBtn {\n        width: 15vw;\n        height: 15vw;\n        top: 28vw;\n        left: 11vw; }\n        #landingVideo .poster .playBtn .playArrow {\n          width: 8vw;\n          height: 8vw;\n          top: 3.5vw;\n          left: 4vw; } }\n", ""]);

// exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/AvenirNextLTPro-HeavyIt.3bf18432.woff";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/AvenirNextLTPro-HeavyIt.0d647f24.ttf";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/instructionsThumb.d02d79a0.jpg";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/showHost2.2a9d7a1a.png";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/game_bg5.d55facc1.jpg";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/showHost3.dc3b1017.png";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/showHost.40ff8222.png";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ad-syndication.c9598f1e.jpg";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ranking_header.7739b2bd.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/leaderboard_header.8b911670.png";

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tunein_tunein.fbcaba9e.png";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tunein_host.08473c47.png";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/landingVideoThumb2.7d8c4aed.jpg";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/btn_video_bg.88be8abb.svg";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/btn_cta_right_arrow.a816c8ea.svg";

/***/ }),
/* 118 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Btn=function Btn(_ref){var _onClick=_ref.onClick,btnRef=_ref.btnRef,btnClassName=_ref.btnClassName,label=_ref.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:btnClassName,ref:btnRef,onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();},onClick:function onClick(){return _onClick();}},label);};Btn.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,btnRef:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,btnClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Btn);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(121);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(40)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-2-2!./FooterLogo.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js??ref--1-oneOf-2-2!./FooterLogo.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(36)(undefined);
// imports


// module
exports.push([module.i, ".f-logo-container {\n  bottom: 0;\n  color: #fff;\n  font: 10px \"AvenirNextLTPro-HeavyIt\", arial;\n  right: 0;\n  text-align: right;\n  padding: 1em 1em 2em 0;\n  position: absolute; }\n  .f-logo-container img {\n    margin-left: .5em;\n    vertical-align: middle;\n    width: 5vw; }\n\n@media (max-width: 768px) {\n  .f-logo-container {\n    display: none; } }\n", ""]);

// exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_analytics__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EXTERNAL_LINK='https://vupulse.com/c/3232';var TuneIn=function(_Component){_inherits(TuneIn,_Component);function TuneIn(props){_classCallCheck(this,TuneIn);var _this=_possibleConstructorReturn(this,(TuneIn.__proto__||Object.getPrototypeOf(TuneIn)).call(this,props));_this.transitionIn=new window.TimelineMax();_this.state={};return _this;}_createClass(TuneIn,[{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.wipe,{"width":"100%"});window.TweenMax.set(this.refs.host,{"height":"0%"});window.TweenMax.set(this.refs.tuneIn,{"alpha":"0","transform":"translateY(1vw)"});// window.TweenMax.set(this.refs.dvrBtn, {"alpha":"0", "transform":"translateY(1vw)"});
this.transitionIn.to(this.refs.wipe,.4,{"width":"0%"}).to(this.refs.host,.5,{"height":"100%"},"-=.2").to(this.refs.tuneIn,.5,{"alpha":"1","transform":"translateY(0vw)"},"-=.2");// .to(this.refs.dvrBtn, .5, {"alpha":"1", "transform":"translateY(0vw)"}, "-=.2");
}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.landingTransitionOut===true&&prevProps.landingTransitionOut===false){this.transitionIn.reverse();}}},{key:'handleClick',value:function handleClick(evt){evt.preventDefault();evt.stopPropagation();Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["a" /* trackingWrapper */])('event','ASGame-external-link',{'event_label':'vupulse','event_category':'america-says-game'});window.open(EXTERNAL_LINK,'_blank');}},{key:'render',value:function render(){var affiliate=this.props.affiliate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tuneIn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tuneIn',ref:'tuneIn'}),affiliate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'affiliateLogo',src:"images/"+affiliate.imgName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'host',ref:'host'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wipe',ref:'wipe'}));}}]);return TuneIn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{affiliate:state.affiliate};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setAffiliate:function setAffiliate(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["setAffiliate"])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TuneIn));

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_gsntv__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scss_App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Leaderboard=function(_Component){_inherits(Leaderboard,_Component);function Leaderboard(props){_classCallCheck(this,Leaderboard);var _this=_possibleConstructorReturn(this,(Leaderboard.__proto__||Object.getPrototypeOf(Leaderboard)).call(this,props));_this.transitionIn=new window.TimelineMax();_this.state={};return _this;}_createClass(Leaderboard,[{key:'componentDidMount',value:function componentDidMount(){// twweens
window.TweenMax.set(this.refs.wipe,{"width":"100%"});window.TweenMax.set(this.refs.header,{"alpha":"0","transform":"translateY(1vw)"});window.TweenMax.set(this.refs.content,{"alpha":"0","transform":"translateY(1vw)"});this.transitionIn.to(this.refs.wipe,.4,{"width":"0%",delay:.2}).to(this.refs.header,.5,{"alpha":"1","transform":"translateY(0vw)"},"-=.2").to(this.refs.content,.5,{"alpha":"1","transform":"translateY(0vw)"},"-=.2");}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.landingTransitionOut===true&&prevProps.landingTransitionOut===false){this.transitionIn.reverse();}}},{key:'render',value:function render(){console.log("Leaderboard :: render redux props",this.props.user);var highScoreData=Object(__WEBPACK_IMPORTED_MODULE_2__utils_gsntv__["c" /* isIframed */])()?window.highScores.scores:window.leaderboard.leaderboard;var month=Object(__WEBPACK_IMPORTED_MODULE_2__utils_gsntv__["c" /* isIframed */])()?window.highScores.month:'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'leaderboard',ref:'leaderboard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'month-header'},month),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header',ref:'header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{ref:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,highScoreData.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,index+1,'. ',item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* numberWithCommas */])(item.score)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wipe',ref:'wipe'}));}}]);return Leaderboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Leaderboard);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__game_Game__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidebar_SideBar__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__game_BonusGame__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instructions_InstructionsOverlay__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instructions_BonusInstructionsOverlay__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__results_ResultsOverlay__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__results_FinalResultsOverlay__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__results_BonusResultsOverlay__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__results_BeforeResultsOverlay__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ads_RewardAdContainer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_analytics__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GamePage=function(_Component){_inherits(GamePage,_Component);function GamePage(props){_classCallCheck(this,GamePage);var _this2=_possibleConstructorReturn(this,(GamePage.__proto__||Object.getPrototypeOf(GamePage)).call(this,props));_this2.totalRoundDurationInSeconds=window.config.roundTimer;_this2.totalBonusRoundDurationInSeconds=window.config.bonusRoundTimer;_this2.totalRounds=window.config.rounds.length;_this2.roundsData=[].concat(_toConsumableArray(window.config.rounds));_this2.timer=null;_this2.showAdAfterThisManyGames=window.config.videoAd.showAdAfterThisManyGames;_this2.state={showInstructions:true,showBonusInstructions:false,hasReachedBonusRound:false,questionSet:null,totalAnswers:null,totalAnsweredCorrect:0,currentRound:0,showBeforeResults:false,showRoundResults:false,showFinalResults:false,showBonusResults:false,uniqueID:0,bonusQuestionSets:[],timerMsg:"00:00",timerRemaining:_this2.totalRoundDurationInSeconds,showAnswers:false,roundPoints:0,totalPoints:0,roundIsStarted:false,blurGame:true,showVideoAd:false,videoAdId:0,videoAdCallback:null,gamePlays:1,showNeedMoreTimeBtn:false,needMoreTimeBtnHasWatchedThisRound:false,replayCount:0};_this2.handleCorrectAnswer=_this2.handleCorrectAnswer.bind(_this2);_this2.handleNextRound=_this2.handleNextRound.bind(_this2);_this2.handlePlayAgainBtn=_this2.handlePlayAgainBtn.bind(_this2);_this2.handleLoginBtn=_this2.handleLoginBtn.bind(_this2);_this2.handleLeaderboardBtn=_this2.handleLeaderboardBtn.bind(_this2);_this2.handleVideoOverlayClose=_this2.handleVideoOverlayClose.bind(_this2);_this2.handleVideoAdCloseFromGamePlays=_this2.handleVideoAdCloseFromGamePlays.bind(_this2);_this2.handleAnswerRevealComplete=_this2.handleAnswerRevealComplete.bind(_this2);_this2.handleNeedMoreTimeBtnClick=_this2.handleNeedMoreTimeBtnClick.bind(_this2);_this2.handleVideoAdCloseFromNeedMoreTime=_this2.handleVideoAdCloseFromNeedMoreTime.bind(_this2);_this2.handleFinalResultVideoAdClose=_this2.handleVideoAdCloseFinalResult.bind(_this2);_this2.handleBeforeResults=_this2.handleBeforeResultsClick.bind(_this2);_this2.handleGiveUp=_this2.handleGiveUp.bind(_this2);_this2.gameTimerTick=_this2.gameTimerTick.bind(_this2);_this2.initRound=_this2.initRound.bind(_this2);_this2.initBonusRound=_this2.initBonusRound.bind(_this2);return _this2;}_createClass(GamePage,[{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.to(this.refs.wipe,.5,{"height":"0%"});}},{key:'initRound',value:function initRound(){//console.log("----------- GamePage :: initRound");
window.sounds.startButtonClick.play();this.setState({currentRound:this.state.currentRound+1,showInstructions:false,showRoundResults:false,timerMsg:this.formatTimeFromSeconds(this.totalRoundDurationInSeconds),timerRemaining:this.totalRoundDurationInSeconds,roundPoints:0,roundIsStarted:true,needMoreTimeBtnHasWatchedThisRound:false,showNeedMoreTimeBtn:false});var _this=this;setTimeout(function(){_this.initRandomQuestion();_this.startGameTimer();_this.setState({blurGame:false});},10);//tracking
Object(__WEBPACK_IMPORTED_MODULE_13__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-round-'+(this.state.currentRound+1)+'-start',{'event_category':'america-says-game'});if(this.state.currentRound===0){Object(__WEBPACK_IMPORTED_MODULE_13__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-total-plays',{'event_category':'america-says-game'});}}},{key:'initBonusRound',value:function initBonusRound(){//console.log("============ GamePage :: initBonusRound");
window.sounds.startButtonClick.play();this.setState({currentRound:this.state.currentRound+1,showBonusInstructions:false,timerMsg:this.formatTimeFromSeconds(this.totalBonusRoundDurationInSeconds),timerRemaining:this.totalBonusRoundDurationInSeconds,roundIsStarted:true,roundPoints:0,needMoreTimeBtnHasWatchedThisRound:false,showNeedMoreTimeBtn:false});var _this=this;setTimeout(function(){_this.initBonusQuestions();_this.startGameTimer();_this.setState({blurGame:false});},10);//tracking
Object(__WEBPACK_IMPORTED_MODULE_13__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-bonus-round-start',{'event_category':'america-says-game'});}},{key:'initBonusQuestions',value:function initBonusQuestions(){var bonusQuestions=[];var totalSets=window.config.bonusRound.sets.length;var count=0;//console.log("GamePage :: initBonusQuestions - totalSets", totalSets);
// loop thru pool to find x sets of bonus questions, if not enough, reset the pool with full list
var _loop=function _loop(){var set=window.config.bonusRound.sets[count].answers;bonusQuestionsPool=window.bonusQuestionsPool[set];//console.log("============ GamePage :: initBonusQuestions - set: ", set);
//console.log("GamePage :: initBonusQuestions - bonusQuestionsPool: ", bonusQuestionsPool);
// get random question
var bonusQuestionSet=bonusQuestionsPool[Math.floor(Math.random()*bonusQuestionsPool.length)];// add random question to the set array
bonusQuestions.push(bonusQuestionSet);// update pool by removing the randomly chosen one
var newQuestions=[].concat(_toConsumableArray(bonusQuestionsPool.filter(function(x){return x!==bonusQuestionSet;})));// if pool is empty, reset the pool with full list
if(newQuestions.length===0){window.bonusQuestionsPool[set]=[].concat(_toConsumableArray(window.bonusQuestions[set]));// if list is more than 1, remove the selected so it doesn't get chosen back to back
if(window.bonusQuestions[set].length>1){window.bonusQuestionsPool[set]=[].concat(_toConsumableArray(window.bonusQuestionsPool[set].filter(function(x){return x!==bonusQuestionSet;})));}}else{bonusQuestionsPool=[].concat(_toConsumableArray(newQuestions));}count++;};while(bonusQuestions.length<totalSets){var bonusQuestionsPool;_loop();}//console.log("GamePage :: initBonusQuestions - bonusQuestions = ", bonusQuestions);
this.setState({bonusQuestionSets:bonusQuestions,uniqueID:this.state.uniqueID+1});}},{key:'initRandomQuestion',value:function initRandomQuestion(){//console.log("-----------------------------------------------");
//console.log("GamePage :: initRandomQuestion - round: ", this.state.currentRound);
var difficulty=window.config.rounds[this.state.currentRound-1].difficulty;var questionsPool=window.questionsPool[difficulty];//console.log("GamePage :: initRandomQuestion - difficulty: ", difficulty);
//console.log("GamePage :: initRandomQuestion - start questionsPool ######: ", questionsPool);
// get random question
var questionSet=questionsPool[Math.floor(Math.random()*questionsPool.length)];//console.log("GamePage :: initRandomQuestion - questionSet chosen: ", questionSet);
// remove chosen question from pool
var newQuestionsPool=[].concat(_toConsumableArray(questionsPool.filter(function(x){return x!==questionSet;})));//console.log("GamePage :: initRandomQuestion - new pool: ", newQuestionsPool);
// if pool is empty, reset the pool with full list
if(newQuestionsPool.length===0){window.questionsPool[difficulty]=[].concat(_toConsumableArray(window.questions[difficulty]));// if list is more than 1, remove the selected so it doesn't get chosen back to back
if(window.questions[difficulty].length>1){window.questionsPool[difficulty]=[].concat(_toConsumableArray(window.questionsPool[difficulty].filter(function(x){return x!==questionSet;})));}}else{window.questionsPool[difficulty]=[].concat(_toConsumableArray(newQuestionsPool));}//
/*
		console.log("=======================");
		console.log("GamePage :: initRandomQuestion - parsed data : ", (this.parseAnswersOrder(questionSet)));
		console.log("----------");
		console.log("GamePage :: initRandomQuestion - double check - window.questionsPool[easy]: ", window.questionsPool["easy"]);
		*/this.setState({questionSet:this.parseAnswersOrder(questionSet),totalAnswers:questionSet.answers.length,totalAnsweredCorrect:0,uniqueID:this.state.uniqueID+1});}},{key:'parseAnswersOrder',value:function parseAnswersOrder(questionSet){//console.log("GamePage :: parseAnswersOrder - questionSet : ", questionSet);
var newQuestionSet=Object.assign({},questionSet);var answers=newQuestionSet.answers;var newAnswersOrder=[];newAnswersOrder[0]=""+answers[0];newAnswersOrder[1]=""+answers[1];newAnswersOrder[2]=""+answers[4];newAnswersOrder[3]=""+answers[2];newAnswersOrder[4]=""+answers[5];newAnswersOrder[5]=""+answers[3];newAnswersOrder[6]=""+answers[6];newQuestionSet.answers=[].concat(newAnswersOrder);return Object.assign({},newQuestionSet);}},{key:'startGameTimer',value:function startGameTimer(){this.timer=setInterval(this.gameTimerTick,1000);// stop all bg music
window.sounds.introBg.stop();window.sounds.roundBg.stop();window.sounds.bonusBg.stop();window.sounds.gameOverBg.stop();// if bonus round
if(this.state.currentRound>this.totalRounds){window.sounds.bonusBg.play();window.sounds.bonusBg.volume(1);}// else if regular rounds
else{window.sounds.roundBg.play();window.sounds.roundBg.volume(1);}}},{key:'stopGameTimer',value:function stopGameTimer(){console.log("GamePage :: stopGameTimer");clearInterval(this.timer);// if stopped timer due to need more time button
if(this.state.videoAdCallback!==this.handleVideoAdCloseFromNeedMoreTime){window.sounds.bonusBg.volume(0);window.sounds.roundBg.volume(0);}// if bonus round
else if(this.state.currentRound>this.totalRounds){window.sounds.bonusBg.volume(.2);}// else if regular rounds
else{window.sounds.roundBg.volume(.2);}}},{key:'gameTimerTick',value:function gameTimerTick(){var newTime=this.state.timerRemaining-1;if(newTime<1){// handle out of time
this.stopGameTimer();this.handleOutOfTime();}else{// update timer
this.setState({timerRemaining:newTime,timerMsg:this.formatTimeFromSeconds(newTime)});// play sound if less than 5 seconds left
if(newTime<=5){window.sounds.timerRunningOut.play();}}// show need more time button
if(newTime<window.config.needMoreTimeBtn.showAtRemainingSecs&&this.state.needMoreTimeBtnHasWatchedThisRound===false){console.log("GamePage :: gameTimerTick - show more time button to true");this.setState({showNeedMoreTimeBtn:true});}}},{key:'formatTimeFromSeconds',value:function formatTimeFromSeconds(seconds){var minutesRemaining=Math.floor(seconds/60);var secondsRemaining=seconds%60;return""+this.formatTimerDigits(minutesRemaining)+":"+this.formatTimerDigits(secondsRemaining);}},{key:'formatTimerDigits',value:function formatTimerDigits(num){if(String(num).length===1){return"0"+num;}return num;}},{key:'handleCorrectAnswer',value:function handleCorrectAnswer(){console.log("GamePage :: handleCorrectAnswer");// points to give
var pointsRewarded=window.config.rounds[this.state.currentRound-1].correctAnswerPointsAwarded;var totalAnsweredCorrect=this.state.totalAnsweredCorrect+1;this.setState({totalAnsweredCorrect:totalAnsweredCorrect,roundPoints:this.state.roundPoints+pointsRewarded,totalPoints:this.state.totalPoints+pointsRewarded});// if all answers completed
if(totalAnsweredCorrect===this.state.totalAnswers){console.log("GamePage :: handleCorrectAnswer --- last question correct - handle end of round");// tracking
// trackingWrapper('event', 'game-round-[#]-duration', {'event_label':this.state.timerRemaining,'event_category':'america-says-game'});
//
var _this=this;// need to stop round ahead of next step so "reveal" button can dissappear first
_this.setState({roundIsStarted:false});// add bonus points for all completed
var bonusPointsRewarded=window.config.rounds[this.state.currentRound-1].allCorrectBonusPointsAwarded;this.stopGameTimer();setTimeout(function(){// if not final round
if(_this.state.currentRound<_this.totalRounds){_this.setState({showRoundResults:true,roundPoints:_this.state.roundPoints+bonusPointsRewarded,totalPoints:_this.state.totalPoints+bonusPointsRewarded,blurGame:true});}// if final round and will go to bonus round
else if(_this.state.totalPoints+pointsRewarded>=window.config.bonusRound.bonusRoundPointsThreshold){_this.setState({showFinalResults:true,roundPoints:_this.state.roundPoints+bonusPointsRewarded,totalPoints:_this.state.totalPoints+bonusPointsRewarded,blurGame:true});}// else show replay screen
else{_this.setState({roundPoints:_this.state.roundPoints+bonusPointsRewarded,totalPoints:_this.state.totalPoints+bonusPointsRewarded,blurGame:true});_this.showBeforeResultScreen(_this);}},2000);}}},{key:'handleOutOfTime',value:function handleOutOfTime(){//alert("You ran out of time! Here are the answers...");
// tracking
// trackingWrapper('event', 'game-round-[#]-timeout', {'event_label':this.totalRoundDurationInSeconds,'event_category':'america-says-game'});
//
window.sounds.buzzer.play("buzzer");var _this=this;_this.setState({roundIsStarted:false,timerMsg:"00:00"});setTimeout(function(){// show answers
_this.setState({showAnswers:true});},2000);}},{key:'handleAnswerRevealComplete',value:function handleAnswerRevealComplete(){console.log("GamePage :: handleAnswerRevealComplete");var _this=this;// if not last round
if(_this.state.currentRound<_this.totalRounds){setTimeout(function(){_this.setState({showRoundResults:true,showAnswers:false,blurGame:true});},3000);}// if last round
else if(_this.state.currentRound===_this.totalRounds){setTimeout(function(){// if quality for bonus round
if(_this.state.totalPoints>=window.config.bonusRound.bonusRoundPointsThreshold){_this.setState({showFinalResults:true,showAnswers:false,blurGame:true});}// else show game over screen
else{_this.setState({showAnswers:false,blurGame:true});_this.showBeforeResultScreen(_this);}},3000);}// if bonus round
else{setTimeout(function(){_this.setState({showAnswers:false,blurGame:true});_this.showBeforeResultScreen(_this);},3000);}}},{key:'handleNextRound',value:function handleNextRound(){console.log("GamePage :: handleNextRound - currentRound ",this.state.currentRound);// if not last round
if(this.state.currentRound<this.totalRounds){console.log("GamePage :: ------- handleNextRound - not last round");this.initRound();/*
			this.setState({
				currentRound : this.state.currentRound + 1,
				showRoundResults : false,
				timerMsg : this.formatTimeFromSeconds(this.totalRoundDurationInSeconds),
				timerRemaining : this.totalRoundDurationInSeconds,
				roundPoints : 0,
				roundIsStarted : true
			});

			const _this = this;

			setTimeout(function(){
				_this.initRandomQuestion();
				_this.startGameTimer();

				_this.setState({
					blurGame : false
				});
			},10);

			window.sounds.startButtonClick.play();
			*/}// if last round
else if(this.state.currentRound>=this.totalRounds){console.log("GamePage :: ++++++++++ handleNextRound - last round");// if quality for bonus round
if(this.state.totalPoints>=window.config.bonusRound.bonusRoundPointsThreshold){console.log("GamePage :: ++++++++++ handleNextRound - made to bonus");this.setState({currentRound:this.state.currentRound+1,showFinalResults:false,showBonusInstructions:true,hasReachedBonusRound:true,roundPoints:0});/*
				const _this = this;

				setTimeout(function(){
					_this.initBonusRound();
				},10);
				*///window.sounds.startButtonClick.play();
//this.initBonusRound();
}else{console.log("GamePage :: !!!!!!!!!! handleNextRound - failed to bonus");this.setState({showFinalResults:false,showBonusInstructions:false,roundPoints:0});this.showBeforeResultScreen();}}}},{key:'handleBonusCompleted',value:function handleBonusCompleted(){console.log("GamePage :: handleBonusCompleted");this.stopGameTimer();// award bonus round points
var _this=this;_this.setState({totalPoints:_this.state.totalPoints+window.config.bonusRound.bonusPointsAwarded,roundIsStarted:false});setTimeout(function(){_this.setState({blurGame:true});_this.showBeforeResultScreen(_this);},2000);}},{key:'handlePlayAgainBtn',value:function handlePlayAgainBtn(){//console.log("GamePage :: handlePlayAgainBtn");
// tracking 
Object(__WEBPACK_IMPORTED_MODULE_13__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-game-replay',{'event_category':'america-says-game'});Object(__WEBPACK_IMPORTED_MODULE_13__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-game-replay-'+(this.state.replayCount+1),{'event_category':'america-says-game'});//
window.sounds.buttonClick.play();//
// if reached game played threshold, show video ad
if(this.state.gamePlays>=this.showAdAfterThisManyGames){this.setState({showVideoAd:__WEBPACK_IMPORTED_MODULE_12__utils_constants__["c" /* AD_REPLAY_CLICKED */],showInstructions:false,showBonusInstructions:false,showRoundResults:false,showFinalResults:false,showBonusResults:false,currentRound:0,timerRemaining:this.totalRoundDurationInSeconds,roundPoints:0,totalPoints:0,gamePlays:1,videoAdCallback:this.handleVideoAdCloseFromGamePlays,hasReachedBonusRound:false,replayCount:this.state.replayCount+1});}else{this.setState({showVideoAd:false,videoAdId:0,showInstructions:true,showBonusInstructions:false,showRoundResults:false,showFinalResults:false,showBonusResults:false,currentRound:0,timerRemaining:this.totalRoundDurationInSeconds,roundPoints:0,totalPoints:0,gamePlays:this.state.gamePlays+1,hasReachedBonusRound:false,replayCount:this.state.replayCount+1});}}},{key:'handleLoginBtn',value:function handleLoginBtn(){console.log("GamePage :: handleLoginBtn");window.sounds.buttonClick.play();}},{key:'handleLeaderboardBtn',value:function handleLeaderboardBtn(){//console.log("GamePage :: handleLeaderboardBtn");
window.sounds.buttonClick.play();if(window.config&&window.config.buttons&&window.config.buttons.leaderboard&&window.config.buttons.leaderboard.redirect){//tracking
if(window.config.buttons.leaderboard.externalTracking){Object(__WEBPACK_IMPORTED_MODULE_13__utils_analytics__["a" /* trackingWrapper */])('event','ASGame-external-link',{'event_label':window.config.buttons.leaderboard.externalTracking,'event_category':'america-says-game'});}window.open(window.config.buttons.leaderboard.redirect,'_blank');}else{this.props.showPage("landing");}}},{key:'handleGiveUp',value:function handleGiveUp(){this.stopGameTimer();// show answers
this.setState({showAnswers:true,roundIsStarted:false});}},{key:'handleVideoOverlayClose',value:function handleVideoOverlayClose(){var rewardComplete=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;console.log('handleVideoOverlayClose');this.state.videoAdCallback(rewardComplete);}},{key:'handleVideoAdCloseFromGamePlays',value:function handleVideoAdCloseFromGamePlays(){this.setState({showVideoAd:false,videoAdId:0,showInstructions:true,videoAdCallback:null});}},{key:'handleVideoAdCloseFromNeedMoreTime',value:function handleVideoAdCloseFromNeedMoreTime(){var rewardComplete=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;this.setState({showVideoAd:false,videoAdId:0,videoAdCallback:null,needMoreTimeBtnHasWatchedThisRound:true,showNeedMoreTimeBtn:false});if(rewardComplete){this.setState({timerRemaining:this.state.timerRemaining+window.config.needMoreTimeBtn.timeAwarded,timerMsg:this.formatTimeFromSeconds(this.state.timerRemaining+window.config.needMoreTimeBtn.timeAwarded)});}var _this=this;setTimeout(function(){_this.startGameTimer();},10);}},{key:'handleNeedMoreTimeBtnClick',value:function handleNeedMoreTimeBtnClick(){this.setState({showVideoAd:__WEBPACK_IMPORTED_MODULE_12__utils_constants__["b" /* AD_MORE_TIME_CLICKED */],videoAdCallback:this.handleVideoAdCloseFromNeedMoreTime});var _this=this;setTimeout(function(){_this.stopGameTimer();},10);}},{key:'handleVideoAdCloseFinalResult',value:function handleVideoAdCloseFinalResult(){console.log('handleVideoAdCloseFinalResult');this.setState({showVideoAd:false,videoAdId:0,videoAdCallback:null,showBonusResults:true});}},{key:'handleBeforeResultsClick',value:function handleBeforeResultsClick(){window.sounds.gameOverBg.stop();this.showFinalResultVideoAd();}},{key:'showFinalResultVideoAd',value:function showFinalResultVideoAd(self){var _this=self||this;var videoId=window.config.videoAd.resultVideo||0;_this.setState({showVideoAd:__WEBPACK_IMPORTED_MODULE_12__utils_constants__["a" /* AD_FINAL_RESULTS */],videoAdId:videoId,videoAdCallback:_this.handleFinalResultVideoAdClose,showBonusResults:false,showBeforeResults:false});}},{key:'showBeforeResultScreen',value:function showBeforeResultScreen(self){var _this=self||this;_this.setState({showBeforeResults:true});}},{key:'renderInstructionsOverlay',value:function renderInstructionsOverlay(){if(this.state.showInstructions){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__instructions_InstructionsOverlay__["a" /* default */],{initRound:this.initRound,timer:this.totalRoundDurationInSeconds});}else if(this.state.showBonusInstructions){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__instructions_BonusInstructionsOverlay__["a" /* default */],{initBonusRound:this.initBonusRound,timer:this.totalBonusRoundDurationInSeconds});}}},{key:'renderResultsOverlay',value:function renderResultsOverlay(){if(this.state.showRoundResults){var bonusRoundThreshold=window.config.bonusRound.bonusRoundPointsThreshold;var missingPoints=bonusRoundThreshold-this.state.totalPoints;var renderThresholdMsg="";if(this.state.totalPoints<bonusRoundThreshold){renderThresholdMsg=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thresholdMsg'},'(You need another ',missingPoints,'pts to qualify for The Bonus Round!)');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__results_ResultsOverlay__["a" /* default */],{round:this.state.currentRound,roundPoints:this.state.roundPoints,totalPoints:this.state.totalPoints,handleNextRound:this.handleNextRound,renderThresholdMsg:renderThresholdMsg});}else if(this.state.showBeforeResults){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__results_BeforeResultsOverlay__["a" /* default */],{handleNextRound:this.handleBeforeResults});}else if(this.state.showFinalResults){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__results_FinalResultsOverlay__["a" /* default */],{round:this.state.currentRound,roundPoints:this.state.roundPoints,totalPoints:this.state.totalPoints,handleNextRound:this.handleNextRound});}else if(this.state.showBonusResults){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__results_BonusResultsOverlay__["a" /* default */],{store:this.props.store,totalPoints:this.state.totalPoints,handlePlayAgainBtn:this.handlePlayAgainBtn,handleLoginBtn:this.handleLoginBtn,handleLeaderboardBtn:this.handleLeaderboardBtn,hasReachedBonusRound:this.state.hasReachedBonusRound});}}},{key:'renderGame',value:function renderGame(){var _this3=this;if(this.state.currentRound>this.totalRounds){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__game_BonusGame__["a" /* default */],{bonusQuestionSets:this.state.bonusQuestionSets,handleBonusCompleted:function handleBonusCompleted(){return _this3.handleBonusCompleted();},key:this.state.uniqueID,showAnswers:this.state.showAnswers,handleAnswerRevealComplete:this.handleAnswerRevealComplete,handleGiveUp:this.handleGiveUp,roundIsStarted:this.state.roundIsStarted,blurGame:this.state.blurGame});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__game_Game__["a" /* default */],{questionSet:this.state.questionSet,handleCorrectAnswer:function handleCorrectAnswer(){return _this3.handleCorrectAnswer();},key:this.state.uniqueID,showAnswers:this.state.showAnswers,totalAnswers:this.state.totalAnswers,handleAnswerRevealComplete:this.handleAnswerRevealComplete,handleGiveUp:this.handleGiveUp,roundIsStarted:this.state.roundIsStarted,blurGame:this.state.blurGame});}}},{key:'renderVideoOverlay',value:function renderVideoOverlay(){if(this.state.showVideoAd){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ads_RewardAdContainer__["a" /* default */],{showVideoAd:this.state.showVideoAd,handleVideoOverlayClose:this.handleVideoOverlayClose,videoId:this.state.videoAdId});}}},{key:'render',value:function render(){var roundMsg="ROUND "+this.state.currentRound;if(this.state.currentRound>this.totalRounds){roundMsg="BONUS ROUND";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page game'},this.renderVideoOverlay(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'game_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},this.renderGame())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar_wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__sidebar_SideBar__["a" /* default */],{roundMsg:roundMsg,totalPoints:this.state.totalPoints,timerMsg:this.state.timerMsg,blurGame:this.state.blurGame,handleNeedMoreTimeBtnClick:this.handleNeedMoreTimeBtnClick,showNeedMoreTimeBtn:this.state.showNeedMoreTimeBtn,roundIsStarted:this.state.roundIsStarted,currentRound:this.state.currentRound}))),this.renderInstructionsOverlay(),this.renderResultsOverlay(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wipe',ref:'wipe'}));}}]);return GamePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GamePage);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Field__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GiveUpButton__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FooterLogo__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Game=function(_Component){_inherits(Game,_Component);function Game(props){_classCallCheck(this,Game);var _this2=_possibleConstructorReturn(this,(Game.__proto__||Object.getPrototypeOf(Game)).call(this,props));_this2.totalAnswers=_this2.props.totalAnswers;_this2.answersCompleted=[];_this2.giveUpTime=window.config.giveUpTime*1000;_this2.giveUpTimer=null;_this2.state={fieldIsFocused:false,answersCompleted:[],revealingAnswersMode:false,showGiveUp:false,checkAnswer:null};_this2.handleCorrectAnswer=_this2.handleCorrectAnswer.bind(_this2);_this2.handleWrongAnswer=_this2.handleWrongAnswer.bind(_this2);_this2.handleFieldIsFocused=_this2.handleFieldIsFocused.bind(_this2);_this2.resetGiveUpTimer=_this2.resetGiveUpTimer.bind(_this2);_this2.updateAnswerHandler=_this2.updateAnswerHandler.bind(_this2);_this2.blurIn=_this2.blurIn.bind(_this2);_this2.blurOut=_this2.blurOut.bind(_this2);return _this2;}_createClass(Game,[{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.game,{"opacity":0});window.TweenMax.to(this.refs.game,.5,{"opacity":1,"filter":"blur(5px)"});if(this.props.questionSet!==null){this.resetGiveUpTimer();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.giveUpTimer);}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){/*
		console.log("Game :: componentWillUpdate - this.props.roundIsStarted : ", this.props.roundIsStarted);
		console.log("Game :: componentWillUpdate - nextProps.roundIsStarted : ", nextProps.roundIsStarted);

		// if round starting
		if(this.props.roundIsStarted === false && nextProps.roundIsStarted === true){
			this.resetGiveUpTimer();
		}
		*/// if parent tells this to start revealing answers
if(this.props.showAnswers===false&&nextProps.showAnswers===true){this.setState({revealingAnswersMode:true});var _this=this;setTimeout(function(){_this.revealNextAnswer();},10);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){//console.log("Game :: componentDidUpdate");
// blur the game area
if(this.props.blurGame===true&&prevProps.blurGame===false){//console.log("Game :: componentDidUpdate - blurOut");
this.blurOut();}// unblur the game area
if(this.props.blurGame===false&&prevProps.blurGame===true){//console.log("Game :: componentDidUpdate - blurIn");
this.blurIn();}}},{key:'blurIn',value:function blurIn(){//console.log("Game :: blurIn - this.refs.game : ", this.refs.game);
window.TweenMax.to(this.refs.game,.5,{"filter":"blur(0px)"});}},{key:'blurOut',value:function blurOut(){//console.log("Game :: blurOut");
window.TweenMax.to(this.refs.game,.5,{"filter":"blur(5px)"});}},{key:'resetGiveUpTimer',value:function resetGiveUpTimer(){//console.log("Game :: resetGiveUpTimer");
var _this=this;clearTimeout(this.giveUpTimer);this.giveUpTimer=setTimeout(function(){//console.log("Game :: resetGiveUpTimer - show give up button");
_this.setState({showGiveUp:true});},this.giveUpTime);}},{key:'revealNextAnswer',value:function revealNextAnswer(){var unansweredFound=true;for(var i=0;i<this.totalAnswers;i++){if(this.state.answersCompleted[i]!==true){var newAnswersCompleted=[].concat(_toConsumableArray(this.state.answersCompleted));newAnswersCompleted[i]=true;this.setState({answersCompleted:newAnswersCompleted});break;}else if(i===this.totalAnswers-1){unansweredFound=false;}}//
var _this=this;if(unansweredFound){setTimeout(function(){_this.revealNextAnswer();},1000);}else{_this.props.handleAnswerRevealComplete();}}},{key:'handleCorrectAnswer',value:function handleCorrectAnswer(key){//console.log("Game :: handleCorrectAnswer");
var _this=this;var _key=key;window.TweenMax.set(this.refs.correctAnswerCue,{"opacity":.8});window.TweenMax.to(this.refs.correctAnswerCue,1.3,{"opacity":0,onComplete:function onComplete(){}});// update completion
var newAnswersCompleted=[].concat(_toConsumableArray(_this.state.answersCompleted));newAnswersCompleted[_key]=true;_this.setState({answersCompleted:newAnswersCompleted});// update parent
_this.props.handleCorrectAnswer();}},{key:'handleWrongAnswer',value:function handleWrongAnswer(){window.TweenMax.set(this.refs.wrongAnswerCue,{"opacity":.8});window.TweenMax.to(this.refs.wrongAnswerCue,1.3,{"opacity":0});}},{key:'handleFieldIsFocused',value:function handleFieldIsFocused(boolean){this.setState({fieldIsFocused:boolean});}},{key:'updateAnswerHandler',value:function updateAnswerHandler(answer){this.setState({checkAnswer:answer});}},{key:'renderAnswers',value:function renderAnswers(){//console.log("GamePage:: renderAnswers");
var _this=this;if(this.props.questionSet!==null){if(this.props.questionSet.answers){return this.props.questionSet.answers.map(function(answer,i){var shouldShowAnswer=_this.state.answersCompleted[i];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Field__["a" /* default */],{key:i,answer:answer,handleCorrectAnswer:function handleCorrectAnswer(){return _this.handleCorrectAnswer(i);},handleWrongAnswer:_this.handleWrongAnswer,handleFieldIsFocused:_this.handleFieldIsFocused,showAnswers:shouldShowAnswer,checkAnswer:_this.state.checkAnswer,updateAnswerHandler:_this.updateAnswerHandler,revealingAnswersMode:_this.state.revealingAnswersMode});});}else{//console.log("Game::renderAnswers - questionSet answers is undefined");
}}else{//console.log("Game::renderAnswers - questionSet is null");
}}},{key:'renderInstructionsHint',value:function renderInstructionsHint(){if(!this.state.revealingAnswersMode){if(this.state.fieldIsFocused){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint'},'(fill-out the answer)');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint'},'(choose a blanked-out word to start typing)');}}}},{key:'render',value:function render(){var _this3=this;var question=this.props.questionSet!==null?this.props.questionSet.question:"";var answersReadOnly=this.props.showAnswers?" readOnly":"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'game',ref:'game'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'questionBox'},question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"answers_wrapper"+answersReadOnly,onClick:function onClick(){return _this3.resetGiveUpTimer();}},this.renderAnswers()),this.renderInstructionsHint(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GiveUpButton__["a" /* default */],{show:this.state.showGiveUp&&this.props.roundIsStarted,handleGiveUp:function handleGiveUp(){return _this3.props.handleGiveUp();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'correctAnswerCue',ref:'correctAnswerCue'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrongAnswerCue',ref:'wrongAnswerCue'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FooterLogo__["a" /* default */],null));}}]);return Game;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Game);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_analytics__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SideBar=function(_Component){_inherits(SideBar,_Component);function SideBar(props){_classCallCheck(this,SideBar);var _this=_possibleConstructorReturn(this,(SideBar.__proto__||Object.getPrototypeOf(SideBar)).call(this,props));_this.state={};_this.blurIn=_this.blurIn.bind(_this);_this.blurOut=_this.blurOut.bind(_this);_this.handleNeedMoreTimeBtnClick=_this.handleNeedMoreTimeBtnClick.bind(_this);_this.handleAdClick=_this.handleAdClick.bind(_this);return _this;}_createClass(SideBar,[{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.sidebar,{"opacity":0});window.TweenMax.to(this.refs.sidebar,.5,{"opacity":1,"filter":"blur(5px)"});// need more time button starts hidden
window.TweenMax.set(this.refs.needMoreTimeBtn,{"display":"none","opacity":0});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// blur the game area
if(this.props.blurGame===true&&prevProps.blurGame===false){this.blurOut();}// unblur the game area
if(this.props.blurGame===false&&prevProps.blurGame===true){this.blurIn();}// if parent tells need more time button to show
if(prevProps.showNeedMoreTimeBtn===false&&this.props.showNeedMoreTimeBtn===true&&this.props.roundIsStarted===true){console.log("SideBar :: componentDidUpdate - qualifies to SHOW needMoreTimeBtn");window.TweenMax.set(this.refs.needMoreTimeBtn,{"display":"block"});window.TweenMax.to(this.refs.needMoreTimeBtn,.5,{"opacity":1});}else if(prevProps.showNeedMoreTimeBtn===true&&this.props.showNeedMoreTimeBtn===false||this.props.roundIsStarted===false){console.log("SideBar :: componentDidUpdate - qualifies to HIDE needMoreTimeBtn");window.TweenMax.set(this.refs.needMoreTimeBtn,{"display":"none","opacity":0});}}},{key:'blurIn',value:function blurIn(){window.TweenMax.to(this.refs.sidebar,.5,{"filter":"blur(0px)"});}},{key:'blurOut',value:function blurOut(){window.TweenMax.to(this.refs.sidebar,.5,{"filter":"blur(5px)"});}},{key:'handleNeedMoreTimeBtnClick',value:function handleNeedMoreTimeBtnClick(){console.log("SideBar :: handleNeedMoreTimeBtnClick");// tracking
Object(__WEBPACK_IMPORTED_MODULE_4__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-more-time',{'event_category':'america-says-game'});// call parent handler
this.props.handleNeedMoreTimeBtnClick();}},{key:'handleAdClick',value:function handleAdClick(evt){var url=this.props.affiliate!==null?this.props.affiliate.url:'https://www.gsntv.com';Object(__WEBPACK_IMPORTED_MODULE_4__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-external-link',{'event_category':url});window.open(url,'_blank');}},{key:'render',value:function render(){var _this2=this;var affiliate=this.props.affiliate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'sidebar',ref:'sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'round'},this.props.roundMsg),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'Current Score: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'value'},Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["b" /* numberWithCommas */])(this.props.totalPoints))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},'Time Remaining: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'value'},this.props.timerMsg)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ad',onClick:this.handleAdClick},affiliate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'affiliateLogo',src:"images/"+affiliate.imgName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'needMoreTimeBtn',ref:'needMoreTimeBtn',onClick:function onClick(){return _this2.handleNeedMoreTimeBtnClick();}},'Need More Time'));}}]);return SideBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{affiliate:state.affiliate};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SideBar));

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Field__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GiveUpButton__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FooterLogo__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BonusGame=function(_Component){_inherits(BonusGame,_Component);function BonusGame(props){_classCallCheck(this,BonusGame);var _this2=_possibleConstructorReturn(this,(BonusGame.__proto__||Object.getPrototypeOf(BonusGame)).call(this,props));_this2.giveUpTime=window.config.giveUpTime*1000;_this2.giveUpTimer=null;_this2.state={fieldIsFocused:false,currentSet:0,answerTree:[],revealingAnswersMode:false,showGiveUp:false,checkAnswer:null};_this2.handleCorrectAnswer=_this2.handleCorrectAnswer.bind(_this2);_this2.handleWrongAnswer=_this2.handleWrongAnswer.bind(_this2);_this2.handleFieldIsFocused=_this2.handleFieldIsFocused.bind(_this2);_this2.renderBonusSet=_this2.renderBonusSet.bind(_this2);_this2.handleSkipButton=_this2.handleSkipButton.bind(_this2);_this2.resetGiveUpTimer=_this2.resetGiveUpTimer.bind(_this2);_this2.updateAnswerHandler=_this2.updateAnswerHandler.bind(_this2);return _this2;}_createClass(BonusGame,[{key:'componentWillMount',value:function componentWillMount(){//console.log("BonusGame :: componentDidMount - questions length", this.props.bonusQuestionSets);
// init answerTree array to keep track of answers correct and pagination
var answerTree=[];for(var i=0;i<this.props.bonusQuestionSets.length;i++){//console.log("componentDidMount loop i");
answerTree[i]=[];for(var j=0;j<this.props.bonusQuestionSets[i].answers.length;j++){//console.log("componentDidMount loop j");
//totalAnswers++;
answerTree[i][j]=0;}}//console.log("BonusGame :: componentWillMount - answerTree : ", answerTree);
this.setState({answerTree:answerTree});}},{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.game,{"opacity":0});window.TweenMax.to(this.refs.game,.5,{"opacity":1,"filter":"blur(5px)"});if(this.props.bonusQuestionSets!==null){this.resetGiveUpTimer();}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){// if round starting
if(this.props.roundIsStarted===false&&nextProps.roundIsStarted===true){this.resetGiveUpTimer();}// if not in revealing answers mode
if(!this.state.revealingAnswersMode){if(this.state.answerTree.length>0){if(nextState.answerTree!==this.state.answerTree){// if all answers solved, bonus round complete
if(this.getTotalCorrect()>=this.getTotalAnswers()){//console.log("BonusGame :: componentWillMount ====== bonus game complete");
this.props.handleBonusCompleted();}// if current set is completed, go to next page with at least one unanswered
else if(this.isSetCompleted(this.state.currentSet)){var _this=this;setTimeout(function(){_this.setState({currentSet:_this.getNextOpenSet()});},1500);}}}}// if parent tells this to start revealing answers
if(this.props.showAnswers===false&&nextProps.showAnswers===true){//console.log("BonusGame :: componentWillUpdate - call revealNextAnswer");
this.setState({revealingAnswersMode:true});var _this3=this;setTimeout(function(){_this3.revealNextAnswer();},10);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){//console.log("BonusGame :: componentDidUpdate");
// blur the game area
if(this.props.blurGame===true&&prevProps.blurGame===false){//console.log("BonusGame :: componentDidUpdate - blurOut");
this.blurOut();}// unblur the game area
if(this.props.blurGame===false&&prevProps.blurGame===true){//console.log("BonusGame :: componentDidUpdate - blurIn");
this.blurIn();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.giveUpTimer);}},{key:'blurIn',value:function blurIn(){//console.log("BonusGame :: blurIn - this.refs.game : ", this.refs.game);
window.TweenMax.to(this.refs.game,.5,{"filter":"blur(0px)"});}},{key:'blurOut',value:function blurOut(){//console.log("BonusGame :: blurOut");
window.TweenMax.to(this.refs.game,.5,{"filter":"blur(5px)"});}},{key:'resetGiveUpTimer',value:function resetGiveUpTimer(){//console.log("BonusGame :: resetGiveUpTimer");
var _this=this;clearTimeout(this.giveUpTimer);this.giveUpTimer=setTimeout(function(){//console.log("BonusGame :: resetGiveUpTimer - show give up button");
_this.setState({showGiveUp:true});},this.giveUpTime);}},{key:'revealNextAnswer',value:function revealNextAnswer(){//console.log("=============== BonusGame :: revealNextAnswer");
var _this=this;var unansweredFound=true;// if there is a open answer on this set, show it
if(this.getNextOpenAnswer(this.state.currentSet)!==false){//console.log("BonusGame :: revealNextAnswer -  if");
var newAnswerTree=[].concat(_toConsumableArray(this.state.answerTree));newAnswerTree[this.state.currentSet][this.getNextOpenAnswer()]=1;this.setState({answerTree:newAnswerTree});}// else get next open set
else if(this.getNextOpenSet()!==false){//console.log("BonusGame :: revealNextAnswer -  else if");
var _this4=this;// wait 2 seconds before revealing next page
setTimeout(function(){_this4.setState({currentSet:_this4.getNextOpenSet()});// wait 1 sec before showing first answer on next page
setTimeout(function(){_this4.revealNextAnswer();},1000);},2500);return false;}// if no open sets, then it is done revealing all
else{//console.log("BonusGame :: revealNextAnswer -  else");
unansweredFound=false;}//
if(unansweredFound){setTimeout(function(){_this.revealNextAnswer();},1000);}else{_this.props.handleAnswerRevealComplete();}}},{key:'getTotalAnswers',value:function getTotalAnswers(){var count=0;for(var i=0;i<this.state.answerTree.length;i++){for(var j=0;j<this.state.answerTree[i].length;j++){count++;}}return count;}},{key:'getTotalCorrect',value:function getTotalCorrect(){var count=0;for(var i=0;i<this.state.answerTree.length;i++){for(var j=0;j<this.state.answerTree[i].length;j++){count=count+this.state.answerTree[i][j];}}return count;}},{key:'isSetCompleted',value:function isSetCompleted(setNo){//console.log("BonusGame :: isSetCompleted - setNo: ", setNo);
for(var i=0;i<this.state.answerTree[setNo].length;i++){if(this.state.answerTree[setNo][i]===0){//console.log("BonusGame :: isSetCompleted - return false");
return false;}}//console.log("BonusGame :: isSetCompleted - return true");
return true;}},{key:'isLastSet',value:function isLastSet(){//console.log("BonusGame :: isLastSet");
var openSets=0;for(var i=0;i<this.state.answerTree.length;i++){if(!this.isSetCompleted(i)){openSets++;}}if(openSets>1){return false;}else{return true;}}},{key:'getLastAnswerIndex',value:function getLastAnswerIndex(){return this.state.answerTree[this.state.currentSet].length-1;}},{key:'getNextOpenSet',value:function getNextOpenSet(){//console.log("BonusGame :: getNextOpenSet");
var index=this.state.currentSet;var count=0;var totalSets=this.state.answerTree.length;//console.log("BonusGame :: getNextOpenSet - totalSets : " + totalSets + "    ");
while(count<totalSets){count++;// if at last set, start back at first set
if(index>=totalSets-1){index=0;}// else increment for next set
else{index=index+1;}// if the next set is not completed, return it's index
if(!this.isSetCompleted(index)){return index;}}// if nothing found, return false
return false;}},{key:'getNextOpenAnswer',value:function getNextOpenAnswer(){//console.log("BonusGame :: getNextOpenAnswer");
if(this.isSetCompleted(this.state.currentSet)!==true){//console.log("BonusGame :: getNextOpenAnswer - if");
var ret=false;var count=0;while(!ret||count<10){if(this.state.answerTree[this.state.currentSet][count]===0){/*
					var newAnswerTree = [...this.state.answerTree];
					newAnswerTree[nextOpenSet][count] = 1;

					this.setState({
						answerTree : newAnswerTree
					});
					*/ret=true;//console.log("BonusGame :: getNextOpenAnswer - return: ", count);
return count;}else{count++;}}}else{//console.log("BonusGame :: getNextOpenAnswer - else");
return false;}}},{key:'updateAnswerTree',value:function updateAnswerTree(setNo,i){var answerTree=[].concat(_toConsumableArray(this.state.answerTree));answerTree[setNo][i]=1;this.setState({answerTree:answerTree});}},{key:'handleCorrectAnswer',value:function handleCorrectAnswer(setNo,i){//console.log("setNo: " + setNo + "    i: " + i);
var _this=this;window.TweenMax.set(this.refs.correctAnswerCue,{"opacity":.8});window.TweenMax.to(this.refs.correctAnswerCue,1.3,{"opacity":0,onComplete:function onComplete(){}});// update completion
_this.updateAnswerTree(setNo,i);}},{key:'handleWrongAnswer',value:function handleWrongAnswer(){//console.log("Game:: show wrong answer cue");
window.TweenMax.set(this.refs.wrongAnswerCue,{"opacity":.8});window.TweenMax.to(this.refs.wrongAnswerCue,1.3,{"opacity":0});}},{key:'handleFieldIsFocused',value:function handleFieldIsFocused(boolean){this.setState({fieldIsFocused:boolean});}},{key:'handleSkipButton',value:function handleSkipButton(){//console.log("BonusGame :: handleSkipButton");
window.sounds.startButtonClick.play();this.resetGiveUpTimer();var nextSet=this.getNextOpenSet();//console.log("BonusGame :: handleSkipButton - nextSet : ", nextSet);
if(nextSet!==false){this.setState({currentSet:nextSet});}}},{key:'updateAnswerHandler',value:function updateAnswerHandler(answer){//console.log("BonusGame :: updateAnswerHandler - answer ", answer);
this.setState({checkAnswer:answer});}},{key:'renderInstructionsHint',value:function renderInstructionsHint(){if(!this.state.revealingAnswersMode){if(this.state.fieldIsFocused){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint'},'(fill-out the answer)');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hint'},'(choose a blanked-out word to start typing)');}}}},{key:'renderAnswers',value:function renderAnswers(answersArray,setNo){//console.log("GamePage:: renderAnswers");
var _this=this;return answersArray.map(function(answer,i){//console.log("Bonusgame :: renderAnswers - _this.state.answerTree[setNo][i]", _this.state.answerTree[setNo][i]);
var shouldShowAnswer=_this.state.answerTree[setNo][i]===1?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Field__["a" /* default */],{key:i,answer:answer,handleCorrectAnswer:function handleCorrectAnswer(){return _this.handleCorrectAnswer(setNo,i);},handleWrongAnswer:_this.handleWrongAnswer,handleFieldIsFocused:_this.handleFieldIsFocused,showAnswers:shouldShowAnswer,checkAnswer:_this.state.checkAnswer,updateAnswerHandler:_this.updateAnswerHandler,revealingAnswersMode:_this.state.revealingAnswersMode,bonusSet:setNo,currentSet:_this.state.currentSet});});}},{key:'renderBonusSet',value:function renderBonusSet(questionSet,i){var _this5=this;var _this=this;var isShowing=this.state.currentSet===i?" show":"";var answersReadOnly=this.props.showAnswers?" readOnly":"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"bonusSet"+isShowing,key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'questionBox'},questionSet.question),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"answers_wrapper"+answersReadOnly,onClick:function onClick(){return _this5.resetGiveUpTimer();}},_this.renderAnswers(questionSet.answers,i)));}},{key:'renderSkipBtn',value:function renderSkipBtn(){var _this6=this;//console.log("BonusGame :: renderSkipBtn - this.isLastSet : " + this.isLastSet() + "      this.state.hideSkipBtn : " + this.state.hideSkipBtn);
if(!this.isLastSet()&&!this.state.revealingAnswersMode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'skipBtn',onClick:function onClick(){return _this6.handleSkipButton();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},'SKIP');}}},{key:'render',value:function render(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'bonusGame',ref:'game'},this.props.bonusQuestionSets.map(this.renderBonusSet),this.renderInstructionsHint(),this.renderSkipBtn(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GiveUpButton__["a" /* default */],{show:this.state.showGiveUp&&this.props.roundIsStarted,handleGiveUp:function handleGiveUp(){return _this7.props.handleGiveUp();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'correctAnswerCue',ref:'correctAnswerCue'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrongAnswerCue',ref:'wrongAnswerCue'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FooterLogo__["a" /* default */],null));}}]);return BonusGame;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BonusGame);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_analytics__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
import {userDataFromGSNTV} from './../../../utils/gsntv';
*/var InstructionsOverlay=function(_Component){_inherits(InstructionsOverlay,_Component);function InstructionsOverlay(props){_classCallCheck(this,InstructionsOverlay);var _this2=_possibleConstructorReturn(this,(InstructionsOverlay.__proto__||Object.getPrototypeOf(InstructionsOverlay)).call(this,props));_this2.transitionIn=new window.TimelineMax({onComplete:_this2.handleTransitionComplete,onCompleteParams:[_this2],onReverseComplete:_this2.handleTransitionOutComplete,onReverseCompleteParams:[_this2]});return _this2;}_createClass(InstructionsOverlay,[{key:'componentDidMount',value:function componentDidMount(){// get users highest score if logged in (prep data)
/*
		if(this.props.userLoggedIn){
			userDataFromGSNTV().then((data) => {
				console.log("InstructionsOverlay :: componentDidMount - userDataFromGSNTV data = ", data);
				window.userMaxScore = data.userMaxScore;
			});
		}
		*/// animate in
window.TweenMax.set(this.refs.overlay,{"opacity":0});window.TweenMax.set(this.refs.line1,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line2,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line3,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line4,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.thumbnail,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.playBtn,{"opacity":0,"transform":"translateY(1vw)"});this.transitionIn.to(this.refs.overlay,.5,{"opacity":1,"delay":.3}).to(this.refs.line1,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line2,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line3,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line4,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.thumbnail,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.playBtn,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3");//tracking
Object(__WEBPACK_IMPORTED_MODULE_2__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-intro-screen',{'event_category':'america-says-game'});}},{key:'handleTransitionComplete',value:function handleTransitionComplete(_this){}},{key:'handleTransitionOutComplete',value:function handleTransitionOutComplete(_this){//this.props.initRound();
}},{key:'handlePlayBtnClick',value:function handlePlayBtnClick(){//this.transitionIn.reverse();
}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instructions_overlay',ref:'overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',ref:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'firstLine',ref:'line1'},'HOW TO PLAY'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{ref:'line2'},'GUESS HOW AMERICA FILLED IN THE BLANKS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{ref:'line3'},'THE FIRST LETTER OF THE ANSWER WILL APPEAR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{ref:'line4'},'GUESS AS MANY AS YOU CAN IN ',this.props.timer,' SECONDS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumbnail',ref:'thumbnail'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'playBtn',ref:'playBtn',onClick:function onClick(){return _this3.props.initRound();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},'START')));}}]);return InstructionsOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (InstructionsOverlay);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scss_App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BonusInstructionsOverlay=function(_Component){_inherits(BonusInstructionsOverlay,_Component);function BonusInstructionsOverlay(props){_classCallCheck(this,BonusInstructionsOverlay);var _this2=_possibleConstructorReturn(this,(BonusInstructionsOverlay.__proto__||Object.getPrototypeOf(BonusInstructionsOverlay)).call(this,props));_this2.transitionIn=new window.TimelineMax({onComplete:_this2.handleTransitionComplete,onCompleteParams:[_this2],onReverseComplete:_this2.handleTransitionOutComplete,onReverseCompleteParams:[_this2]});return _this2;}_createClass(BonusInstructionsOverlay,[{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.overlay,{"opacity":0});window.TweenMax.set(this.refs.host,{"opacity":0,"height":"0%"});window.TweenMax.set(this.refs.line1,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line2,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line3,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line4,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.playBtn,{"opacity":0,"transform":"translateY(1vw)"});this.transitionIn.to(this.refs.overlay,.5,{"opacity":1,"delay":.3}).to(this.refs.host,.4,{"opacity":1,"height":"100%"},"-=.3").to(this.refs.line1,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.6").to(this.refs.line2,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line3,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line4,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.playBtn,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3");}},{key:'handleTransitionComplete',value:function handleTransitionComplete(_this){}},{key:'handleTransitionOutComplete',value:function handleTransitionOutComplete(_this){}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bonusInstructions_overlay',ref:'overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',ref:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'firstLine',ref:'line1'},'HOW TO PLAY BONUS ROUND'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{ref:'line2'},'GUESS THE TOP ANSWER(S) TO 4 SETS OF QUESTIONS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{ref:'line3'},'STUCK? HIT "SKIP" AND COME BACK TO IT LATER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{ref:'line4'},'GET THEM ALL CORRECT IN ',this.props.timer,' SECONDS TO WIN THE GAME!'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'host',ref:'host'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'playBtn',ref:'playBtn',onClick:function onClick(){return _this3.props.initBonusRound();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},'PLAY NOW')));}}]);return BonusInstructionsOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BonusInstructionsOverlay);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResultsOverlay=function(_Component){_inherits(ResultsOverlay,_Component);function ResultsOverlay(props){_classCallCheck(this,ResultsOverlay);var _this2=_possibleConstructorReturn(this,(ResultsOverlay.__proto__||Object.getPrototypeOf(ResultsOverlay)).call(this,props));_this2.transitionIn=new window.TimelineMax({onComplete:_this2.handleTransitionComplete,onCompleteParams:[_this2],onReverseComplete:_this2.handleTransitionOutComplete,onReverseCompleteParams:[_this2]});return _this2;}_createClass(ResultsOverlay,[{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.overlay,{"opacity":0});window.TweenMax.set(this.refs.line1,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line2,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.playBtn,{"opacity":0,"transform":"translateY(1vw)"});this.transitionIn.to(this.refs.overlay,.5,{"opacity":1,"delay":.3}).to(this.refs.line1,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line2,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.playBtn,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3");}},{key:'handleTransitionComplete',value:function handleTransitionComplete(_this){}},{key:'handleTransitionOutComplete',value:function handleTransitionOutComplete(_this){//_this.props.handleNextRound();
}},{key:'handlePlayBtnClick',value:function handlePlayBtnClick(){//this.transitionIn.reverse();
}},{key:'render',value:function render(){var _this3=this;// determine round message
var totalRounds=window.config.rounds.length;var roundMsg="ROUND COMPLETE";if(totalRounds>1){roundMsg="ROUND "+this.props.round+" OF "+totalRounds+" COMPLETE";}// determine play button label
var playBtnLabel="NEXT ROUND";if(totalRounds>1&&this.props.round===totalRounds-1){playBtnLabel="FINAL ROUND";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results_overlay',ref:'overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',ref:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'roundMsg',ref:'line1'},roundMsg),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scoreMsg',ref:'line2'},'This Round: ',Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* numberWithCommas */])(this.props.roundPoints),' points',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Total Score: ',Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* numberWithCommas */])(this.props.totalPoints),' points'),this.props.renderThresholdMsg,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nextBtn',ref:'playBtn',onClick:function onClick(){return _this3.props.handleNextRound();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},playBtnLabel)));}}]);return ResultsOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ResultsOverlay);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FinalResultsOverlay=function(_Component){_inherits(FinalResultsOverlay,_Component);function FinalResultsOverlay(props){_classCallCheck(this,FinalResultsOverlay);var _this2=_possibleConstructorReturn(this,(FinalResultsOverlay.__proto__||Object.getPrototypeOf(FinalResultsOverlay)).call(this,props));_this2.transitionIn=new window.TimelineMax({onComplete:_this2.handleTransitionComplete,onCompleteParams:[_this2],onReverseComplete:_this2.handleTransitionOutComplete,onReverseCompleteParams:[_this2]});return _this2;}_createClass(FinalResultsOverlay,[{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.overlay,{"opacity":0});window.TweenMax.set(this.refs.line1,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line2,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line3,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.playBtn,{"opacity":0,"transform":"translateY(1vw)"});this.transitionIn.to(this.refs.overlay,.5,{"opacity":1,"delay":.3}).to(this.refs.line1,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line2,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line3,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.playBtn,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3");}},{key:'handleTransitionComplete',value:function handleTransitionComplete(_this){}},{key:'handleTransitionOutComplete',value:function handleTransitionOutComplete(_this){//_this.props.handleNextRound();
}},{key:'handlePlayBtnClick',value:function handlePlayBtnClick(){//this.transitionIn.reverse();
}},{key:'render',value:function render(){var _this3=this;var totalRounds=window.config.rounds.length;var roundMsg="ROUND COMPLETE";if(totalRounds>1){roundMsg="ROUND "+this.props.round+" OF "+totalRounds+" COMPLETE";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results_overlay',ref:'overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',ref:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'roundMsg',ref:'line1'},roundMsg),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scoreMsg',ref:'line2'},'This Round: ',Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* numberWithCommas */])(this.props.roundPoints),' points',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Total Score: ',Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* numberWithCommas */])(this.props.totalPoints),' points'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bonusRoundMsg',ref:'line3'},'CONGRATULATIONS!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'You made it to The Bonus Round!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nextBtn',ref:'playBtn',onClick:function onClick(){return _this3.props.handleNextRound();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},'BONUS ROUND')));}}]);return FinalResultsOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FinalResultsOverlay);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Confetti__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_AccAccessBtnContainer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_gsntv__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_analytics__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FooterLogo__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import {setMaxScore} from './../../../actions';
var BonusResultsOverlay=function(_Component){_inherits(BonusResultsOverlay,_Component);function BonusResultsOverlay(props){_classCallCheck(this,BonusResultsOverlay);var _this2=_possibleConstructorReturn(this,(BonusResultsOverlay.__proto__||Object.getPrototypeOf(BonusResultsOverlay)).call(this,props));_this2.transitionIn=new window.TimelineMax({onComplete:_this2.handleTransitionComplete,onCompleteParams:[_this2],onReverseComplete:_this2.handleTransitionOutComplete,onReverseCompleteParams:[_this2]});_this2.accAccessBtn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this2;}_createClass(BonusResultsOverlay,[{key:"componentDidMount",value:function componentDidMount(){// stop all bg
window.sounds.introBg.stop();window.sounds.roundBg.stop();window.sounds.bonusBg.stop();window.sounds.gameOverBg.stop();// play bg music
window.sounds.gameOverBg.play();window.sounds.gameOverBg.volume(.3);// update user's score if logged in
console.log("======= BonusResultsOverlay :: componentDidMount");console.log("BonusResultsOverlay :: componentDidMount - this.props.userLoggedIn : ",this.props.userLoggedIn);//console.log("BonusResultsOverlay :: componentDidMount - this.props.maxScore : ", this.props.maxScore);
console.log("BonusResultsOverlay :: componentDidMount - this.props.user : ",this.props.user);if(this.props.userLoggedIn){this.saveScore();}// animate in
window.TweenMax.set(this.refs.overlay,{"opacity":0});window.TweenMax.set(this.refs.logo,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.tuneIn,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.host,{"height":"0%"});window.TweenMax.set(this.refs.line1,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line2,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line3,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.playAgainBtn,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.accAccessBtn.current,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.leaderboardBtn,{"opacity":0,"transform":"translateY(1vw)"});this.transitionIn.to(this.refs.overlay,.5,{"opacity":1,"delay":.3}).to(this.refs.logo,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.tuneIn,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.host,.4,{"height":"100%"},"-=.3").to(this.refs.line1,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.6").to(this.refs.line2,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line3,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.playAgainBtn,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.accAccessBtn.current,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.leaderboardBtn,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3");// tracking
Object(__WEBPACK_IMPORTED_MODULE_7__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-end',{'event_label':this.props.totalPoints,'event_category':'america-says-game'});// gleam
var Gleam=window.Gleam||[];Gleam.push(['america-says-game-daily-play-holiday-regular','myValue']);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){console.log('*********** BonusResultsOverlay :: componentDidUpdate');if(prevProps.userLoggedIn!==this.props.userLoggedIn&&this.props.userLoggedIn===true){console.log('*********** BonusResultsOverlay :: componentDidUpdate - will save score');this.saveScore();}}},{key:"saveScore",value:function saveScore(){var _this3=this;console.log('-------- BonusResultsOverlay :: saveScore - this.props.totalPoints',this.props.totalPoints);//console.log('-------- BonusResultsOverlay :: saveScore - this.props.maxScore', this.props.maxScore);
Object(__WEBPACK_IMPORTED_MODULE_5__utils_gsntv__["f" /* userDataFromGSNTV */])().then(function(data){var userJSON=JSON.parse(data);console.log('-------- BonusResultsOverlay :: saveScore - userDataFromGSNTV data',data);console.log('-------- BonusResultsOverlay :: saveScore - userDataFromGSNTV userJSON.maxScore',userJSON.maxScore);if(_this3.props.totalPoints>userJSON.maxScore||userJSON.maxScore===null||userJSON===false){console.log("BonusResultsOverlay :: saveScore - this.props.user : ",_this3.props.user);var leaderboardUpdateObj={"name":_this3.props.user.firstName+" "+_this3.props.user.lastName.charAt(0)+".","highScore":_this3.props.totalPoints};console.log("BonusResultsOverlay :: saveScore - leaderboardUpdateObj : ",leaderboardUpdateObj);// save to leaderboard
Object(__WEBPACK_IMPORTED_MODULE_5__utils_gsntv__["d" /* saveHighScoreToGSNTV */])(leaderboardUpdateObj);// save to user profile
var scoreObj=JSON.stringify({"maxScore":_this3.props.totalPoints});Object(__WEBPACK_IMPORTED_MODULE_5__utils_gsntv__["e" /* saveUserDataToGSNTV */])(scoreObj).then(function(){Object(__WEBPACK_IMPORTED_MODULE_5__utils_gsntv__["f" /* userDataFromGSNTV */])().then(function(data){console.log("!!! save user data - new data: ",data);});});// store in redux
//this.props.store.dispatch(setMaxScore(this.props.totalPoints));
}else{console.log("BonusResultsOverlay :: saveScore - score not high enough to be saved");}});}},{key:"handleTransitionComplete",value:function handleTransitionComplete(_this){}},{key:"handleTransitionOutComplete",value:function handleTransitionOutComplete(_this){//_this.props.initRound();
}},{key:"facebookHandleClick",value:function facebookHandleClick(){Object(__WEBPACK_IMPORTED_MODULE_7__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-share-fb',{'event_category':'america-says-game','event_label':'result'});}},{key:"twitterHandleClick",value:function twitterHandleClick(){Object(__WEBPACK_IMPORTED_MODULE_7__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-share-tw',{'event_category':'america-says-game','event_label':'result'});}},{key:"handlePlayBtnClick",value:function handlePlayBtnClick(){//this.transitionIn.reverse();
}},{key:"renderConfetti",value:function renderConfetti(){if(this.props.hasReachedBonusRound){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Confetti__["a" /* default */],null);}}},{key:"render",value:function render(){var _this4=this;var _props=this.props,affiliate=_props.affiliate,isAppIframed=_props.isAppIframed;var btnRef=this.accAccessBtn;var btnClassName={login:'loginBtn button'+(isAppIframed?'':' hide'),logout:'loginBtn button'+(isAppIframed?'':' hide')};var btnLabel={login:'Login / Register',logout:'Logout'//
};var line1Msg="THANK YOU FOR PLAYING!";if(this.props.hasReachedBonusRound){line1Msg="CONGRATULATIONS!";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bonusResults_overlay",ref:"overlay"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content",ref:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"leftColumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"logo",ref:"logo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Weekdays")),affiliate!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"affiliateLogo",src:"images/"+affiliate.imgName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"tuneIn",ref:"tuneIn"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"host",ref:"host"}),window.config.share&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"socialWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"label"},"Share Your Score!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fab fa-facebook-square",onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();},onClick:function onClick(){return _this4.facebookHandleClick();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fab fa-twitter-square",onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();},onClick:function onClick(){return _this4.twitterHandleClick();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"rightColumn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"line1",ref:"line1"},line1Msg),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"line2",ref:"line2"},"Your Final Score Is:",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["b" /* numberWithCommas */])(this.props.totalPoints)," points"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"line3",ref:"line3"},"Think you can do better?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"buttonsWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"playAgainBtn button",ref:"playAgainBtn",onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();},onClick:function onClick(){return _this4.props.handlePlayAgainBtn();}},"Play Again"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_AccAccessBtnContainer__["a" /* default */],{btnLabel:btnLabel,btnRef:btnRef,btnClassName:btnClassName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"leaderboardBtn button",ref:"leaderboardBtn",onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();},onClick:function onClick(){return _this4.props.handleLeaderboardBtn();}},window.config.buttons.leaderboard.label))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FooterLogo__["a" /* default */],null)),this.renderConfetti());}}]);return BonusResultsOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{userLoggedIn:state.userLoggedIn,isAppIframed:state.isAppIframed,maxScore:state.maxScore,user:state.user,affiliate:state.affiliate};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(BonusResultsOverlay));

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scss_App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Confetti=function(_Component){_inherits(Confetti,_Component);function Confetti(props){_classCallCheck(this,Confetti);var _this=_possibleConstructorReturn(this,(Confetti.__proto__||Object.getPrototypeOf(Confetti)).call(this,props));_this.state={hasMounted:false};return _this;}_createClass(Confetti,[{key:'componentDidMount',value:function componentDidMount(){/*
		SetGlobals();
        InitializeButton();
        InitializeConfetti();

        $(window).resize(function () {
            W = window.innerWidth;
            H = window.innerHeight;
            canvas.width = W;
            canvas.height = H;
        });
        */this.setState({hasMounted:true});SetGlobals();InitializeConfetti();window.$(window).resize(function(){W=window.innerWidth;H=window.innerHeight;canvas.width=W;canvas.height=H;});}},{key:'componentWillUpdate',value:function componentWillUpdate(){if(this.state.hasMounted){return false;}else{return true;}}},{key:'componentWillUnmount',value:function componentWillUnmount(){console.log("Confetti :: componentWillUnmount");StopConfetti();}},{key:'render',value:function render(){//console.log("Confetti :: render");
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'confetti'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{id:'confetti-canvas',className:'confetti'}));}}]);return Confetti;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Confetti);//===============================================
// globals
var canvas;var ctx;var W;var H;var mp=150;//max particles
var particles=[];var angle=0;var tiltAngle=0;var confettiActive=true;var animationComplete=true;var deactivationTimerHandler;var reactivationTimerHandler;var animationHandler;// objects
var particleColors={colorOptions:["Red","White","Blue"],colorIndex:0,colorIncrementer:0,colorThreshold:10,getColor:function getColor(){if(this.colorIncrementer>=10){this.colorIncrementer=0;this.colorIndex++;if(this.colorIndex>=this.colorOptions.length){this.colorIndex=0;}}this.colorIncrementer++;return this.colorOptions[this.colorIndex];}};function confettiParticle(color){//console.log("Confetti :: color - ", color);
this.x=Math.random()*W;// x-coordinate
this.y=Math.random()*H-H;//y-coordinate
this.r=RandomFromTo(10,30);//radius;
this.d=Math.random()*mp+10;//density;
this.color=color;this.tilt=Math.floor(Math.random()*10)-10;this.tiltAngleIncremental=Math.random()*0.07+.05;this.tiltAngle=0;this.draw=function(){ctx.beginPath();ctx.lineWidth=this.r/2;ctx.strokeStyle=this.color;ctx.moveTo(this.x+this.tilt+this.r/4,this.y);ctx.lineTo(this.x+this.tilt,this.y+this.tilt+this.r/4);return ctx.stroke();};}/*
$(document).ready(function () {
    

});
*/function SetGlobals(){canvas=document.getElementById("confetti-canvas");ctx=canvas.getContext("2d");W=window.innerWidth;H=window.innerHeight;canvas.width=W;canvas.height=H;}function InitializeConfetti(){particles=[];animationComplete=false;for(var i=0;i<mp;i++){var particleColor=particleColors.getColor();particles.push(new confettiParticle(particleColor));}StartConfetti();}function Draw(){ctx.clearRect(0,0,W,H);var results=[];for(var i=0;i<mp;i++){(function(j){results.push(particles[j].draw());})(i);}Update();return results;}function RandomFromTo(from,to){return Math.floor(Math.random()*(to-from+1)+from);}function Update(){var remainingFlakes=0;var particle;angle+=0.01;tiltAngle+=0.1;for(var i=0;i<mp;i++){particle=particles[i];if(animationComplete)return;if(!confettiActive&&particle.y<-15){particle.y=H+100;continue;}stepParticle(particle,i);if(particle.y<=H){remainingFlakes++;}CheckForReposition(particle,i);}if(remainingFlakes===0){StopConfetti();}}function CheckForReposition(particle,index){if((particle.x>W+20||particle.x<-20||particle.y>H)&&confettiActive){if(index%5>0||index%2==0)//66.67% of the flakes
{repositionParticle(particle,Math.random()*W,-10,Math.floor(Math.random()*10)-10);}else{if(Math.sin(angle)>0){//Enter from the left
repositionParticle(particle,-5,Math.random()*H,Math.floor(Math.random()*10)-10);}else{//Enter from the right
repositionParticle(particle,W+5,Math.random()*H,Math.floor(Math.random()*10)-10);}}}}function stepParticle(particle,particleIndex){particle.tiltAngle+=particle.tiltAngleIncremental;particle.y+=(Math.cos(angle+particle.d)+3+particle.r/2)/2;particle.x+=Math.sin(angle);particle.tilt=Math.sin(particle.tiltAngle-particleIndex/3)*15;}function repositionParticle(particle,xCoordinate,yCoordinate,tilt){particle.x=xCoordinate;particle.y=yCoordinate;particle.tilt=tilt;}function StartConfetti(){W=window.innerWidth;H=window.innerHeight;canvas.width=W;canvas.height=H;(function animloop(){//console.log("Confetti :: animLoop");
if(animationComplete)return null;animationHandler=window.requestAnimFrame(animloop);return Draw();})();}function ClearTimers(){clearTimeout(reactivationTimerHandler);clearTimeout(animationHandler);}function DeactivateConfetti(){confettiActive=false;ClearTimers();}function StopConfetti(){console.log("Confetti :: StopConfetti()");animationComplete=true;if(ctx==undefined)return;ctx.clearRect(0,0,W,H);}function RestartConfetti(){ClearTimers();StopConfetti();reactivationTimerHandler=setTimeout(function(){confettiActive=true;animationComplete=false;InitializeConfetti();},100);}window.requestAnimFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(callback){return window.setTimeout(callback,1000/60);};}();

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_App_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BeforeResultsOverlay=function(_Component){_inherits(BeforeResultsOverlay,_Component);function BeforeResultsOverlay(props){_classCallCheck(this,BeforeResultsOverlay);var _this2=_possibleConstructorReturn(this,(BeforeResultsOverlay.__proto__||Object.getPrototypeOf(BeforeResultsOverlay)).call(this,props));_this2.transitionIn=new window.TimelineMax({onComplete:_this2.handleTransitionComplete,onCompleteParams:[_this2],onReverseComplete:_this2.handleTransitionOutComplete,onReverseCompleteParams:[_this2]});return _this2;}_createClass(BeforeResultsOverlay,[{key:'componentDidMount',value:function componentDidMount(){// stop all bg
window.sounds.introBg.stop();window.sounds.roundBg.stop();window.sounds.bonusBg.stop();window.sounds.gameOverBg.stop();// play bg music
window.sounds.gameOverBg.play();window.sounds.gameOverBg.volume(.3);window.TweenMax.set(this.refs.overlay,{"opacity":0});window.TweenMax.set(this.refs.line1,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.line2,{"opacity":0,"transform":"translateY(1vw)"});window.TweenMax.set(this.refs.playBtn,{"opacity":0,"transform":"translateY(1vw)"});this.transitionIn.to(this.refs.overlay,.5,{"opacity":1,"delay":.3}).to(this.refs.line1,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.line2,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3").to(this.refs.playBtn,.4,{"opacity":1,"transform":"translateY(0vw)"},"-=.3");}},{key:'handleTransitionComplete',value:function handleTransitionComplete(_this){}},{key:'handleTransitionOutComplete',value:function handleTransitionOutComplete(_this){//_this.props.handleNextRound();
}},{key:'handlePlayBtnClick',value:function handlePlayBtnClick(){//this.transitionIn.reverse();
}},{key:'render',value:function render(){var _this3=this;// determine round message
var totalRounds=window.config.rounds.length;var roundMsg="ROUND COMPLETE";if(totalRounds>1){roundMsg="ROUND "+this.props.round+" OF "+totalRounds+" COMPLETE";}// determine play button label
var playBtnLabel="CONTINUE";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'results_overlay',ref:'overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',ref:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'roundMsg',ref:'line1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scoreMsg',ref:'line2'},'Watch this brief ad to continue.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nextBtn',ref:'playBtn',onClick:function onClick(){return _this3.props.handleNextRound();},onMouseOver:function onMouseOver(){return window.sounds.buttonHover.play();}},playBtnLabel)));}}]);return BeforeResultsOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BeforeResultsOverlay);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RANDOM_END_RESULT_VIDEOS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_analytics__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IronSource__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VideoOverlay__ = __webpack_require__(137);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NAMESPACE='[ RewardAdContainer ]';var RANDOM_END_RESULT_VIDEOS=1;var RewardAdContainer=function(_Component){_inherits(RewardAdContainer,_Component);function RewardAdContainer(){_classCallCheck(this,RewardAdContainer);return _possibleConstructorReturn(this,(RewardAdContainer.__proto__||Object.getPrototypeOf(RewardAdContainer)).apply(this,arguments));}_createClass(RewardAdContainer,[{key:'componentWillMount',value:function componentWillMount(){// tracking
var trackingTag='ASgame-2nd-replay-gate-ad';if(this.props.showVideoAd===__WEBPACK_IMPORTED_MODULE_2__utils_constants__["b" /* AD_MORE_TIME_CLICKED */]){trackingTag='ASgame-more-time-ad';}if(this.props.showVideoAd===__WEBPACK_IMPORTED_MODULE_2__utils_constants__["a" /* AD_FINAL_RESULTS */]){trackingTag='ASgame-final-results-ad';}Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["a" /* trackingWrapper */])('event',trackingTag,{'event_category':'america-says-game'});}},{key:'render',value:function render(){if(this.props.rewardVideo.ready&&this.props.rewardVideo.support===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__IronSource__["a" /* default */],{showVideoAd:this.props.showVideoAd,handleVideoOverlayClose:this.props.handleVideoOverlayClose,videoAdType:this.props.trackingType});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__VideoOverlay__["a" /* default */],{showVideoAd:this.props.showVideoAd,handleVideoOverlayClose:this.props.handleVideoOverlayClose,videoAdType:this.props.trackingType});}}]);return RewardAdContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{rewardVideo:state.rewardVideo};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(RewardAdContainer));

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RANDOM_END_RESULT_VIDEOS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_analytics__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_rewardVideo__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NAMESPACE='[ IronSource ]';var RANDOM_END_RESULT_VIDEOS=1;var IronSource=function(_Component){_inherits(IronSource,_Component);function IronSource(){_classCallCheck(this,IronSource);return _possibleConstructorReturn(this,(IronSource.__proto__||Object.getPrototypeOf(IronSource)).apply(this,arguments));}_createClass(IronSource,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.rewardVideo.ironRV!==null){this.props.rewardVideoOpen({name:window.IronRV.EVENTS.OPEN});this.props.rewardVideo.ironRV.show();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){//close ironsource modal
console.log('<IronSource />',this.props.rewardVideo,prevProps);//ironsourse modal close
if(!this.props.rewardVideo.open&&prevProps.rewardVideo.open){this.props.handleVideoOverlayClose(this.props.rewardVideo.complete);if(!this.props.rewardVideo.complete&&this.props.videoAdType!==null){// tracking
Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-skip-ad',{'event_category':'america-says-game'});}}if(this.props.rewardVideo.complete&&!prevProps.rewardVideo.complete){this.props.rewardVideo.ironRV.hide();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return IronSource;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{userLoggedIn:state.userLoggedIn,user:state.user,playCount:state.playCount,rewardVideo:state.rewardVideo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{rewardVideoOpen:function rewardVideoOpen(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_rewardVideo__["j" /* rewardVideoOpen */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(IronSource));

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RANDOM_END_RESULT_VIDEOS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_analytics__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NAMESPACE='[ VideoOverlay ]';var RANDOM_END_RESULT_VIDEOS=1;var VideoOverlay=function(_Component){_inherits(VideoOverlay,_Component);function VideoOverlay(props){_classCallCheck(this,VideoOverlay);var _this=_possibleConstructorReturn(this,(VideoOverlay.__proto__||Object.getPrototypeOf(VideoOverlay)).call(this,props));_this.skipBtnAfterSecs=window.config.videoAd.skipBtnAppearsAfterSecs;_this.skipAdCountdownLabel=window.config.videoAd.skipAdCountdownLabel;_this.timer=null;_this.state={videoId:props.videoId||null,timerRemaining:_this.skipBtnAfterSecs// Tracking flags
};_this.tracked10Played=false;// this.tracked25Played = false;
_this.tracked50Played=false;// this.tracked75Played = false;
_this.tracked90Played=false;// this.trackedPlayed = false;
_this.handleMediaStartedRef=_this.handleMediaStarted.bind(_this);_this.handleMediaPlayingRef=_this.handleMediaPlaying.bind(_this);_this.handleMediaEndedRef=_this.handleMediaEnded.bind(_this);_this.handleIFrameLoaded=_this.handleIFrameLoaded.bind(_this);_this.handleCloseBtnClick=_this.handleCloseBtnClick.bind(_this);_this.timerTick=_this.timerTick.bind(_this);return _this;}_createClass(VideoOverlay,[{key:'componentWillMount',value:function componentWillMount(){if(this.state.videoId===null){this.setRandomVideo();}else{this.setVideo(this.state.videoId);}// tracking
var trackingTag='ASgame-2nd-replay-gate-ad';if(this.props.showVideoAd===__WEBPACK_IMPORTED_MODULE_2__utils_constants__["b" /* AD_MORE_TIME_CLICKED */]){trackingTag='ASgame-more-time-ad';}Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["a" /* trackingWrapper */])('event',trackingTag,{'event_category':'america-says-game'});}},{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.closeBtn,{"display":"none","opacity":0});window.TweenMax.set(this.refs.skipCountdown,{"opacity":0});this.timer=setInterval(this.timerTick,1000);// begin fade in of countdown
window.TweenMax.to(this.refs.skipCountdown,this.skipBtnAfterSecs+2,{"opacity":1});}},{key:'timerTick',value:function timerTick(){var newTime=this.state.timerRemaining-1;if(newTime<1){clearInterval(this.timer);// hide countdown, show close button
window.TweenMax.set(this.refs.skipCountdown,{"display":"none"});window.TweenMax.set(this.refs.closeBtn,{"display":"block"});window.TweenMax.to(this.refs.closeBtn,.4,{"opacity":1});}else{// update timer
this.setState({timerRemaining:newTime});}}},{key:'setRandomVideo',value:function setRandomVideo(){//console.log("================ VideoOverlay :: setRandomVideo() - start pool:", window.videoAdsPool);
// get random from pool
var video=window.videoAdsPool[Math.floor(Math.random()*window.videoAdsPool.length)];// remove chosen from pool
var newVideoAdsPool=[].concat(_toConsumableArray(window.videoAdsPool.filter(function(x){return x!==video;})));// if pool is empty, reset the pool with full list minus selected
if(newVideoAdsPool.length===0){window.videoAdsPool=[].concat(_toConsumableArray(window.config.videoAd.videos));// if total pool size is > 1, remove the selected so it does show back to back on next cycle
if(window.config.videoAd.videos.length>1){window.videoAdsPool=[].concat(_toConsumableArray(window.videoAdsPool.filter(function(x){return x!==video;})));}}else{window.videoAdsPool=[].concat(_toConsumableArray(newVideoAdsPool));}//console.log("VideoOverlay :: setRandomVideo() -  selected video: ", video);
//console.log("VideoOverlay :: setRandomVideo() -  end pool: ", window.videoAdsPool);
this.setVideo(video);}},{key:'setVideo',value:function setVideo(id){this.setState({videoId:id});}},{key:'handleIFrameLoaded',value:function handleIFrameLoaded(){console.log(NAMESPACE,'handleIFrameLoaded()');window.$pdk.bind(this,true);window.$pdk.controller.setIFrame(this.refs.iframe,true);window.$pdk.controller.addEventListener('OnMediaStart',this.handleMediaStartedRef);window.$pdk.controller.addEventListener('OnMediaPlaying',this.handleMediaPlayingRef);window.$pdk.controller.addEventListener('OnMediaEnd',this.handleMediaEndedRef);}},{key:'handleMediaStarted',value:function handleMediaStarted(){console.log(NAMESPACE,'handleMediaStarted()');}},{key:'handleMediaPlaying',value:function handleMediaPlaying(event){// console.log( NAMESPACE, 'media playing ', 'time: '+event.data.currentTime, ' duration: '+event.data.duration );
var percentage=event.data.currentTime/event.data.duration;if(percentage>0.9&&!this.tracked90Played){// console.log( NAMESPACE, 'track 90% played' );
// trackingWrapper('event', 'ASgame-ad-play-90%', {'event_category':'america-says-game'});
this.tracked90Played=true;}else if(percentage>0.5&&!this.tracked50Played){// console.log( NAMESPACE, 'track 50% played' );
// trackingWrapper('event', 'ASgame-ad-play-50%', {'event_category':'america-says-game'});
this.tracked50Played=true;}else if(percentage>0.1&&!this.tracked10Played){// console.log( NAMESPACE, 'track 10% played' );
// trackingWrapper('event', 'ASgame-ad-play-10%', {'event_category':'america-says-game'});
this.tracked10Played=true;}}},{key:'handleMediaEnded',value:function handleMediaEnded(){console.log(NAMESPACE,'handleMediaEnded()');this.closeOverlay();}},{key:'handleCloseBtnClick',value:function handleCloseBtnClick(){// tracking
Object(__WEBPACK_IMPORTED_MODULE_3__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-skip-ad',{'event_category':'america-says-game'});this.closeOverlay();}},{key:'closeOverlay',value:function closeOverlay(){this.props.handleVideoOverlayClose();}},{key:'componentWillUnmount',value:function componentWillUnmount(){console.log(NAMESPACE,'componentWillUnmount()');window.$pdk.controller.removeEventListener('OnMediaStart',this.handleMediaStartedRef);window.$pdk.controller.removeEventListener('OnMediaPlaying',this.handleMediaPlayingRef);window.$pdk.controller.removeEventListener('OnMediaEnd',this.handleMediaEndedRef);window.$pdk.controller.resetPlayer();}},{key:'render',value:function render(){var _this2=this;var iframeUrl="https://player.theplatform.com/p/"+window.config.mpx.clientId+"/"+window.config.mpx.playerId+"/embed/select/media/"+this.state.videoId+"?form=html&autoPlay=true";// countdown
var countDownText=""+this.skipAdCountdownLabel+" "+this.state.timerRemaining;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'videoOverlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},'America Says Game Will Resume After This Video'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-player'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{ref:'iframe',src:iframeUrl,width:'100%',height:'100%',scrolling:'no',frameBorder:'0',seamless:'seamless',title:'MPX Player',allowFullScreen:true,onLoad:this.handleIFrameLoaded})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'skipCountdown',ref:'skipCountdown'},countDownText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'closeBtn',ref:'closeBtn',onClick:function onClick(){return _this2.handleCloseBtnClick();}},'x'));}}]);return VideoOverlay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VideoOverlay);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ironsource_IronSourceInitializer__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_rewardVideo__ = __webpack_require__(13);
var mapStateToProps=function mapStateToProps(state){return{rewardVideo:state.rewardVideo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{rewardVideoReady:function rewardVideoReady(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_rewardVideo__["k" /* rewardVideoReady */])(data));},setIronRV:function setIronRV(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_rewardVideo__["l" /* setIronRV */])(data));},rewardVideoOpen:function rewardVideoOpen(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_rewardVideo__["j" /* rewardVideoOpen */])(data));},rewardVideoComplete:function rewardVideoComplete(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_rewardVideo__["i" /* rewardVideoComplete */])(data));},rewardVideoAdBlocked:function rewardVideoAdBlocked(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_rewardVideo__["h" /* rewardVideoAdBlocked */])(data));},setRewardVideoSupport:function setRewardVideoSupport(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_rewardVideo__["m" /* setRewardVideoSupport */])(data));},updateRewardVideoStale:function updateRewardVideoStale(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_rewardVideo__["n" /* updateRewardVideoStale */])(data));}};};var IronSourceInitializerContainer=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_ironsource_IronSourceInitializer__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (IronSourceInitializerContainer);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ironsource__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IronSourceInitializer=function(_Component){_inherits(IronSourceInitializer,_Component);function IronSourceInitializer(props){_classCallCheck(this,IronSourceInitializer);var _this=_possibleConstructorReturn(this,(IronSourceInitializer.__proto__||Object.getPrototypeOf(IronSourceInitializer)).call(this,props));_this.state={ironSourceStaleVideo:false};_this.staleVideoTimer=null;return _this;}_createClass(IronSourceInitializer,[{key:"setIronSourceStaleTimer",value:function setIronSourceStaleTimer(delay){var self=this;console.log('Ironsource: timer',delay);window.clearTimeout(self.staleVideoTimer);self.staleVideoTimer=window.setTimeout(function(){console.log('Ironsource: triggered timer',delay);self.setState({ironSourceStaleVideo:true});// self.props.rewardVideo.updateRewardVideoStale(true);
},delay);}},{key:"initIronSource",value:function initIronSource(){var IronRV=window.IronRV;var ironrv=Object(__WEBPACK_IMPORTED_MODULE_2__utils_ironsource__["c" /* initIronSource */])([{name:IronRV.EVENTS.AD_BLOCK,callback:this.props.rewardVideoAdBlocked},{name:IronRV.EVENTS.NO_CAMPAIGNS,callback:this.props.rewardVideoReady},{name:IronRV.EVENTS.READY,callback:this.props.rewardVideoReady},{name:IronRV.EVENTS.RESIZE,callback:null},{name:IronRV.EVENTS.OPEN,callback:this.props.rewardVideoOpen},{name:IronRV.EVENTS.CLOSE,callback:this.props.rewardVideoOpen},{name:IronRV.EVENTS.COMPLETION,callback:this.props.rewardVideoComplete}]);this.setState({ironSourceStaleVideo:false});this.props.setRewardVideoSupport();this.props.setIronRV(ironrv);}},{key:"componentDidMount",value:function componentDidMount(){this.initIronSource();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){console.log('[IronSourceInitializer] ironsource: ',prevProps,this.props,prevState,this.state);var inventoryDoesNotExist=this.props.rewardVideo.ready!==prevProps.rewardVideo.ready&&this.props.rewardVideo.ready===false;var inventoryStale=this.state.ironSourceStaleVideo!==prevState.ironSourceStaleVideo&&this.state.ironSourceStaleVideo===true;var inventoryExist=this.props.rewardVideo.ready!==prevProps.rewardVideo.ready&&this.props.rewardVideo.ready===true;if(this.props.rewardVideo.adBlocked){Object(__WEBPACK_IMPORTED_MODULE_2__utils_ironsource__["b" /* adBlockerPopup */])(this.props.rewardVideo.ironRV);}if(inventoryDoesNotExist){this.props.rewardVideoReady(null);//reset to default
this.setIronSourceStaleTimer(30*1000);}if(inventoryExist){this.setIronSourceStaleTimer(15*60*1000);}if(inventoryStale){this.initIronSource();}}},{key:"render",value:function render(){return null;}}]);return IronSourceInitializer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Btn.propTypes = {
//   onClick: PropTypes.func.isRequired,
//   btnRef: PropTypes.object,
//   btnClassName: PropTypes.string,
//   label: PropTypes.string
// };
/* harmony default export */ __webpack_exports__["a"] = (IronSourceInitializer);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scss_App_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__scss_App_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_analytics__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NAMESPACE='[ LandingVideo ]';var LandingVideo=function(_Component){_inherits(LandingVideo,_Component);function LandingVideo(props){_classCallCheck(this,LandingVideo);var _this2=_possibleConstructorReturn(this,(LandingVideo.__proto__||Object.getPrototypeOf(LandingVideo)).call(this,props));_this2.transitionIn=new window.TimelineMax();_this2.playBtnAnimation=new window.TimelineMax();_this2.state={videoId:null,showVideo:false// Tracking flags
};_this2.tracked10Played=false;// this.tracked25Played = false;
_this2.tracked50Played=false;// this.tracked75Played = false;
_this2.tracked90Played=false;// this.trackedPlayed = false;
_this2.handleMediaStartedRef=_this2.handleMediaStarted.bind(_this2);_this2.handleMediaPlayingRef=_this2.handleMediaPlaying.bind(_this2);_this2.handleMediaEndedRef=_this2.handleMediaEnded.bind(_this2);_this2.handleIFrameLoaded=_this2.handleIFrameLoaded.bind(_this2);_this2.handlePlayBtnClick=_this2.handlePlayBtnClick.bind(_this2);_this2.handleMouseOver=_this2.handleMouseOver.bind(_this2);_this2.handleMouseOut=_this2.handleMouseOut.bind(_this2);return _this2;}_createClass(LandingVideo,[{key:'componentWillMount',value:function componentWillMount(){this.setRandomVideo();}},{key:'componentDidMount',value:function componentDidMount(){window.TweenMax.set(this.refs.wipe,{"width":"100%"});this.transitionIn.to(this.refs.wipe,.4,{"width":"0%"});//
this.playBtnAnimation.to(this.refs.playArrow,.1,{"transform":"translateX(150%)"}).set(this.refs.playArrow,{"transform":"translateX(-150%)"}).to(this.refs.playArrow,.1,{"transform":"translateX(0%)"});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.landingTransitionOut===true&&prevProps.landingTransitionOut===false){this.transitionIn.reverse();}}},{key:'setRandomVideo',value:function setRandomVideo(){//console.log("================ VideoOverlay :: setRandomVideo() - start pool:", window.videoAdsPool);
// get random from pool
var video=window.videoAdsPool[Math.floor(Math.random()*window.videoAdsPool.length)];// remove chosen from pool
var newVideoAdsPool=[].concat(_toConsumableArray(window.videoAdsPool.filter(function(x){return x!==video;})));// if pool is empty, reset the pool with full list minus selected
if(newVideoAdsPool.length===0){window.videoAdsPool=[].concat(_toConsumableArray(window.config.videoAd.videos));// if total pool size is > 1, remove the selected so it does show back to back on next cycle
if(window.config.videoAd.videos.length>1){window.videoAdsPool=[].concat(_toConsumableArray(window.videoAdsPool.filter(function(x){return x!==video;})));}}else{window.videoAdsPool=[].concat(_toConsumableArray(newVideoAdsPool));}//console.log("VideoOverlay :: setRandomVideo() -  selected video: ", video);
//console.log("VideoOverlay :: setRandomVideo() -  end pool: ", window.videoAdsPool);
this.setState({videoId:video});}},{key:'handleIFrameLoaded',value:function handleIFrameLoaded(){console.log(NAMESPACE,'handleIFrameLoaded()');window.$pdk.bind(this,true);window.$pdk.controller.setIFrame(this.refs.iframe,true);window.$pdk.controller.addEventListener('OnMediaStart',this.handleMediaStartedRef);window.$pdk.controller.addEventListener('OnMediaPlaying',this.handleMediaPlayingRef);window.$pdk.controller.addEventListener('OnMediaEnd',this.handleMediaEndedRef);}},{key:'handleMediaStarted',value:function handleMediaStarted(){console.log(NAMESPACE,'handleMediaStarted()');}},{key:'handleMediaPlaying',value:function handleMediaPlaying(event){// console.log( NAMESPACE, 'media playing ', 'time: '+event.data.currentTime, ' duration: '+event.data.duration );
var percentage=event.data.currentTime/event.data.duration;if(percentage>0.9&&!this.tracked90Played){console.log(NAMESPACE,'track 90% played');Object(__WEBPACK_IMPORTED_MODULE_2__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-landing-video-play-90%',{'event_category':'america-says-game'});this.tracked90Played=true;}// else if( percentage > 0.75 && !this.tracked75Played ) {
// 	console.log( NAMESPACE, 'track 75% played' );
// 	Krux('ns:gsn','admEvent', kruxEvents.media75Played, {});
// 	this.tracked75Played = true;
// } 
else if(percentage>0.5&&!this.tracked50Played){console.log(NAMESPACE,'track 50% played');Object(__WEBPACK_IMPORTED_MODULE_2__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-landing-video-play-50%',{'event_category':'america-says-game'});this.tracked50Played=true;}// else if( percentage > 0.25 && !this.tracked25Played ) {
// 	console.log( NAMESPACE, 'track 25% played' );
// 	Krux('ns:gsn','admEvent', kruxEvents.media25Played, {});
// 	this.tracked25Played = true;
// } 
else if(percentage>0.1&&!this.tracked10Played){console.log(NAMESPACE,'track 10% played');Object(__WEBPACK_IMPORTED_MODULE_2__utils_analytics__["a" /* trackingWrapper */])('event','ASgame-landing-video-play-10%',{'event_category':'america-says-game'});this.tracked10Played=true;}}},{key:'handleMediaEnded',value:function handleMediaEnded(){console.log(NAMESPACE,'handleMediaEnded()');this.setState({showVideo:false});// turn on bg music
window.sounds.introBg.play();}},{key:'componentWillUnmount',value:function componentWillUnmount(){console.log(NAMESPACE,'componentWillUnmount()');window.$pdk.controller.removeEventListener('OnMediaStart',this.handleMediaStartedRef);window.$pdk.controller.removeEventListener('OnMediaPlaying',this.handleMediaPlayingRef);window.$pdk.controller.removeEventListener('OnMediaEnd',this.handleMediaEndedRef);window.$pdk.controller.resetPlayer();}},{key:'handlePlayBtnClick',value:function handlePlayBtnClick(){this.setState({showVideo:true});// turn off bg music
window.sounds.introBg.stop();}},{key:'handleMouseOver',value:function handleMouseOver(){this.playBtnAnimation.play();}},{key:'handleMouseOut',value:function handleMouseOut(){this.playBtnAnimation.reverse();}},{key:'renderVideo',value:function renderVideo(){var _this=this;if(this.state.showVideo){var iframeUrl="https://player.theplatform.com/p/"+window.config.mpx.clientId+"/"+window.config.mpx.playerId+"/embed/select/media/"+this.state.videoId+"?form=html&autoPlay=true";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-player'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{ref:'iframe',src:iframeUrl,width:'100%',height:'100%',scrolling:'no',frameBorder:'0',seamless:'seamless',title:'MPX Player',allowFullScreen:true,onLoad:this.handleIFrameLoaded}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'poster',onClick:function onClick(){return _this.handlePlayBtnClick();},onMouseOver:function onMouseOver(){return _this.handleMouseOver();},onMouseOut:function onMouseOut(){return _this.handleMouseOut();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'playBtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'playArrow',ref:'playArrow'})));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'landingVideo'},this.renderVideo(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wipe',ref:'wipe'}));}}]);return LandingVideo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LandingVideo);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL(".",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="."+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.36d2d831.js